import React, { Component, createRef } from 'react';
import { ToastContainer } from "react-toastify";
import Loader from "../../../utils/Loader";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../utils/withRouter";
import { getDetails_spaceBooking_action, edit_spaceBoking_action, updateSpacebookingEstimate_action } from "../../../actions/exhibitor_module_actions/space_booking_action/spaceBooking_action"
import { connect } from "react-redux";
import { data } from "jquery";
import { axiosGet, axiosPost } from "../../../react_axios/Axios"
import {
    cityActionId, countryActionId, pincodeActionId, stateActionId, toastError, toastSuccess, BASE_URL, link_BASE_URL, internationalAreaSlabActionId, stallTypeActionId, opensSidesListActionId, stallSizeActionId, primaryChapterListActionId, lengthActionId, breadthActionId, openSideListActionId, downloadReport, fetchAuthReport, GSTvalidationActionId, fullStallAreaActionId, BarActionId,
    CFMActionId, IntAreaRules
} from "../../../utils/constants";
import {
    primaryChapterAdd_action, getPreviewDetails_action, getDoubleStoreySSI_action, deleteSSicertificate_action, deleteTMMAITAMMA_action
} from '../../../actions/primary_chapter_action'
import { fill_action } from "../../../actions/fillCombo_action"
import { gstNoValidator, panNoValidator, tanNoValidator, emailValidator } from "../../../utils/Validator";
import Modal from "react-modal";
import Resizer from "react-image-file-resizer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import { getDetails_exhibitorSpaceBooking_action, edit_exhibitorSpaceBoking_action, updateExhibitorSpacebookingEstimate_action } from "../../../actions/admin_module_action/exhibitor_spacebooking_action/exhibitor_spacebooking_action";
import moment from "moment";
import {
    deleteChapterDoc_action
} from '../../../actions/primary_chapter_action'
import "pdfjs-dist/build/pdf.worker.entry";
// import { BASE_URL } from "../../utils/constants";
import * as pdfjsLib from "pdfjs-dist";
class ExhibitorsSpacebooking extends Component {

    // Initialize Constructor
    constructor(props) {
        super(props)
        //States    
        this.state = {
            isLoading: false,
            isAgree: false,
            isAgree2: false,
            isAgree3: false,
            isDisplayPincodeList: false,
            isDisplayCityList: false,
            isDisplayStateList: false,
            isDisplayCountryList: false,
            isDisplayBillPincodeList: false,
            isDisplayBillCityList: false,
            isDisplayBillStateList: false,
            isDisplayBillCountryList: false,
            isOtherPreFixPersonInch: false,
            isOtherOwnerFirstName: false,
            isOtherBillPersonInchFirst: false,
            primaryChapterName: "",
            exbRegNo: "",
            isCorrespondence: false,
            primaryChapterId: "",
            isPreviousOrSameDate: false,
            isOpen: false,
            countryId: '',
            namePrefix: ['Mr', 'Ms', 'DR', 'Prof'],
            comment: '',
            // Registration Details Fields
            preFixPersonInch: "Mr",
            otherPersonInchFirst: "",
            personInchFirst: "",
            personInchLast: "",
            regDesignation: "",
            regCompany: "",
            fasciaName: "",
            regAdd1: "",
            regAdd2: "",
            regPin: "",
            regCity: "",
            regState: "",
            regCountryId: "",
            regCountry: "",
            preRegMob1: "",
            regMob1: "",
            preRegMob2: "",
            regMob2: "",
            preRegTel: "",
            regTel: "",
            preRegTel1: "",
            regTel1: "",
            regTelFax: "",
            regPrimaryEmail: "",
            regSecondaryEmail: "",
            regWeb: "",
            otherOwnerFirstName: "",
            preOwnerNameFirst: "",
            ownerNameFirst: "",
            ownerNameLast: "",
            ownerDesignation: '',
            preOwnerMob: "",
            ownerMob: "",
            ownerEmail: "",
            oldsubChapters: [],

            // Bill Details field
            preFixBillPersonInch: "",
            otherBillPersonInchFirst: "",
            billPersonInchFirst: "",
            billPersonInchLast: "",
            billDesignation: "",
            billCompany: "",
            billAdd1: "",
            billAdd2: "",
            billPin: "",
            billCity: "",
            billState: "",
            billCountry: "",
            billCountryId: "",
            preBillMob1: "",
            billMob1: "",
            preBillMob2: "",
            billMob2: "",
            preBillTel: "",
            billTel: "",
            preBillTel1: "",
            billTel1: "",
            billTelFax: "",
            billPrimaryEmail: "",
            billSecondaryEmail: "",
            billWeb: "",
            isDel3Open: false,
            delChapterID: '',
            ///lists
            countryList: [],
            tempCountryList: [],
            billTempCountryList: [],
            stateList: [],
            tempStateList: [],
            billTempStateList: [],
            cityList: [],
            tempCityList: [],
            billTempCityList: [],
            pincodeList: [],
            tempPincodeList: [],
            billTempPincodeList: [],
            primaryChapterHeaderList: [],
            subChapters: [],
            estimateDetails: [],
            lev2: [],
            lev3: [],
            lev4: [],
            checkboxList: [],
            undertakingContent: [],
            gstValidtionList: [],
            stateId: '',

            // Company Credentials Fields
            companyRegNo: "",
            panNo: "",
            panName: "",
            gstNo: "",
            status: "",
            tanNo: "",
            uanNo: "",
            iecCode: "",
            accName: "",
            accNo: "",
            accType: "",
            accTypeOthers: "",
            bankName: "",
            branchName: "",
            ifsc: "",
            SSIMaxArea: '',
            StallTypeName: '',
            SSIdiscount: '',

            // Validation Error Messages
            personInchFirstErr: "",
            personInchLastErr: "",
            regDesignationErr: "",
            regCompanyErr: "",
            fasciaNameErr: "",
            regAdd1Err: "",
            regPinErr: "",
            regCityErr: "",
            regStateErr: "",
            regCountryErr: "",
            regMob1Err: "",
            regPrimaryEmailErr: "",
            ownerNameFirstErr: "",
            ownerDesignationErr: '',
            ownerEmailErr: "",
            billPersonInchFirstErr: "",
            billPersonInchLastErr: "",
            billDesignationErr: "",
            billCompanyErr: "",
            billAdd1Err: "",
            billPinErr: "",
            billCityErr: "",
            billStateErr: "",
            billCountryErr: "",
            billMob1Err: "",
            billPrimaryEmailErr: "",
            panNoErr: "",
            panNameErr: "",
            gstNoErr: "",
            statusErr: "",
            tanNoErr: "",
            uanNoErr: "",
            accNameErr: "",
            accNoErr: "",
            ifscErr: "",
            exbTableErr: "",

            exhRegistrationNo: '',
            area: '',
            minAreaPercent: '',
            minArea: '',
            doubleStoreyArea: '',
            doubleStoreyAreaErr: '',
            isDoubleStorey: false,
            isSSi: false,
            isSSifile: '',
            isSSifileErr: '',
            isSSifileType: '',
            isSSifilePath: '',
            isSSifileReplacement: '',
            isSSifileTypeReplacement: '',
            isSSifilePathReplacement: '',
            TMMAITAMMA: '',
            TMMAITAMMAfile: '',
            TMMAITAMMAfileErr: '',
            TMMAITAMMAfileType: '',
            TMMAITAMMAfilePath: '',
            TMMAITAMMAfileReplacement: '',
            TMMAITAMMAfileTypeReplacement: '',
            TMMAITAMMAfilePathReplacement: '',
            AuthorizedPersonName: '',
            DesignationAuthorizedPerson: '',
            ExhibitorCompanyName: '',
            EmailAuthorizedPerson: '',
            MobileAuthorizedPerson: '',
            PreMobileAuthorizedPerson: '',
            AuthorizedPersonNameErr: '',
            DesignationAuthorizedPersonErr: '',
            ExhibitorCompanyNameErr: '',
            EmailAuthorizedPersonErr: '',
            MobileAuthorizedPersonErr: '',

            isDoubleStoreyExhibition: false,
            isSSIExhibition: false,
            isSSIdeleted: true,
            isTMMAITAMMAdeleted: true,
            isDel1Open: false,
            isDel2Open: false,

            isSSIreplaced: true,
            isTAMMAITAMMAreplaced: true,
            isLoad1stTime: true,
            ExhPrimaryChapterComment: '',
            ExhPrimaryChapterCommentErr: '',
            isShowExhPrimaryChapterComment: false,
            dueDate: '',

            lengthWidthErr: '',
            // subChapters: '',
            InternationalArea: '',
            exhibitDetailsTableErr: '',
            InternationalAreaErr: '',

            minShellArea: [],
            MinBareArea: [],

            manufactureCountryIndex: '',
            lengthList: [],
            breadthList: [],
            isShowInternationalArea: false,

            stallTypeIdList: [],
            stallTypeId: '',
            stallTypeIdErr: '',
            stallArea: '',
            stallAreaList: [],
            url: '',
            OpenSidePath: '',
            stallAreaErr: '',
            openSlidesErr: '',
            openSlides: '',
            openSideList: [],

            oldstallTypeId: '',
            oldstallArea: '',
            oldopenSlides: '',
            oldInternationalArea: '',
            olddoubleStoreyArea: '',
            oldisDoubleStorey: false,
            oldisSSI: false,
            estimatePop: false,
            newestimateDetails: [],
            isUpdatePerm: false,
            slabpop: false,

            compareObjArr: [],
            // DueDate: '',
            internationalAreaSlabList: [],

            minAreafor4OpenSide: 300,
            ExhibitDetailsNote: [],

            is1stPiCreated: false,
            is2ndPiCreated: false,
            IS_SSI_Manual_Approved: false,

            toNewPop: false,
            UUID: '',
            newPopCountry: '',
            isMachineMandatory: true,
            isReceiptGenerated: false,

            primaryChapterListData: [],
            selectedPrimaryChapterIdList: [],
            isOpenAgree: false,
            ExhPrimaryChapterComment: '',
            ExhPrimaryChapterCommentErr: '',
            defaultprimaryChapterIdErr: '',
            MultiSelectNotes: [],
            selectedPrimaryChapterId: '',

            ExhPrimaryUndertakingPersonName: '',
            ExhPrimaryUndertakingDesignation: '',
            ExhPrimaryUndertakingCompanyName: '',
            ExhPrimaryUndertakingEmail: '',
            ExhPrimaryUndertakingMobileNo: '',
            PreExhPrimaryUndertakingMobileNo: '',
            isOpen4: false,
            expectedArea: '',
            expectedAreaId: '',
            loginAccesslist: [],
            areaValidationPopFlag: 1,
            intAreaRulesPop: false,

            referenceStallAreaArr: [],
            isAllBro: false,
            isMixRuleAgree: false,
            OpenMixExhibitorRule: false,
            barQuantityList: [],
            CFMQuantityList: [],
            OpensameCountryManuErr: false,
            isView: false,
            adminRemark: '',
            minAreaPop1: false,
            minAreaPop2: false,
            prefferedType: '',
            prefferedPop: false,
            prefferedPopAsk: false,
            IAbare: 0,
            IAshell: 0,
            isOpen10: false,
        }
        this.pdfContainerRef2 = createRef();
        this.editSpaceBooking = this.editSpaceBooking.bind(this)
        this.getSpaceBookingDetails = this.getSpaceBookingDetails.bind(this)
        this.inputValidate = this.inputValidate.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.onPincodeSearch = this.onPincodeSearch.bind(this)
        this.renderPincodeList = this.renderPincodeList.bind(this)
        this.onCitySearch = this.onCitySearch.bind(this)
        this.renderCityList = this.renderCityList.bind(this)
        this.onStateSearch = this.onStateSearch.bind(this)
        this.renderStateList = this.renderStateList.bind(this)
        this.callStateList = this.callStateList.bind(this)
        this.onCountrySearch = this.onCountrySearch.bind(this)
        this.renderCountryList = this.renderCountryList.bind(this)
        this.maxLengthCheck = this.maxLengthCheck.bind(this)
        this.preventMinus = this.preventMinus.bind(this)
        this.onBillPincodeSearch = this.onBillPincodeSearch.bind(this)
        this.renderBillPincodeList = this.renderBillPincodeList.bind(this)
        this.onBillCitySearch = this.onBillCitySearch.bind(this)
        this.renderBillCityList = this.renderBillCityList.bind(this)
        this.onBillStateSearch = this.onBillStateSearch.bind(this)
        this.renderBillStateList = this.renderBillStateList.bind(this)
        this.callBillStateList = this.callBillStateList.bind(this)
        this.onBillCountrySearch = this.onBillCountrySearch.bind(this)
        this.renderBillCountryList = this.renderBillCountryList.bind(this)
        this.onEnterProductName = this.onEnterProductName.bind(this)
        this.onMachineDetailsChange = this.onMachineDetailsChange.bind(this)
        this.onEnterHSNCode = this.onEnterHSNCode.bind(this)
        this.onLengthChange = this.onLengthChange.bind(this)
        this.onBreadthChange = this.onBreadthChange.bind(this)
        this.onHeightChange = this.onHeightChange.bind(this)
        this.onFloorCapacityChange = this.onFloorCapacityChange.bind(this)
        this.onManufacturerNameChange = this.onManufacturerNameChange.bind(this)
        this.onMachineWeightChange = this.onMachineWeightChange.bind(this)
        this.onManufacturingCountryChange = this.onManufacturingCountryChange.bind(this)
        this.onAddClick = this.onAddClick.bind(this)
        this.record = this.record.bind(this)
        this.onCheckLevel2 = this.onCheckLevel2.bind(this)
        this.onCheckLevel3 = this.onCheckLevel3.bind(this)
        this.recordFour = this.recordFour.bind(this)
        this.onSSITMMAITAMMAClick = this.onSSITMMAITAMMAClick.bind(this)
        this.onSelectLevel4 = this.onSelectLevel4.bind(this)
        this.onSchemeTypeChange = this.onSchemeTypeChange.bind(this)
        this.onLengthTypeChange = this.onLengthTypeChange.bind(this)
        this.onMBclick = this.onMBclick.bind(this)
        this.adjustInternationalArea = this.adjustInternationalArea.bind(this)
        this.viewPI = this.viewPI.bind(this)
        this.fillInternationalForm = this.fillInternationalForm.bind(this)
        this.onCancelClick = this.onCancelClick.bind(this)

        this.onFilePick = this.onFilePick.bind(this)
        this.resizeFile = this.resizeFile.bind(this)
        this.onPdfSelect = this.onPdfSelect.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)
        this.handleChapterDocDelete = this.handleChapterDocDelete.bind(this)
        this.renderNewImage = this.renderNewImage.bind(this)
        this.onChapterDocDelete = this.onChapterDocDelete.bind(this)
        this.onGSTchange = this.onGSTchange.bind(this)
        this.adjustIntAreaNew = this.adjustIntAreaNew.bind(this)
        this.getUpdateAccess = this.getUpdateAccess.bind(this)

    }

    async PdfRender2() {
        const { RandRpath } = this.state;
        // console.log("RandRpath--------------------------------------------->", RandRpath)
        if (!IntAreaRules) return;

        const container = this.pdfContainerRef2.current;
        // console.log("container--------------------------------------------->", container)
        if (!container) return;

        container.innerHTML = ""; // clear old pages

        const url = `${BASE_URL.split("/api")[0]}/document/Exhibition/InternationalAreaRules/International-Area-Rules.pdf`;
        // const url = IntAreaRules
        console.log("url--------------------------------------------->", url)
        try {
            const pdf = await pdfjsLib.getDocument(url).promise;
            for (let i = 1; i <= pdf.numPages; i++) {
                const page = await pdf.getPage(i);
                const viewport = page.getViewport({ scale: 1.5 });

                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                canvas.height = viewport.height;
                canvas.width = viewport.width;
                canvas.style.width = "100%";
                canvas.style.height = "auto";
                canvas.style.display = "block";
                canvas.style.margin = "20px auto";

                container.appendChild(canvas);
                await page.render({ canvasContext: context, viewport }).promise;
            }
        } catch (err) {
            console.error("PDF rendering error:", err);
        }
    }

    // On Component Load
    componentDidMount() {
        // this.setState({isLoad1stTime:false})
        const url = BASE_URL.split('/api')
        this.setState({ url: url[0] })
        this.setState({
            isView: this.props.location.state != null && this.props.location.state.isView != null ? this.props.location.state.isView : false,
        })
        this.getFillList(internationalAreaSlabActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '').then(() => {
            this.getFillList(BarActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')
            this.getFillList(CFMActionId, sessionStorage.getItem("sessionExhibitionID"), '', 13, "", 1)
            setTimeout(() => {
                this.getSpaceBookingDetails()
                // const fasciaEditableDate = new Date(JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['FasicaEditableDate'] != null &&
                //     JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['FasicaEditableDate'])
                console.log(JSON.parse(sessionStorage.getItem('isDoubleStoreyExhibition')))
                this.setState({
                    // doubleStoreyArea: JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['FasicaEditableDate'],
                    isDoubleStoreyExhibition: JSON.parse(sessionStorage.getItem('isDoubleStoreyExhibition')),
                    isSSIExhibition: JSON.parse(sessionStorage.getItem('isSSIcertificateExhibition')),
                })
            }, 200);
        })
        this.setState(
            {
                loginAccesslist: JSON.parse(sessionStorage.getItem("loginDataSS"))[
                    "loginAccesslist"
                ],
            })
    }

    //Input Field Validations
    inputValidate() {
        const { personInchFirst, gstValidtionList, stateId, personInchLast, regDesignation, regCompany, fasciaName, regAdd1, regPin, regCity, regState, regCountry, regMob1, ExhibitorCompanyName, regTel, regPrimaryEmail, ownerNameFirst, AuthorizedPersonName, EmailAuthorizedPerson, MobileAuthorizedPerson, PreMobileAuthorizedPerson, DesignationAuthorizedPerson, ownerEmail, billDesignation, billCompany, billAdd1, billPin, billCity, billState,
            billCountry, billMob1, billMob2, billTel, billPrimaryEmail, billSecondaryEmail, billWeb, companyRegNo,
            panNo, panName, gstNo, status, tanNo, uanNo, iecCode, accName, accNo, bankName, branchName, ifsc, billPersonInchFirst, ownerDesignation, ownerDesignationErr, stallArea, stallTypeId, stallAreaErr, stallTypeIdErr, openSlidesErr, openSlides, subChapters,
            billPersonInchLast } = this.state
        return new Promise(async (resolve, reject) => {
            var err = false
            if (personInchFirst == "") {
                this.setState({ personInchFirstErr: "Please enter person incharge first name" });
                err = true
            }
            if (personInchLast == "") {
                this.setState({ personInchLastErr: "Please enter last name" });
                err = true
            }
            if (regDesignation == "") {
                this.setState({ regDesignationErr: "Please Enter Designation" });
                err = true
            }
            if (regCompany == "") {
                this.setState({ regCompanyErr: "Please Enter Company Name" });
                err = true
            }
            if (fasciaName == "") {
                this.setState({ fasciaName: "Please enter fascia name" });
                err = true
            }
            if (regAdd1 == "") {
                this.setState({ regAdd1Err: "Please Enter Address" });
                err = true
            }
            if (regPin == "") {
                this.setState({ regPinErr: "Please Enter PinCode" });
                err = true
            }
            if (regCity == "") {
                this.setState({ regCityErr: "Please Enter City" });
                err = true
            }
            if (regState == "" && regCountry.toLowerCase().trim() == "india") {
                this.setState({ regStateErr: "Please Enter State" });
                err = true
            }
            if (regCountry == "") {
                this.setState({ regCountryErr: "Please Enter Country" });
                err = true
            }
            if (regMob1 == "") {
                this.setState({ regMob1Err: "Please Enter Mobile No." });
                err = true
            }
            if (regPrimaryEmail == "") {
                this.setState({ regPrimaryEmailErr: "Please Enter Primary Email" });
                err = true
            } else {
                var emailError = emailValidator(regPrimaryEmail)
                if (emailError != '') {
                    this.setState({ regPrimaryEmailErr: emailError });
                    err = true
                }
            }
            if (ownerNameFirst == "") {
                this.setState({ ownerNameFirstErr: "Please Enter Owner Name" });
                err = true
            }
            if (ownerDesignation == "") {
                this.setState({ ownerDesignationErr: "Please Enter Owner Designation" });
                err = true
            }
            if (ownerEmail == "") {
                this.setState({ ownerEmailErr: "Please Enter Owner Email" });
                err = true
            }
            if (billPersonInchFirst == "") {
                this.setState({ billPersonInchFirstErr: "Please enter person incharge first name" });
                err = true
            }
            if (billPersonInchLast == "") {
                this.setState({ billPersonInchLastErr: "Please enter person incharge first name" });
                err = true
            }
            if (billDesignation == "") {
                this.setState({ billDesignationErr: "Please Enter Designation" });
                err = true
            }
            if (billCompany == "") {
                this.setState({ billCompanyErr: "Please Enter Billing Name" });
                err = true
            }
            if (billAdd1 == "") {
                this.setState({ billAdd1Err: "Please Enter Address" });
                err = true
            }
            if (billPin == "") {
                this.setState({ billPinErr: "Please Enter PinCode" });
                err = true
            }
            if (billCity == "") {
                this.setState({ billCityErr: "Please Enter City" });
                err = true
            }
            if (billState == "" && billCountry.toLowerCase().trim() == "india") {
                this.setState({ billStateErr: "Please Enter State" });
                err = true
            }
            if (billCountry == "") {
                this.setState({ billCountryErr: "Please Enter Country" });
                err = true
            }
            if (billMob1 == "") {
                this.setState({ billMob1Err: "Please Enter Mobile No." });
                err = true
            }
            if (billPrimaryEmail == "") {
                this.setState({ billPrimaryEmailErr: "Please Enter Primary Email" });
                err = true
            } else {
                var emailError = emailValidator(billPrimaryEmail)
                if (emailError != '') {
                    this.setState({ billPrimaryEmailErr: emailError });
                    err = true
                }
            }
            if (this.state.undertakingContent.length > 0 && this.state.countryId == 91) {
                if (AuthorizedPersonName == "") {
                    this.setState({ AuthorizedPersonNameErr: "Please Enter Person Name" });
                    err = true
                } if (EmailAuthorizedPerson == "") {
                    this.setState({ EmailAuthorizedPersonErr: "Please Enter Email" });
                    err = true
                } else {
                    var emailError = emailValidator(EmailAuthorizedPerson)
                    if (emailError != '') {
                        this.setState({ EmailAuthorizedPersonErr: emailError });
                        console.log('emailErroremailErroremailErroremailError', emailError)
                        err = true
                    }
                }

                if (MobileAuthorizedPerson == "") {
                    this.setState({ MobileAuthorizedPersonErr: "Please Enter Mobile No" });
                    err = true
                } if (DesignationAuthorizedPerson == "") {
                    this.setState({ DesignationAuthorizedPersonErr: "Please Enter designation" });
                    err = true
                } if (ExhibitorCompanyName == "") {
                    this.setState({ ExhibitorCompanyNameErr: "Please Enter Company Name" });
                    err = true
                }
            }

            if (regCountry != "" && regCountry != null && regCountry.toLowerCase().trim() == "india") {
                if (panNo == "") {
                    this.setState({ panNoErr: "Please Enter PAN No." });
                    err = true
                }
                if (panName == "") {
                    this.setState({ panNameErr: "Please Enter PAN Name" });
                    err = true
                }
                if (gstNo == "") {
                    this.setState({ gstNoErr: "Please Enter GST No." });
                    err = true
                }
                if (gstNo == "") {
                    this.setState({
                        gstNoErr: "Please enter gst no",
                    });
                    err = true
                } else {
                    var code = gstNo.slice(0, 2)
                    var isStateValid = false
                    for (var i = 0; i < gstValidtionList.length; i++) {
                        if (stateId != '' && stateId != null) {
                            isStateValid = true
                            if (gstValidtionList[i].StateID == stateId) {
                                if (parseInt(gstValidtionList[i].GSTCode) != code) {
                                    this.setState({
                                        gstNoErr: "Please enter proper gst no",
                                    });
                                    err = true
                                    console.log('ip', this.state.gstNoErr)
                                }
                                break
                            }
                        }
                        else {
                            console.log()
                            if (gstValidtionList[i].StateName.trim().toLowerCase() == regState.trim().toLowerCase()) {
                                isStateValid = true
                                if (parseInt(gstValidtionList[i].GSTCode) != code) {
                                    console.log("2--->",)
                                    this.setState({
                                        gstNoErr: "Please enter proper gst no",
                                        // gstNo: ''
                                    });
                                    err = true
                                }
                                break
                            }
                        }
                    }
                    console.log(code, isStateValid, this.state.stateId, this.state.regState)
                    if (!isStateValid) {
                        // toastError("Please select proper State/Province")
                        this.setState({
                            regStateErr: "Please select proper State/Province",
                            isDisplayStateList: false
                        })
                        err = true
                    }
                }
                if (tanNo == "") {
                    this.setState({ tanNoErr: "Please Enter TAN No." });
                    err = true
                }
            }
            // if (accName == "" && regCountry != "" && regCountry != null && regCountry.toLowerCase().trim() == "india") {
            //     this.setState({ accNameErr: "Please Enter Account Name" });
            // }
            // if (accNo == "" && regCountry != "" && regCountry != null && regCountry.toLowerCase().trim() == "india") {
            //     this.setState({ accNoErr: "Please Enter Account No." });
            // }
            // if (ifsc == "" && regCountry != "" && regCountry != null && regCountry.toLowerCase().trim() == "india") {
            //     this.setState({ ifscErr: "Please Enter IFCI" });
            // }
            if (stallTypeId == '') {
                this.setState({
                    stallTypeIdErr: 'Please select scheme type'
                })
                err = true
            }
            if (stallArea == '') {
                this.setState({
                    stallAreaErr: 'Please select stall area'
                })
                err = true
            }
            if (openSlides == '') {
                this.setState({
                    openSlidesErr: 'Please select open sides'
                })
                err = true
            }
            if (subChapters.length == 0) {
                console.log("exhibitDetailsList", subChapters)
                this.setState({
                    exhibitDetailsTableErr: 'Please select atleast one chapter'
                })
                err = true
            }
            setTimeout(() => {
                console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>', err)
                resolve(err)
            }, 200);
        })
    }

    onCheckBoxClick(i) {
        const { checkboxList, isAgree, isAgree2, isAgree3 } = this.state
        checkboxList[i].checked = !checkboxList[i].checked
        this.setState({ checkboxList: checkboxList })
        // setTimeout(() => {

        if (i == 0) {
            this.setState({ isAgree: checkboxList[i].checked })
        } else if (i == 1) {
            this.setState({ isAgree3: checkboxList[i].checked })
        } else if (i == 2) {
            this.setState({ isAgree2: checkboxList[i].checked })
        }
        console.log(isAgree, isAgree3, isAgree2, i)
        // }, 50);
    }

    // Edit Space Booking
    async editSpaceBooking() {
        const { isLoading, personInchFirst, area, compareObjArr, regDesignation, regCompany, fasciaName, regAdd1, regAdd2, regPin, regCity, comment,
            regState, regCountry, regMob1, regMob2, regTel, regPrimaryEmail, regSecondaryEmail, regWeb,
            billDesignation, billCompany, billAdd1, billAdd2, billPin, billCity, billState, billCountry, billMob1, isAllBro,
            billMob2, billTel, billPrimaryEmail, billSecondaryEmail, billWeb, companyRegNo, panNo, panName, gstNo, status,
            tanNo, uanNo, iecCode, accName, accNo, accType, bankName, branchName, ifsc, isAgree, isAgree2, personInchLast,
            regTel1, regTelFax, preOwnerNameFirst, ownerNameFirst, ownerNameLast, ownerMob, ownerEmail, preFixBillPersonInch,
            billPersonInchFirst, billPersonInchLast, billTel1, billTelFax, preFixPersonInch, preRegTel, preRegTel1, preRegMob1,
            preRegMob2, preBillMob1, preBillMob2, preBillTel, preBillTel1, preOwnerMob, personInchLastErr, primaryChapterListData, selectedPrimaryChapterId, selectedPrimaryChapterIdList, stallAreaList,
            billPersonInchLastErr, regCompanyErr, fasciaNameErr, regAdd1Err, regCityErr, regStateErr, regPinErr,
            regCountryErr, personInchFirstErr, regDesignationErr, regMob1Err, regPrimaryEmailErr, ownerNameFirstErr, ownerDesignation, ownerDesignationErr,
            ownerEmailErr, billCompanyErr, billAdd1Err, billCityErr, billStateErr, billPinErr, billCountryErr, AuthorizedPersonNameErr, EmailAuthorizedPersonErr, MobileAuthorizedPersonErr, DesignationAuthorizedPersonErr, ExhibitorCompanyNameErr,
            billPersonInchFirstErr, billDesignationErr, billPrimaryEmailErr, accNameErr, accNoErr, ifscErr, regCountryId, isUpdatePerm,
            billCountryId, accTypeOthers, isOtherPreFixPersonInch, otherPersonInchFirst, isOtherOwnerFirstName, AuthorizedPersonName, DesignationAuthorizedPerson, ExhibitorCompanyName, EmailAuthorizedPerson, MobileAuthorizedPerson, PreMobileAuthorizedPerson, otherOwnerFirstName, isOtherBillPersonInchFirst, otherBillPersonInchFirst, exbRegNo, isCorrespondence, openSlides, stallArea, stallTypeId,
            ExhPrimaryUndertakingPersonName,
            ExhPrimaryUndertakingDesignation,
            ExhPrimaryUndertakingCompanyName,
            ExhPrimaryUndertakingEmail, countryId,
            ExhPrimaryUndertakingMobileNo,
            isOpenAgree, PreExhPrimaryUndertakingMobileNo,
            primaryChapterId, exbTableErr, billMob1Err, isSSIreplaced, isSSIExhibition, isTAMMAITAMMAreplaced, isSSIdeleted, isTMMAITAMMAdeleted, countryList, isDoubleStorey, isSSi, ExhPrimaryChapterComment, lengthWidthErr, subChapters, InternationalArea, exhibitDetailsTableErr, InternationalAreaErr, oldInternationalArea, olddoubleStoreyArea, oldisDoubleStorey, internationalAreaSlabList, oldopenSlides, oldstallArea, oldstallTypeId } = this.state

        /// Setting data in session storage For Update
        sessionStorage.setItem("sessionregisterTelephoneNoPre", preRegTel)
        sessionStorage.setItem("sessionregisterTelephoneNo1Pre", preRegTel1)
        sessionStorage.setItem("sessioninvoiceregisterTelephoneNoPre", preBillTel)
        sessionStorage.setItem("sessioninvoiceregisterTelephoneNo1Pre", preBillTel1)
        sessionStorage.setItem("sessionCountryNamePreRegisterMobileNo", preRegMob1)
        sessionStorage.setItem("sessionCountryNamePreRegisterAlternateMobileNo", preRegMob2)
        sessionStorage.setItem("sessionCountryNamePreOwnerMobileNo", preOwnerMob)
        sessionStorage.setItem("sessionCountryNamePreInvoiceregisterMobileNo", preBillMob1)
        sessionStorage.setItem("sessionCountryNamePreInvoiceregisterAlternateMobileNo", preBillMob1)

        var errMsg = ''
        errMsg = errMsg + panNoValidator(panNo)
        errMsg = errMsg + tanNoValidator(tanNo)
        errMsg = errMsg + gstNoValidator(gstNo)

        //Validate InputFields before edit
        this.inputValidate().then(async (ivRes) => {
            console.log("...................................", ivRes)
            if (ivRes) {
                toastError("Please enter namdatory fields")
                return
            }

            var isnotContact = false
            if (regMob1 != '') {
                isnotContact = false
            } else {
                isnotContact = true
            }

            // validation for company info
            var isNotCompanyValidate = false
            if (regCountry.toLowerCase().trim() == "india") {
                if (
                    panName != '' && panNo != '' && tanNo != '' && gstNo != ''
                ) {
                    isNotCompanyValidate = false
                }
                else {
                    isNotCompanyValidate = true
                }
            }

            var isNotStaBankValidate = false
            // if (regCountry.toLowerCase().trim() == "india") {
            //     if (
            //         accName != '' && accNo != '' && ifsc != ''
            //     ) {
            //         isNotStaBankValidate = false
            //     }
            //     else {
            //         isNotStaBankValidate = true
            //     }
            // }
            var iserror = false
            if (isDoubleStorey) {
                if (this.state.doubleStoreyArea == '' || this.state.doubleStoreyArea == null) {
                    console.log("///this.state.doubleStoreyArea", isDoubleStorey, this.state.doubleStoreyArea)
                    this.setState({ doubleStoreyAreaErr: 'Please fill Double storey area' })
                    iserror = true;
                }
            }
            var isSSIfile = null
            var isSSIfileType = null
            var TMMA_ITAMMAfile = null
            var TMMA_ITAMMAfiletype = null
            if (isSSi) {
                if (isSSIreplaced) {
                    if (this.state.isSSifileReplacement == '' || this.state.isSSifileReplacement == null) {
                        this.setState({ isSSifileErr: 'Please upload SSI certificate' })
                        console.log("///this.state.certificateSSEE", isSSIreplaced, this.state.isSSifileReplacement)
                        iserror = true;
                    }
                    else {
                        isSSIfile = this.state.isSSifileReplacement
                        isSSIfileType = this.state.isSSifileTypeReplacement
                        // this.setState({ isSSifilePath: '' })
                    }
                } else {
                    if (this.state.isSSifile == '' || this.state.isSSifile == null) {
                        this.setState({ isSSifileErr: 'Please upload SSI certificate' })
                        console.log("///this.state.SSI", this.state.isSSifile)
                        iserror = true;
                    }
                    else {
                        isSSIfile = this.state.isSSifile
                        isSSIfileType = this.state.isSSifileType
                        // this.setState({ isSSifilePath: '' })
                    }
                }
                if (isTAMMAITAMMAreplaced) {
                    // if (this.state.TMMAITAMMA != '' && this.state.TMMAITAMMA != null) {
                    if (this.state.TMMAITAMMAfileReplacement == '' || this.state.TMMAITAMMAfileReplacement == null) {
                        this.setState({ TMMAITAMMAfileErr: 'Please upload TMMA or ITAMMA certificate' })
                        console.log("///this.state.isTAMMAITAMMAreplaced", isTAMMAITAMMAreplaced, this.state.TMMAITAMMAfileReplacement)
                        iserror = true;
                    }
                    else {
                        TMMA_ITAMMAfile = this.state.TMMAITAMMAfileReplacement
                        TMMA_ITAMMAfiletype = this.state.TMMAITAMMAfileTypeReplacement
                        // this.setState({ isSSifilePath: '' })
                    }
                    // } else {
                    //     TMMA_ITAMMAfile = null
                    //     TMMA_ITAMMAfiletype = null
                    //     this.setState({ TMMAITAMMAfilePath: '' })
                    // }
                }
                else {
                    // if (this.state.TMMAITAMMA != '' && this.state.TMMAITAMMA != null) {
                    if (this.state.TMMAITAMMAfile == '' || this.state.TMMAITAMMAfile == null) {
                        this.setState({ TMMAITAMMAfileErr: 'Please upload TMMA or ITAMMA certificate' })
                        console.log("///this.state.TMMAITAMMAfileErr", this.state.TMMAITAMMAfile)
                        iserror = true;
                    }
                    else {
                        TMMA_ITAMMAfile = this.state.TMMAITAMMAfile
                        TMMA_ITAMMAfiletype = this.state.TMMAITAMMAfileType
                        // this.setState({ TMMAITAMMAfilePath: '' })
                    }
                    // }
                    // else {
                    //     TMMA_ITAMMAfile = null
                    //     TMMA_ITAMMAfiletype = null
                    //     this.setState({ TMMAITAMMAfilePath: '' })
                    // }
                }
            }
            else {
                isSSIfile = null
                isSSIfileType = null
                this.setState({ isSSifilePath: '' })
                TMMA_ITAMMAfile = null
                TMMA_ITAMMAfiletype = null
                this.setState({ TMMAITAMMAfilePath: '' })
            }
            if (this.state.isShowExhPrimaryChapterComment) {
                if (ExhPrimaryChapterComment == '' || ExhPrimaryChapterComment == null) {
                    this.setState({ ExhPrimaryChapterCommentErr: 'Please enter Multiple Chapter remark' })
                    console.log("///this.state.isShowExhPrimaryChapterComment", ExhPrimaryChapterComment, this.state.isShowExhPrimaryChapterComment)
                    iserror = true
                }
            }
            if (this.state.stallArea == '' || this.state.stallArea == null || this.state.stallTypeId == '' || this.state.stallTypeId == null || this.state.openSlides == '' || this.state.openSlides == null || (this.state.isDoubleStorey && this.state.doubleStoreyArea == '') || (this.state.isDoubleStorey && this.state.doubleStoreyArea == null) || this.state.InternationalArea == null) {
                console.log(this.state.stallArea, this.state.stallTypeId, this.state.openSlides, this.state.isDoubleStorey, this.state.doubleStoreyArea, this.state.InternationalArea)
                console.log(this.state.stallArea == '', this.state.stallArea == null, this.state.stallTypeId == '', this.state.stallTypeId == null, this.state.openSlides == '', this.state.openSlides == null, (this.state.isDoubleStorey && this.state.doubleStoreyArea == ''), (this.state.isDoubleStorey && this.state.doubleStoreyArea == null), this.state.InternationalArea == '', this.state.InternationalArea == null)

                iserror = true
            }
            if (stallTypeId == '') {
                this.setState({
                    stallTypeIdErr: 'Please select scheme type'
                })
                iserror = true
            }
            if (stallArea == '') {
                this.setState({
                    stallAreaErr: 'Please select stall area'
                })
                iserror = true
            }
            if (openSlides == '') {
                this.setState({
                    openSlidesErr: 'Please select open sides'
                })
                iserror = true
            }
            if (subChapters.length == 0) {
                console.log("exhibitDetailsList", subChapters)
                this.setState({
                    exhibitDetailsTableErr: 'Please select atleast one chapter'
                })
                iserror = true
            }
            var lengthErr = ''
            if (lengthWidthErr != '') {
                console.log("exhibitDetailsList", subChapters)
                // this.setState({
                //     exhibitDetailsTableErr: 'Please select atleast one chapter'
                // })
                iserror = true
                lengthErr = lengthWidthErr
            }
            const isAllMB = subChapters.every(item => item.isMachine != undefined && item.isBrochure != undefined && item.IsAccessory != undefined ? (item.isMachine || item.isBrochure || item.IsAccessory) : false)
            subChapters.every(item => console.log(item.isMachine != undefined && item.isBrochure != undefined && item.IsAccessory != undefined, (item.isMachine, item.isBrochure)))

            console.log(isAllMB)
            var DueDateValidation = false
            if (this.state.dueDate != '') {
                if (new Date(this.state.dueDate) < new Date()) {
                    DueDateValidation = true
                }
            }
            console.log("-------------------------------------------------------------------mb", isAllMB)
            const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
            var isAllCompanyEmail = true
            var isAllregistrationHQaddress = true
            // if (countryId == 91 && filterArray.length > 0) {
            isAllCompanyEmail = subChapters.every(item => item.CompanyEmail != null && item.CompanyEmail != '')
            isAllregistrationHQaddress = subChapters.every(item => item.registrationHQaddress != null && item.registrationHQaddress != '')
            // }
            for (var i = 0; i < subChapters.length; i++) {
                if (!isAllMB) {
                    console.log("-------------------------------------------------------------------mb4")
                    iserror = true
                    lengthErr = "Please Select Machine/Brochure/Accessories"
                    this.setState({
                        lengthWidthErr: "Please Select Machine/Brochure/Accessories"
                    })
                } if (subChapters[i].CompanyEmail == '' || subChapters[i].CompanyEmail == null) {
                    console.log("-------------------------------------------------------------------mb5", 2)
                    iserror = true
                    lengthErr = "Please Enter all Company Email"
                    this.setState({
                        lengthWidthErr: "Please Enter all Company Email"
                    })
                } else {
                    if (emailValidator(subChapters[i].CompanyEmail) != '') {
                        iserror = true
                        lengthErr = "Please Enter proper Company Email"
                        this.setState({
                            lengthWidthErr: "Please Enter proper Company Email"
                        })
                    }
                } if (subChapters[i].registrationHQaddress == '' || subChapters[i].registrationHQaddress == null) {
                    console.log("-------------------------------------------------------------------mb5", 3)
                    iserror = true
                    lengthErr = "Please Enter all Registration Head Quarters address"
                    this.setState({
                        lengthWidthErr: "Please Enter all Registration Head Quarters address"
                    })
                } if (subChapters[i].ManufacturerName == '' || subChapters[i].ManufacturerName == null) {
                    console.log("-------------------------------------------------------------------mb5")
                    iserror = true
                    lengthErr = "Please Enter all Manufacturer Company Name"
                    this.setState({
                        lengthWidthErr: "Please Enter all Manufacturer Company Name"
                    })
                } if (subChapters[i].ManufacturingCountry == '' || subChapters[i].ManufacturingCountry == null) {
                    console.log("-------------------------------------------------------------------mb6")
                    this.setState({
                        lengthWidthErr: 'Please Select all Manufacturer Country'
                    })
                    iserror = true
                    lengthErr = "Please Select all Manufacturer Country"

                } if (subChapters[i].SinglePhasePower === '' || subChapters[i].SinglePhasePower === null) {
                    console.log("-------------------------------------------------------------------mb6")
                    this.setState({
                        lengthWidthErr: 'Please Enter all Single Phase Power'
                    })
                    iserror = true
                    lengthErr = 'Please Enter all Single Phase Power'

                } if (subChapters[i].ThreePhasePower === '' || subChapters[i].ThreePhasePower === null) {
                    console.log("-------------------------------------------------------------------mb6")
                    this.setState({
                        lengthWidthErr: "Please Enter all Three Phase Power"
                    })
                    iserror = true
                    lengthErr = "Please Enter all Three Phase Power"

                } if (subChapters[i].WaterConsumption === '' || subChapters[i].WaterConsumption === null) {
                    console.log("-------------------------------------------------------------------mb6")
                    this.setState({
                        lengthWidthErr: 'Please Enter all Water Consumption'
                    })
                    iserror = true
                    lengthErr = 'Please Enter all Water Consumption'

                } if (subChapters[i].InletQuantity === '' || subChapters[i].InletQuantity === null) {
                    console.log("-------------------------------------------------------------------mb6")
                    this.setState({
                        lengthWidthErr: 'Please Enter all Inlet Qunatity'
                    })
                    iserror = true
                    lengthErr = 'Please Enter all Inlet Qunatity'

                } if (subChapters[i].OutletQuantity === '' || subChapters[i].OutletQuantity === null) {
                    console.log("-------------------------------------------------------------------mb6")
                    this.setState({
                        lengthWidthErr: 'Please Enter all Outlet Qunatity'
                    })
                    iserror = true
                    lengthErr = 'Please Enter all Outlet Qunatity'

                }
                // else if (
                //     subChapters[i].BarQuantity === undefined ||
                //     subChapters[i].BarQuantity === '') {
                //     console.log("-------------------------------------------------------------------mb6")
                //     this.setState({
                //         lengthWidthErr: 'Please Select all Bar Quantity'
                //     })
                //     iserror = true
                //     lengthErr = "Please Select all Bar Quantity'"

                // } else if (
                //     subChapters[i].CFMQuantity === undefined ||
                //     subChapters[i].CFMQuantity === '') {
                //     console.log("-------------------------------------------------------------------mb6")
                //     this.setState({
                //         lengthWidthErr: 'Please Select all CMF Quantity'
                //     })
                //     iserror = true
                //     lengthErr = "Please Select all CMF Quantity"

                // }
                if (subChapters[i].MaxCompressedAir === '' || subChapters[i].MaxCompressedAir === null) {
                    console.log("-------------------------------------------------------------------mb6")
                    this.setState({
                        lengthWidthErr: 'Please Enter all Max Compressed Air'
                    })
                    iserror = true
                    lengthErr = 'Please Enter all Max Compressed Air'

                } if (subChapters[i].Length == '' || subChapters[i].Length == 0 || subChapters[i].Length == null) {
                    console.log("-------------------------------------------------------------------mb1")
                    if (this.state.isMachineMandatory ? !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && subChapters[i].IsAccessory != undefined && !subChapters[i].isMachine && (subChapters[i].isBrochure || subChapters[i].IsAccessory)) : DueDateValidation && !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && subChapters[i].IsAccessory != undefined && !subChapters[i].isMachine && (subChapters[i].isBrochure || subChapters[i].IsAccessory))) {
                        this.setState({
                            lengthWidthErr: "Please Enter all Length"
                        })
                        iserror = true
                        lengthErr = "Please Enter all Length"
                    }
                } if (subChapters[i].Breadth == '' || subChapters[i].Breadth == null || subChapters[i].Breadth == 0) {
                    console.log("-------------------------------------------------------------------mb2")
                    if (this.state.isMachineMandatory ? !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && subChapters[i].IsAccessory != undefined && !subChapters[i].isMachine && (subChapters[i].isBrochure || subChapters[i].IsAccessory)) : DueDateValidation && !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && subChapters[i].IsAccessory != undefined && !subChapters[i].isMachine && (subChapters[i].isBrochure || subChapters[i].IsAccessory))) {
                        iserror = true
                        lengthErr = "Please Enter all Breadth"
                        this.setState({
                            lengthWidthErr: "Please Enter all Breadth"
                        })
                    }
                } if (subChapters[i].Height == '' || subChapters[i].Height == null || subChapters[i].Height == 0) {
                    console.log("-------------------------------------------------------------------mb3")
                    if (this.state.isMachineMandatory ? !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && subChapters[i].IsAccessory != undefined && !subChapters[i].isMachine && (subChapters[i].isBrochure || subChapters[i].IsAccessory)) : DueDateValidation && !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && subChapters[i].IsAccessory != undefined && !subChapters[i].isMachine && (subChapters[i].isBrochure || subChapters[i].IsAccessory))) {
                        iserror = true
                        lengthErr = "Please Enter all Height"
                        this.setState({
                            lengthWidthErr: "Please Enter all Height"
                        })
                    }
                }
            }
            var lenerr = ''
            var isSSIvalidAndTable = true
            // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
            const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
            var isIntBrochure = filterArray.some((item) => !item.isMachine && item.isBrochure)
            // var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
            // var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
            var totalNational = filterArrayNational.length > 0 ? filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0) : area - InternationalArea
            var remArea = area - InternationalArea
            if (remArea > totalNational) {
                totalNational = remArea
            }
            console.log(this.state.InternationalArea, InternationalArea != 0, totalNational)
            if (countryId == 91 && filterArray.length > 0) {
                if (!this.state.isMixRuleAgree) {
                    this.setState({ intAreaRulesPop: true })
                    return
                }
                var inLimit = false
                var totalArea = totalNational + InternationalArea
                var natAreaErr = false
                // if (!isAllBro) {
                if (stallTypeId == 1) {
                    if (totalNational < 27) {
                        totalArea = InternationalArea + 27
                        natAreaErr = true
                    }
                } else if (stallTypeId == 2) {
                    if (totalNational < 18) {
                        totalArea = InternationalArea + 18
                        natAreaErr = true
                    }
                }
                // }
                var isNatinSlag = false
                for (var j = 0; j < stallAreaList.length; j++) {
                    if (totalNational == stallAreaList[j].StallArea) {
                        isNatinSlag = true
                        break
                    }
                }
                if (!isNatinSlag) {
                    var temptptal = totalArea
                    for (var i = 0; i < stallAreaList.length; i++) {
                        if (totalNational <= stallAreaList[i].StallArea) {
                            temptptal = InternationalArea + stallAreaList[i].StallArea
                            for (var j = 0; j < stallAreaList.length; j++) {
                                if (temptptal == stallAreaList[j].StallArea) {
                                    inLimit = true
                                    this.setState({
                                        expectedArea: stallAreaList[j].StallArea, expectedAreaId: stallAreaList[j].Code, isOpen10: true
                                        // natAreaErr: true 
                                    })
                                    return
                                }
                            }
                        }
                    }
                    if (!inLimit) {
                        if (this.state.stallTypeId == 2) {
                            this.setState({ lengthWidthErr: 'Total sum of area is more than Shell space limit. Kindly switch to Bare space' })
                            lenerr = 'Total sum of area is more than Shell space limit. Kindly switch to Bare space'
                        } else {
                            this.setState({ lengthWidthErr: 'Total sum of area is more than limit. Kindly change to accomodate within space limits or contact  ITME 2026 Exhibition Team' })
                            lenerr = 'Total sum of area is more than limit. Kindly change to accomodate within space limits or contact  ITME 2026 Exhibition Team'
                        }
                    }
                    iserror = true;
                }
                console.log(totalArea, InternationalArea, totalNational, 'totalNationaltotalNationaltotalNational')
                if (natAreaErr) {
                    for (var i = 0; i < stallAreaList.length; i++) {
                        if (totalArea <= stallAreaList[i].StallArea) {
                            inLimit = true
                            this.setState({
                                expectedArea: stallAreaList[i].StallArea, expectedAreaId: stallAreaList[i].Code, isOpen4: true, areaValidationPopFlag: 3,
                                // natAreaErr: true 
                            })
                            return
                        }
                    }
                    if (!inLimit) {
                        if (this.state.stallTypeId == 2) {
                            this.setState({ lengthWidthErr: 'Total sum of area is more than Shell space limit. Kindly switch to Bare space' })
                            lenerr = 'Total sum of area is more than Shell space limit. Kindly switch to Bare space'
                        } else {
                            this.setState({ lengthWidthErr: 'Total sum of area is more than limit. Kindly change to accomodate within space limits' })
                            lenerr = 'Total sum of area is more than limit. Kindly change to accomodate within space limits'
                        }
                    }
                    iserror = true;
                }
                else {
                    if (totalArea > area) {
                        for (var i = 0; i < stallAreaList.length; i++) {
                            if (totalArea <= stallAreaList[i].StallArea) {
                                inLimit = true
                                this.setState({ expectedArea: stallAreaList[i].StallArea, expectedAreaId: stallAreaList[i].Code, isOpen4: true, areaValidationPopFlag: InternationalArea > area ? 1 : 2 })
                                return
                            }
                        }
                        if (!inLimit) {
                            if (this.state.stallTypeId == 2) {
                                this.setState({ lengthWidthErr: 'Total sum of area is more than Shell space limit. Kindly switch to Bare space' })
                                lenerr = 'Total sum of area is more than Shell space limit. Kindly switch to Bare space'
                            } else {
                                this.setState({ lengthWidthErr: 'Total sum of area is more than limit. Kindly change to accomodate within space limits' })
                                lenerr = 'Total sum of area is more than limit. Kindly change to accomodate within space limits'
                            }
                        }
                        // this.setState({ lengthWidthErr: 'Total sum of area  cannot be greater than stall area' })
                        iserror = true;
                    }
                }

                // if (totalInternational != 0) {
                //     if (area >= totalInternational) {
                //         this.setState({ lengthWidthErr: '' })
                //     } else {
                //         this.setState({ lengthWidthErr: 'Total sum of area  cannot be greater than stall area' })
                //         iserror = true;
                //     }
                // } else {
                //     var remArea = 0
                //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
                //         // console.log('internationalAreaSlabList[i].FromRange', internationalAreaSlabList[i].FromRange, area)
                //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
                //             remArea = area - internationalAreaSlabList[i].MinArea
                //             // total = internationalAreaSlabList[i].MinArea
                //         }
                //     }
                //     if (remArea < (totalInternational + totalNational)) {
                //         this.setState({ lengthWidthErr: "Total sum of area cannot be greater than remaining stall area" })
                //         iserror = true;
                //         // isSSIvalidAndTable = false
                //     } else {
                //         this.setState({ lengthWidthErr: '' })
                //     }
                // }
            } else {
                var totalArea = subChapters.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                if (area < totalArea) {
                    var inLimit = false
                    // this.setState({ lengthWidthErr: 'Total sum of area  cannot be greater than stall area' })
                    for (var i = 0; i < stallAreaList.length; i++) {
                        if (totalArea < stallAreaList[i].StallArea) {
                            inLimit = true
                            console.log(stallAreaList[i].Code, 'stallAreaList[i].Code')
                            this.setState({ expectedArea: stallAreaList[i].StallArea, expectedAreaId: stallAreaList[i].Code, isOpen4: true, areaValidationPopFlag: 2 })
                            return
                        }
                    }
                    if (!inLimit) {
                        if (this.state.stallTypeId == 2) {
                            this.setState({ lengthWidthErr: 'Total sum of area is more than Shell space limit. Kindly switch to Bare space' })
                            lenerr = 'Total sum of area is more than Shell space limit. Kindly switch to Bare space'
                        } else {
                            this.setState({ lengthWidthErr: 'Total sum of area is more than limit. Kindly change to accomodate within space limits' })
                            lenerr = 'Total sum of area is more than limit. Kindly change to accomodate within space limits'
                        }
                    }
                    iserror = true;
                } else {
                    this.setState({ lengthWidthErr: '' })
                    lenerr = ''
                }
            }

            for (var i = 0; i < subChapters.length; i++) {
                if (subChapters[i].ManufacturingCountry != '' && subChapters[i].ManufacturingCountry != null) {
                    if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india') {
                        if (this.state.isSSi) {
                            toastError("SSI is not applicable for Mixed Exhibitors")
                            isSSIvalidAndTable = false
                        }
                    }
                }
            }
            if (!isSSIvalidAndTable) {
                return
            }

            // var prodList = []
            // for (var i = 0; i < subChapters.length; i++) {
            //     // console.log("onEnterProductName validate : ", index, ' ', i, ' ', exhibitDetailsList[i].ChapterName.toString().trim().toLowerCase(), ' ', e.target.value.toString().trim().toLowerCase())
            //     if (!prodList.includes(subChapters[i].ChapterName.toString().trim().toLowerCase())) {
            //         prodList.push(subChapters[i].ChapterName.toString().trim().toLowerCase())
            //     } else {
            //         this.setState({ lengthWidthErr: 'Product name must be unique.' })
            //         lenerr = 'Product name must be unique.'
            //         iserror = true;
            //     }
            // }
            if (iserror) {
                setTimeout(() => {
                    toastError(lenerr != '' ? lenerr : "Please fill mandatory fields")
                }, 500);
                return
            }
            setTimeout(() => {
                console.log(stallTypeId,
                    stallArea,
                    openSlides,
                    subChapters)
            }, 500);

            // Preparing SubChapter List For Udt 
            var list = []
            subChapters.map(data => {
                var data = {
                    "ExhibitionID": parseInt(sessionStorage.getItem('sessionExhibitionID')),
                    "ExhRegistrationID": JSON.parse(sessionStorage.getItem('ExhibitorAccessData')).ExhRegistrationID,
                    "ChapterID": data.ChapterID,
                    'ChapterName': data.ChapterName,
                    "HSNCode": data.HSNCode,
                    "CompanyEmail": data.CompanyEmail,
                    "registrationHQaddress": data.registrationHQaddress,
                    "MachineDetails": data.MachineDetails,
                    "Length": data.isBrochure && !data.isMachine ? 0 : data.Length,
                    "Breadth": data.isBrochure && !data.isMachine ? 0 : data.Breadth,
                    "Height": data.isBrochure && !data.isMachine ? 0 : data.Height,
                    "FloorCapacity": data.isBrochure && !data.isMachine ? 0 : data.FloorCapacity,
                    "MachineWeight": data.isBrochure && !data.isMachine ? 0 : data.MachineWeight,
                    "ManufacturerName": data.ManufacturerName,
                    "ManufacturingCountry": data.ManufacturingCountry,
                    'isMachine': data.isMachine,
                    'isBrochure': data.isBrochure,
                    'IsAccessory': data.IsAccessory,
                    'DocumentFile': data.DocumentFile,
                    'DocumentName': data.DocumentName,
                    'DocumentPath': data.DocumentPath,
                    'DocumentType': data.DocumentType,
                    'DocDeleted': data.DocDeleted,
                    SinglePhasePower: data.SinglePhasePower == null ? 0 : data.SinglePhasePower,
                    ThreePhasePower: data.ThreePhasePower == null ? 0 : data.ThreePhasePower,
                    WaterConsumption: data.WaterConsumption == null ? 0 : data.WaterConsumption,
                    InletQuantity: data.InletQuantity == null ? 0 : data.InletQuantity,
                    OutletQuantity: data.OutletQuantity == null ? 0 : data.OutletQuantity,
                    BarQuantity: data.BarQuantity == null ? 0 : data.BarQuantity,
                    CFMQuantity: data.CFMQuantity == null ? 0 : data.CFMQuantity,
                    MaxCompressedAir: data.MaxCompressedAir == null ? 0 : data.MaxCompressedAir,
                    'ShellScheme': data.ShellScheme != '' && data.ShellScheme != null ? data.ShellScheme : null,
                    'CalculatedArea': data.CalculatedArea != '' && data.CalculatedArea != null ? data.CalculatedArea : null,
                }
                list.push(data)
            })

            console.log("p0p0p0p0", regCountry, regCountryId, errMsg, gstNo)
            countryList.map(data => {

            })
            if (personInchLast != "" && billPersonInchLast != "" && regCompany != "" && fasciaName != "" && regAdd1 != "" &&
                regCity != "" && regPin != "" && (regCountry.toLowerCase().trim() == "india" ? regState != "" : true) && regCountry != ""
                && personInchFirst != "" && regDesignation != "" && regMob1 != ""
                && regPrimaryEmail != "" && ownerNameFirst != "" && ownerEmail != "" && billCompany != "" && billAdd1 != "" && ownerDesignation != "" &&
                billCity != "" && billPin != "" && (billCountry.toLowerCase().trim() == "india" ? billState != "" : true) &&
                billCountry != "" && billPersonInchFirst != "" && billDesignation != "" &&
                billMob1 != "" && billPrimaryEmail != "" && isnotContact == false && isNotCompanyValidate == false &&
                isNotStaBankValidate == false) {
                console.log("0090909090909")
                if (errMsg != "") {
                    toastError(errMsg)
                } else {
                    if (personInchLastErr == "" && billPersonInchLastErr == "" && regCompanyErr == "" && fasciaNameErr == "" &&
                        regAdd1Err == "" && regCityErr == "" && (regCountry.toLowerCase().trim() == "" ? regStateErr == "" : true)
                        && regPinErr == "" && regCountryErr == "" &&
                        personInchFirstErr == "" && regDesignationErr == "" && regMob1Err == "" && regPrimaryEmailErr == "" && ownerDesignationErr == "" &&
                        ownerNameFirstErr == "" && ownerEmailErr == "" && billCompanyErr == "" && billAdd1Err == "" && AuthorizedPersonNameErr == '' && EmailAuthorizedPersonErr == '' && MobileAuthorizedPersonErr == '' && DesignationAuthorizedPersonErr == '' && ExhibitorCompanyNameErr == '' &&
                        billCityErr == "" && (billCountry.toLowerCase().trim() == "india" ? billStateErr == "" : true) && billPinErr == "" && billCountryErr == "" &&
                        billPersonInchFirstErr == "" && billDesignationErr == "" && billMob1Err == "" && billPrimaryEmailErr == ""
                        // && accNameErr == "" && accNoErr == "" && ifscErr == ""
                    ) {
                        console.log("x9x9x9x99x9x9")
                        console.log(this.state.stallArea, this.state.oldstallArea, '/', this.state.stallTypeId, this.state.oldstallTypeId, '/', this.state.openSlides, this.state.oldopenSlides, '/', this.state.doubleStoreyArea, this.state.olddoubleStoreyArea, this.state.isDoubleStorey, this.state.oldisDoubleStorey, '/', this.state.InternationalArea, this.state.oldInternationalArea)
                        var toShowPop = false
                        if (this.state.stallArea != this.state.oldstallArea) {
                            toShowPop = true
                        }
                        if (this.state.stallTypeId != this.state.oldstallTypeId) {
                            toShowPop = true
                        }
                        if (this.state.openSlides != this.state.oldopenSlides) {
                            toShowPop = true
                        }
                        if (this.state.isDoubleStorey != this.state.oldisDoubleStorey) {
                            toShowPop = true
                        }
                        if (this.state.doubleStoreyArea != this.state.olddoubleStoreyArea) {
                            toShowPop = true
                        }
                        if (this.state.InternationalArea != this.state.oldInternationalArea) {
                            toShowPop = true
                        }
                        if (this.state.isSSi != this.state.oldisSSI) {
                            toShowPop = true
                        }
                        if (exbTableErr == "") {
                            if (this.state.adminRemark == '' || this.state.adminRemark == null) {
                                toastError("Please Enter Admin Remark")
                                return
                            }
                            var isForeginCountry = subChapters.some(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                            if (isForeginCountry && stallAreaList[i].StallArea == 9 && countryId == 91) {
                                this.setState({ minAreaPop1: true, InternationalArea: 0, IAbare: 0, IAshell: 0, isShowInternationalArea: false })
                                return
                            }
                            if (isForeginCountry && stallAreaList[i].StallArea == 18 && countryId == 91) {
                                this.setState({ minAreaPop2: true })
                                return
                            }
                            // var toNewForm = false
                            // var toNewCountry = ''
                            // var toNewCountryId = ''
                            // if (this.state.regCountry.toLowerCase().trim() == 'india') {
                            //     console.log('toNewForm2')
                            //     for (var i = 0; i < list.length; i++) {
                            //         if (list[i].ManufacturingCountry != undefined && list[i].ManufacturingCountry != null && list[i].ManufacturingCountry != '') {
                            //             console.log('toNewForm3')
                            //             if (list[i].ManufacturingCountry.toLowerCase().trim() != 'india' && list[i].isMachine) {
                            //                 console.log('toNewForm')
                            //                 toNewForm = true
                            //                 toNewCountry = list[i].ManufacturingCountry.toLowerCase().trim()
                            //                 break
                            //             }
                            //         } else {
                            //             toastError("Please Enter Manufacturing Country")
                            //             return
                            //         }
                            //     }
                            //     if (toNewForm) {
                            //         if (toNewCountry != undefined && toNewCountry != null && toNewCountry != '') {
                            //             var isMatch = false
                            //             for (var i = 0; i < countryList.length; i++) {
                            //                 if (toNewCountry == countryList[i].Description.toLowerCase().trim()) {
                            //                     isMatch = true
                            //                     toNewCountryId = countryList[i].Code
                            //                     break
                            //                 }
                            //             }
                            //             if (isMatch) {
                            //                 this.setState({
                            //                     newPopCountry: toNewCountryId,
                            //                     toNewPop: true
                            //                 })
                            //                 return
                            //             } else {
                            //                 toastError("Please Enter Proper Manufacturing Country Name")
                            //                 return
                            //             }
                            //         } else {
                            //             toastError("Please Enter Manufacturing Country")
                            //             return
                            //         }
                            //     }
                            //     // const isAllMachineDoc = list.every(item => item.isMachine != undefined && item.IsAccessory != undefined && (item.isMachine || item.IsAccessory) ? item.DocDeleted ? item.DocumentType != '' && item.DocumentFile != '' : item.DocumentPath != '' : true)
                            //     // if (!isAllMachineDoc) {
                            //     //     toastError("Please Enter Document")
                            //     //     return
                            //     // }
                            // }
                            if ((toShowPop) && this.state.isUpdatePerm == false) {
                                this.setState({ isLoading: true })
                                this.props.updateExhibitorSpacebookingEstimate_action(this.state.stallArea, this.state.area, this.state.stallTypeId, this.state.openSlides, this.state.isDoubleStorey, this.state.isDoubleStorey ? this.state.doubleStoreyArea : null, JSON.parse(sessionStorage.getItem('ExhibitorAccessData')).CountryName.toLowerCase().trim() == 'india' ? this.state.InternationalArea != "" && this.state.InternationalArea != null ? this.state.InternationalArea : 0 : 0, this.state.isSSi, list)
                                    .then((data) => {
                                        if (data.error != 1) {
                                            console.log(data.data[0])
                                            for (var i = 0; i < data.data[0].length; i++) {
                                                if (data.data[0][i].Description.includes("--")) {
                                                    data.data[0][i].Description = data.data[0][i].Description.replace(/\n/g, ' ')
                                                    data.data[0][i].Description = data.data[0][i].Description.replace(/--/g, '\n')
                                                }
                                            }
                                            this.setState({
                                                newestimateDetails: data.data[0].length > 0 ? data.data[0] : '',
                                                estimatePop: true
                                            })
                                            this.setState({ isLoading: false })

                                        } else {
                                            this.setState({ isLoading: false })
                                            toastError(data.msg)
                                        }
                                    }).catch((err) => {
                                        console.log(err)
                                    })

                            } else {
                                if (this.state.selectedPrimaryChapterIdList.length == 1) {
                                    this.setState({ defaultprimaryChapterIdErr: '' })
                                }
                                if (selectedPrimaryChapterId == null || selectedPrimaryChapterId == '') {
                                    if (this.state.selectedPrimaryChapterIdList.length > 1) {
                                        this.setState({ defaultprimaryChapterIdErr: 'Please select default primary chapter.' })
                                        console.log("1")
                                    } else {
                                        this.setState({ primaryChapterIdErr: 'Please select primary chapter.' })
                                        console.log("2")
                                    }
                                    return
                                    iserror = true;
                                }
                                var primaryChapterList = []
                                var multiselectErr = false
                                primaryChapterListData.length > 0 && primaryChapterListData.map(item => {
                                    if (item.isChecked) {
                                        primaryChapterList.push(item)
                                    }
                                })
                                if (primaryChapterList.length > 1) {
                                    // emailValidator(ExhPrimaryUndertakingEmail) != '' && this.setState({ ExhPrimaryUndertakingEmailErr: emailValidator(ExhPrimaryUndertakingEmail) })
                                    // multiselectErr = emailValidator(ExhPrimaryUndertakingEmail) != '' ? true : false
                                    // if (ExhPrimaryUndertakingPersonName == '' || ExhPrimaryUndertakingPersonName == null) {
                                    //     this.setState({ ExhPrimaryUndertakingPersonNameErr: 'Please enter Person Name' })
                                    //     multiselectErr = true
                                    // }
                                    // if (ExhPrimaryUndertakingMobileNo == '' || ExhPrimaryUndertakingMobileNo == null) {
                                    //     this.setState({ ExhPrimaryUndertakingMobileNoErr: 'Please enter Person Mobile' })
                                    //     multiselectErr = true
                                    // }
                                    // if (ExhPrimaryUndertakingEmail == '' || ExhPrimaryUndertakingEmail == null) {
                                    //     this.setState({ ExhPrimaryUndertakingEmailErr: 'Please enter Person Email' })
                                    //     multiselectErr = true
                                    // }
                                    // if (ExhPrimaryUndertakingDesignation == '' || ExhPrimaryUndertakingDesignation == null) {
                                    //     this.setState({ ExhPrimaryUndertakingDesignationErr: 'Please enter Person Designation' })
                                    //     multiselectErr = true
                                    // }
                                    // if (ExhPrimaryUndertakingCompanyName == '' || ExhPrimaryUndertakingCompanyName == null) {
                                    //     this.setState({ ExhPrimaryUndertakingCompanyNameErr: 'Please enter Exhibitor Company Name' })
                                    //     multiselectErr = true
                                    // }
                                    if (ExhPrimaryChapterComment == '' || ExhPrimaryChapterComment == null) {
                                        this.setState({ ExhPrimaryChapterCommentErr: 'Please Enter Primary Chapter Comment' })
                                        multiselectErr = true
                                    }
                                }
                                if (isSSIExhibition) {
                                    if (!isSSi) {
                                        // if (!isSSIdeleted) {
                                        await this.handleSSIDelete()
                                        // }
                                        // if (!isTMMAITAMMAdeleted) {
                                        await this.handleTMMAITAMMADelete()
                                        // }
                                    }
                                }
                                console.log(this.state.isSSi,
                                    isSSIExhibition && isSSi ? (this.state.TMMAITAMMA == 1 ? 'TMMA' : this.state.TMMAITAMMA == 2 ? 'ITAMMA' : null) : null,
                                    isSSIExhibition && isSSi ? (this.state.isSSi == true ? isSSIfile : null) : null,
                                    isSSIExhibition && isSSi ? ((this.state.TMMAITAMMA != '' && this.state.TMMAITAMMA != null) ? TMMA_ITAMMAfile : null) : null,
                                    isSSIExhibition && isSSi ? (this.state.isSSi == true ? isSSIfileType : null) : null,
                                    isSSIExhibition && isSSi ? ((this.state.TMMAITAMMA != '' && this.state.TMMAITAMMA != null) ? TMMA_ITAMMAfiletype : null) : null,
                                    this.state.isSSifilePath,
                                    this.state.TMMAITAMMAfilePath)
                                for (var a = 0; a < compareObjArr.length; a++) {
                                    if (compareObjArr[a].name == "regCompany") { compareObjArr[a].newValue = regCompany }
                                    if (compareObjArr[a].name == "fasciaName") { compareObjArr[a].newValue = fasciaName }
                                    if (compareObjArr[a].name == "regAdd1") { compareObjArr[a].newValue = regAdd1 }
                                    if (compareObjArr[a].name == "regAdd2") { compareObjArr[a].newValue = regAdd2 }
                                    if (compareObjArr[a].name == "regCity") { compareObjArr[a].newValue = regCity }
                                    if (compareObjArr[a].name == "regState") { compareObjArr[a].newValue = regState }
                                    if (compareObjArr[a].name == "regPin") { compareObjArr[a].newValue = regPin }
                                    if (compareObjArr[a].name == "regCountry") { compareObjArr[a].newValue = regCountry }
                                    if (compareObjArr[a].name == "personInchFirst") { compareObjArr[a].newValue = personInchFirst }
                                    if (compareObjArr[a].name == "personInchLast") { compareObjArr[a].newValue = personInchLast }
                                    if (compareObjArr[a].name == "regDesignation") { compareObjArr[a].newValue = regDesignation }
                                    if (compareObjArr[a].name == "regMob1") { compareObjArr[a].newValue = this.state.regMob1 != '' && this.state.regMob1 != null ? this.state.preRegMob1 != '' && this.state.preRegMob1 != null ? `${this.state.preRegMob1}-${this.state.regMob1}` : `${this.state.regMob1}` : '' }
                                    if (compareObjArr[a].name == "regMob2") { compareObjArr[a].newValue = this.state.regMob2 != '' && this.state.regMob2 != null ? this.state.preRegMob2 != '' && this.state.preRegMob2 != null ? `${this.state.preRegMob2}-${this.state.regMob2}` : `${this.state.regMob2}` : '' }
                                    if (compareObjArr[a].name == "regTel") { compareObjArr[a].newValue = this.state.regTel != '' && this.state.regTel != null ? this.state.preRegTel != '' && this.state.preRegTel != null ? `${this.state.preRegTel}-${this.state.regTel}` : `${this.state.regTel}` : '' }
                                    if (compareObjArr[a].name == "regTel1") { compareObjArr[a].newValue = this.state.regTel1 != '' && this.state.regTel1 != null ? this.state.preRegTel1 != '' && this.state.preRegTel1 != null ? `${this.state.preRegTel1}-${this.state.regTel1}` : `${this.state.regTel1}` : '' }
                                    if (compareObjArr[a].name == "regTelFax") { compareObjArr[a].newValue = regTelFax }
                                    if (compareObjArr[a].name == "regPrimaryEmail") { compareObjArr[a].newValue = regPrimaryEmail }
                                    if (compareObjArr[a].name == "regSecondaryEmail") { compareObjArr[a].newValue = regSecondaryEmail }
                                    if (compareObjArr[a].name == "regWeb") { compareObjArr[a].newValue = regWeb }
                                    if (compareObjArr[a].name == "ownerNameFirst") { compareObjArr[a].newValue = ownerNameFirst }
                                    if (compareObjArr[a].name == "ownerNameLast") { compareObjArr[a].newValue = ownerNameLast }
                                    if (compareObjArr[a].name == "ownerDesignation") { compareObjArr[a].newValue = ownerDesignation }
                                    if (compareObjArr[a].name == "ownerMob") { compareObjArr[a].newValue = this.state.ownerMob != '' && this.state.ownerMob != null ? this.state.preOwnerMob != '' && this.state.preOwnerMob != null ? `${this.state.preOwnerMob}-${this.state.ownerMob}` : `${this.state.ownerMob}` : '' }
                                    if (compareObjArr[a].name == "ownerEmail") { compareObjArr[a].newValue = ownerEmail }

                                    if (compareObjArr[a].name == "billCompany") { compareObjArr[a].newValue = billCompany }
                                    if (compareObjArr[a].name == "billAdd1") { compareObjArr[a].newValue = billAdd1 }
                                    if (compareObjArr[a].name == "billAdd2") { compareObjArr[a].newValue = billAdd2 }
                                    if (compareObjArr[a].name == "billCity") { compareObjArr[a].newValue = billCity }
                                    if (compareObjArr[a].name == "billState") { compareObjArr[a].newValue = billState }
                                    if (compareObjArr[a].name == "billPin") { compareObjArr[a].newValue = billPin }
                                    if (compareObjArr[a].name == "billCountry") { compareObjArr[a].newValue = billCountry }
                                    if (compareObjArr[a].name == "billPersonInchFirst") { compareObjArr[a].newValue = billPersonInchFirst }
                                    if (compareObjArr[a].name == "billPersonInchLast") { compareObjArr[a].newValue = billPersonInchLast }
                                    if (compareObjArr[a].name == "billDesignation") { compareObjArr[a].newValue = billDesignation }
                                    if (compareObjArr[a].name == "billMob1") { compareObjArr[a].newValue = this.state.billMob1 != '' && this.state.billMob1 != null ? this.state.preBillMob1 != '' && this.state.preBillMob1 != null ? `${this.state.preBillMob1}-${this.state.billMob1}` : `${this.state.billMob1}` : '' }
                                    if (compareObjArr[a].name == "billMob2") { compareObjArr[a].newValue = this.state.billMob2 != '' && this.state.billMob2 != null ? this.state.preBillMob2 != '' && this.state.preBillMob2 != null ? `${this.state.preBillMob2}-${this.state.billMob2}` : `${this.state.billMob2}` : '' }
                                    if (compareObjArr[a].name == "billTel") { compareObjArr[a].newValue = this.state.billTel != '' && this.state.billTel != null ? this.state.preBillTel != '' && this.state.preBillTel != null ? `${this.state.preBillTel}-${this.state.billTel}` : `${this.state.billTel}` : '' }
                                    if (compareObjArr[a].name == "billTel1") { compareObjArr[a].newValue = this.state.billTel1 != '' && this.state.billTel1 != null ? this.state.preBillTel1 != '' && this.state.preBillTel1 != null ? `${this.state.preBillTel1}-${this.state.billTel1}` : `${this.state.billTel1}` : '' }
                                    if (compareObjArr[a].name == "billTelFax") { compareObjArr[a].newValue = billTelFax }
                                    if (compareObjArr[a].name == "billPrimaryEmail") { compareObjArr[a].newValue = billPrimaryEmail }
                                    if (compareObjArr[a].name == "billSecondaryEmail") { compareObjArr[a].newValue = billSecondaryEmail }
                                    if (compareObjArr[a].name == "billWeb") { compareObjArr[a].newValue = billWeb }

                                    if (compareObjArr[a].name == "panName") { compareObjArr[a].newValue = panName }
                                    if (compareObjArr[a].name == "panNo") { compareObjArr[a].newValue = panNo }
                                    if (compareObjArr[a].name == "tanNo") { compareObjArr[a].newValue = tanNo }
                                    if (compareObjArr[a].name == "gstNo") { compareObjArr[a].newValue = gstNo }
                                    if (compareObjArr[a].name == "companyRegNo") { compareObjArr[a].newValue = companyRegNo }
                                    if (compareObjArr[a].name == "iecCode") { compareObjArr[a].newValue = iecCode }
                                    if (compareObjArr[a].name == "accName") { compareObjArr[a].newValue = accName }
                                    if (compareObjArr[a].name == "accNo") { compareObjArr[a].newValue = accNo }
                                    if (compareObjArr[a].name == "accType") { compareObjArr[a].newValue = accType }
                                    if (compareObjArr[a].name == "bankName") { compareObjArr[a].newValue = bankName }
                                    if (compareObjArr[a].name == "branchName") { compareObjArr[a].newValue = branchName }
                                    if (compareObjArr[a].name == "ifsc") { compareObjArr[a].newValue = ifsc }

                                    if (compareObjArr[a].name == "primaryChapterName") {
                                        var chpName = ''
                                        for (var i = 0; i < primaryChapterListData.length > 0; i++) {
                                            if (primaryChapterListData[i].ChapterID == parseInt(this.state.selectedPrimaryChapterId)) {
                                                chpName = primaryChapterListData[i].ChapterName
                                            }
                                        }
                                        compareObjArr[a].newValue = chpName
                                    }
                                    if (compareObjArr[a].name == "stallTypeId") {
                                        for (var b = 0; b < this.state.stallTypeIdList.length; b++) {
                                            if (stallTypeId == this.state.stallTypeIdList[b].Code) {
                                                compareObjArr[a].newValue = this.state.stallTypeIdList[b].Description
                                            }
                                            if (compareObjArr[a].oldValue == this.state.stallTypeIdList[b].Code) {
                                                compareObjArr[a].oldValue = this.state.stallTypeIdList[b].Description
                                            }
                                        }
                                    }
                                    if (compareObjArr[a].name == "area") { compareObjArr[a].newValue = this.state.area }
                                    if (compareObjArr[a].name == "openSlides") {
                                        for (var b = 0; b < this.state.openSideList.length; b++) {
                                            if (openSlides == this.state.openSideList[b].OpenSidesID) {
                                                compareObjArr[a].newValue = this.state.openSideList[b].OpenSideName
                                            }
                                            if (compareObjArr[a].oldValue == this.state.openSideList[b].OpenSidesID) {
                                                compareObjArr[a].oldValue = this.state.openSideList[b].OpenSideName
                                            }
                                        }
                                    }
                                    if (compareObjArr[a].name == "doubleStoreyArea") { compareObjArr[a].newValue = this.state.isDoubleStorey ? parseFloat(this.state.doubleStoreyArea) : 0 }
                                    if (compareObjArr[a].name == "InternationalArea") { compareObjArr[a].newValue = this.state.isShowInternationalArea ? parseFloat(InternationalArea) : 0 }
                                    if (compareObjArr[a].name == "ExhPrimaryChapterComment") { compareObjArr[a].newValue = ExhPrimaryChapterComment }
                                    if (compareObjArr[a].name == "comment") { compareObjArr[a].newValue = comment }

                                    if (compareObjArr[a].name == "AuthorizedPersonName") { compareObjArr[a].newValue = AuthorizedPersonName }
                                    if (compareObjArr[a].name == "DesignationAuthorizedPerson") { compareObjArr[a].newValue = DesignationAuthorizedPerson }
                                    if (compareObjArr[a].name == "ExhibitorCompanyName") { compareObjArr[a].newValue = ExhibitorCompanyName }
                                    if (compareObjArr[a].name == "EmailAuthorizedPerson") { compareObjArr[a].newValue = EmailAuthorizedPerson }
                                    if (compareObjArr[a].name == "ExibitChapterList") { compareObjArr[a].newValue = this.state.subChapters.length }
                                    if (compareObjArr[a].name == "ExibitChapterList") {
                                        if (compareObjArr[a].newValue != compareObjArr[a].oldValue) {
                                            for (var b = 0; b < compareObjArr.length; b++) {
                                                if (compareObjArr[b].name == 'isExhibitDetailsModify') {
                                                    compareObjArr[b].newValue = 'Yes'
                                                    compareObjArr[b].isUpdated = true
                                                }
                                            }
                                        } else {
                                            var isChange = false
                                            for (var b = 0; b < subChapters.length; b++) {
                                                if (this.state.oldsubChapters[b].Breadth != subChapters[b].Breadth) {
                                                    isChange = true
                                                }
                                                if (this.state.oldsubChapters[b].Area != subChapters[b].Area) {
                                                    isChange = true
                                                }
                                                if (this.state.oldsubChapters[b].ChapterID != subChapters[b].ChapterID) {
                                                    isChange = true
                                                }
                                                if (this.state.oldsubChapters[b].DocumentType != subChapters[b].DocumentType) {
                                                    isChange = true
                                                }
                                                if (this.state.oldsubChapters[b].FloorCapacity != subChapters[b].FloorCapacity) {
                                                    isChange = true
                                                }
                                                if (this.state.oldsubChapters[b].HSNCode != subChapters[b].HSNCode) {
                                                    isChange = true
                                                }
                                                if (this.state.oldsubChapters[b].Height != subChapters[b].Height) {
                                                    isChange = true
                                                }
                                                if (this.state.oldsubChapters[b].IsAccessory != subChapters[b].IsAccessory) {
                                                    isChange = true
                                                }
                                                if (this.state.oldsubChapters[b].Length != subChapters[b].Length) {
                                                    isChange = true
                                                }
                                                if (this.state.oldsubChapters[b].MachineDetails != subChapters[b].MachineDetails) {
                                                    isChange = true
                                                }
                                                if (this.state.oldsubChapters[b].MachineWeight != subChapters[b].MachineWeight) {
                                                    isChange = true
                                                }
                                                if (this.state.oldsubChapters[b].ManufacturerName != subChapters[b].ManufacturerName) {
                                                    isChange = true
                                                }
                                                if (this.state.oldsubChapters[b].ManufacturingCountry != subChapters[b].ManufacturingCountry) {
                                                    isChange = true
                                                }
                                                if (this.state.oldsubChapters[b].isBrochure != subChapters[b].isBrochure) {
                                                    isChange = true
                                                }
                                                if (this.state.oldsubChapters[b].isMachine != subChapters[b].isMachine) {
                                                    isChange = true
                                                }
                                            }
                                            if (isChange) {
                                                for (var b = 0; b < compareObjArr.length; b++) {
                                                    if (compareObjArr[b].name == 'isExhibitDetailsModify') {
                                                        compareObjArr[b].newValue = 'Yes'
                                                        compareObjArr[b].isUpdated = true
                                                    }
                                                }
                                            }
                                        }
                                    }

                                }
                                for (var a = 0; a < compareObjArr.length; a++) {
                                    if (compareObjArr[a].name != 'isExhibitDetailsModify') {
                                        if (compareObjArr[a].newValue != compareObjArr[a].oldValue) {
                                            compareObjArr[a].isUpdated = true
                                        } else {
                                            compareObjArr[a].isUpdated = false
                                        }
                                    }
                                }
                                this.setState({
                                    compareObjArr: compareObjArr
                                }, () => {
                                    console.log('compareObjArr', compareObjArr)
                                    this.setState({ isLoading: true })
                                    this.props.edit_exhibitorSpaceBoking_action(isCorrespondence, exbRegNo, regCountryId, billCountryId, regCompany, fasciaName, regAdd1, regAdd2,
                                        regCity, regState, regPin, regCountry, (isOtherPreFixPersonInch ? otherPersonInchFirst : preFixPersonInch),
                                        personInchFirst, personInchLast, regDesignation,
                                        regMob1, regMob2, regTel, regTel1, regTelFax, regPrimaryEmail, regSecondaryEmail, regWeb,
                                        (isOtherOwnerFirstName ? otherOwnerFirstName : preOwnerNameFirst), ownerNameFirst, ownerNameLast, ownerDesignation, ownerMob, ownerEmail, billCompany, billAdd1,
                                        billAdd2, billCity, billState, billPin, billCountry, (isOtherBillPersonInchFirst ? otherBillPersonInchFirst : preFixBillPersonInch), billPersonInchFirst,
                                        billPersonInchLast, billDesignation, billMob1, billMob2, billTel, billTel1, billTelFax, billPrimaryEmail,
                                        billSecondaryEmail, billWeb, panName, panNo, tanNo, gstNo, companyRegNo, iecCode, accName, accNo,
                                        accType == "Others" ? accTypeOthers : accType, bankName, branchName, ifsc, selectedPrimaryChapterId != '' && selectedPrimaryChapterId != null ? parseInt(selectedPrimaryChapterId) : parseInt(primaryChapterId), list,
                                        isDoubleStorey,
                                        this.state.isDoubleStorey ? parseFloat(this.state.doubleStoreyArea) : null,
                                        this.state.isSSi,
                                        isSSIExhibition && isSSi ? (this.state.TMMAITAMMA == 1 ? 'TMMA' : this.state.TMMAITAMMA == 2 ? 'ITAMMA' : null) : null,
                                        isSSIExhibition && isSSi ? (this.state.isSSi == true ? isSSIfile : null) : null,
                                        isSSIExhibition && isSSi ? ((this.state.TMMAITAMMA != '' && this.state.TMMAITAMMA != null) ? TMMA_ITAMMAfile : null) : null,
                                        isSSIExhibition && isSSi ? (this.state.isSSi == true ? isSSIfileType : null) : null,
                                        isSSIExhibition && isSSi ? ((this.state.TMMAITAMMA != '' && this.state.TMMAITAMMA != null) ? TMMA_ITAMMAfiletype : null) : null,
                                        this.state.isSSifilePath,
                                        this.state.TMMAITAMMAfilePath,
                                        comment,
                                        ExhPrimaryChapterComment,
                                        this.state.openSlides,
                                        this.state.area,
                                        parseInt(this.state.stallArea),
                                        parseInt(this.state.stallTypeId),
                                        JSON.parse(sessionStorage.getItem('ExhibitorAccessData')).CountryName.toLowerCase().trim() == 'india' ? this.state.InternationalArea != "" && this.state.InternationalArea != null ? this.state.InternationalArea : 0 : 0,
                                        this.state.isUpdatePerm,
                                        compareObjArr,
                                        this.state.IS_SSI_Manual_Approved,
                                        AuthorizedPersonName,
                                        DesignationAuthorizedPerson,
                                        ExhibitorCompanyName,
                                        EmailAuthorizedPerson,
                                        MobileAuthorizedPerson,
                                        primaryChapterList,
                                        ExhPrimaryUndertakingPersonName,
                                        ExhPrimaryUndertakingDesignation,
                                        ExhPrimaryUndertakingCompanyName,
                                        ExhPrimaryUndertakingEmail,
                                        PreExhPrimaryUndertakingMobileNo != null && PreExhPrimaryUndertakingMobileNo != '' ? `${PreExhPrimaryUndertakingMobileNo}-${ExhPrimaryUndertakingMobileNo}` : ExhPrimaryUndertakingMobileNo,
                                        isOpenAgree,
                                        JSON.parse(sessionStorage.getItem('ExhibitorAccessData')).CountryName.toLowerCase().trim() == 'india' ? this.state.isMixRuleAgree : false)
                                        .then((data) => {
                                            if (data.error != 1) {
                                                // , isDoubleStorey, DoubleStoreyArea, isSSICertified, TMMA_ITAMMA, isSSICertifiedFile, TMMA_ITAMMAFile, isSSICertifiedFiletype, TMMA_ITAMMAfileType, ssiFilepath, TMMA_ITAMMAfilepath
                                                console.log("EditSpaceBooking", data.data)
                                                toastSuccess("Data Updated Successfully")
                                                setTimeout(() => {
                                                    this.setState({ isLoading: false, isSSIfileType: '', TMMA_ITAMMAfiletype: '', isSSIdeleted: true, isSSIreplaced: true, isLoad1stTime: false, isSSifileErr: '', TMMAITAMMAfileErr: '', isUpdatePerm: false, estimatePop: false, prefferedPopAsk: false })
                                                    this.getSpaceBookingDetails()
                                                    this.props.navigate('/exhibitorlist')
                                                }, 300);
                                            } else {
                                                this.setState({ isLoading: false })
                                                toastError(data.msg)
                                            }
                                        }).catch((err) => {
                                            console.log(err)
                                        })
                                })
                            }
                        }
                        else {
                            toastError("Please Correct Length And Breadth Size")
                        }
                    }
                    else {
                        toastError("Enter Mandatory Fields")
                    }
                }
            }
            else {
                toastError("Enter Mandatory Fields")
            }
        })
    }

    handleChapterDocDelete(e) {
        const { isSSIandTMMAITAMMMA, delChapterID, subChapters, } = this.state
        e != undefined && e.preventDefault()
        const { isDel2Open, logoImg, exhRegistrationID, isDel1Open, exhibitionID, SSIDocumentPath, isSSifile, isSSIdeleted, TMMAITAMMAfile, isTMMAITAMMAdeleted } = this.state
        this.setState({ isLoading: true })
        this.props.deleteChapterDoc_action(parseInt(JSON.parse(sessionStorage.getItem('ExhibitorAccessData')).ExhRegistrationID), parseInt(sessionStorage.getItem('sessionExhibitionID')), delChapterID)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess(" Document Deleted SuccessFully")
                    subChapters.map(item => {
                        if (item.ChapterID == delChapterID) {
                            item.DocumentName = ''
                            item.DocumentType = ''
                            item.DocumentFile = ''
                            item.DocumentPath = ''
                            item.DocDeleted = true
                        }
                    })
                    this.setState({ isLoading: false, isDel3Open: false, subChapters: subChapters })
                } else {
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
                console.log(error)
            })
    }


    onChapterDocDelete(id, i) {
        const { isDel3Open, subChapters } = this.state
        console.log(id)
        if (!subChapters[i].DocDeleted) {
            this.setState({ isDel3Open: !isDel3Open, delChapterID: id })
        } else {
            subChapters[i].DocumentType = ''
            subChapters[i].DocumentFile = ''
            subChapters[i].DocumentName = ''
            this.setState({ subChapters: subChapters })
        }
    }

    onGSTchange(value) {
        const { gstNo, gstNoErr, gstValidtionList, regState, stateId } = this.state
        var code = value
        console.log(code.length, 'rere', stateId)
        if (code.length >= 2) {
            var code = value.slice(0, 2)
            console.log(code.length, gstValidtionList, 'rere')
            console.log('stateId', stateId)
            for (var i = 0; i < gstValidtionList.length; i++) {
                if (stateId != '' && stateId != null) {
                    if (gstValidtionList[i].StateID == stateId) {
                        const errMsg = gstNoValidator(value)
                        console.log("errMsg-->", errMsg)
                        if (errMsg != '') {
                            this.setState({
                                gstNoErr: "Please enter proper gst no",
                                gstNo: value,
                                // gstNo: ''
                            });
                        } else if (parseInt(gstValidtionList[i].GSTCode) != code) {
                            console.log("2--->",)
                            this.setState({
                                gstNoErr: "Please enter proper gst no",
                                gstNo: value,
                                // gstNo: ''
                            });
                        } else {
                            this.setState({
                                gstNo: value,
                                gstNoErr: ''
                            })
                        }
                    } else {
                        this.setState({
                            gstNo: value,
                        });
                    }
                } else {
                    if (gstValidtionList[i].StateName.trim().toLowerCase() == regState.trim().toLowerCase()) {
                        const errMsg = gstNoValidator(value)
                        console.log("errMsg-->", errMsg)
                        if (errMsg != '') {
                            this.setState({
                                gstNoErr: "Please enter proper gst no",
                                gstNo: value,
                                // gstNo: ''
                            });
                        } else if (parseInt(gstValidtionList[i].GSTCode) != code) {
                            console.log("2--->",)
                            this.setState({
                                gstNoErr: "Please enter proper gst no",
                                gstNo: value,
                                // gstNo: ''
                            });
                        } else {
                            this.setState({
                                gstNo: value,
                                gstNoErr: ''
                            })
                        }
                    } else {
                        this.setState({
                            gstNo: value,
                        });
                    }
                }
                // console.log(code, gstValidtionList[i].StateID, stateId, parseInt(gstValidtionList[i].GSTCode))
            }
        }
        else {
            this.setState({
                gstNo: value,
            });
        }
    }

    // Get Space Booking Details
    getSpaceBookingDetails() {
        const { namePrefix, isSSifileType, ExhibitDetailsNote, internationalAreaSlabList, selectedPrimaryChapterIdList, TMMAITAMMAfileType } = this.state
        this.setState({ isLoading: true })
        this.props.getDetails_exhibitorSpaceBooking_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("Get Space Booking Details", data.data)
                    console.log("00000000000", data.data['primaryChapterListDetails'])
                    const countryId = data.data['registrationDetails'][0]['CountryID'] ? data.data['registrationDetails'][0]['CountryID'] : ''

                    // Primary Chapter Name 
                    const primaryChapterList = data.data['primaryChapterListDetails']['primaryChapter'].filter(obj => obj.IsSelect == true)
                    console.log('primaryChapterListprimaryChapterList', primaryChapterList)
                    const primaryChpName = primaryChapterList.length > 0 ? primaryChapterList[0].ChapterName : ''
                    const PrimaryChapId = primaryChapterList.length > 0 ? primaryChapterList[0].ChapterID : ''
                    this.setState({
                        isShowExhPrimaryChapterComment: primaryChapterList.length > 1 ? true : false
                    })

                    // Chapter Level 2 Level 3 And Level 4
                    var allChap = []
                    const level2 = data.data['primaryChapterListDetails']['level2'].filter(obj => obj.IsSelect == true)
                    allChap.push(...level2)
                    const level3 = data.data['primaryChapterListDetails']['level3'].filter(obj => obj.IsSelect == true)
                    allChap.push(...level3)
                    const level4 = data.data['primaryChapterListDetails']['level4'].filter(obj => obj.IsSelect == true)
                    allChap.push(...level4)

                    //filterinh all sub chapters only checkbox
                    var finalSubChap = allChap.filter(element => element.IsCheckbox == true)


                    // Primary Chapter Stall Area
                    const primaryChapterStallArea = data.data['primaryChapterHeaderDetails'][0].ExhibitionStallSizeID


                    if (data.data['primaryChapterHeaderDetails'][0].SSIDocumentPath != null && data.data['primaryChapterHeaderDetails'][0].SSIDocumentPath != '') {
                        var filePath = data.data['primaryChapterHeaderDetails'][0].SSIDocumentPath
                        var array = data.data['primaryChapterHeaderDetails'][0].SSIDocumentPath != null &&
                            data.data['primaryChapterHeaderDetails'][0].SSIDocumentPath != "" && filePath.split("/")
                        const FileName = array[array.length - 1]
                        this.setState({
                            isSSifilePath: filePath,
                            isSSifile: FileName,
                            isSSIdeleted: false,
                            isSSIreplaced: false,
                        })
                        console.log("here")
                    }
                    if (data.data['primaryChapterHeaderDetails'][0].TMMA_ITAMMA_DocumentPath != null && data.data['primaryChapterHeaderDetails'][0].TMMA_ITAMMA_DocumentPath != '') {
                        var filePath = data.data['primaryChapterHeaderDetails'][0].TMMA_ITAMMA_DocumentPath
                        var array = data.data['primaryChapterHeaderDetails'][0].TMMA_ITAMMA_DocumentPath != null &&
                            data.data['primaryChapterHeaderDetails'][0].TMMA_ITAMMA_DocumentPath != "" && filePath.split("/")
                        const FileName = array[array.length - 1]
                        this.setState({
                            TMMAITAMMAfilePath: filePath,
                            TMMAITAMMAfile: FileName,
                            isTMMAITAMMAdeleted: false,
                            isTAMMAITAMMAreplaced: false
                        })
                    }
                    // data.data['primaryChapterHeaderDetails'].length > 0 ? data.data['primaryChapterHeaderDetails'] : '',
                    console.log(data.data['primaryChapterHeaderDetails'][0].isDoubleStorey)
                    this.setState({
                        isDoubleStorey: data.data['primaryChapterHeaderDetails'][0].isDoubleStorey,
                        oldisDoubleStorey: data.data['primaryChapterHeaderDetails'][0].isDoubleStorey,
                        isSSi: data.data['primaryChapterHeaderDetails'][0].isSSICertified,
                        oldisSSI: data.data['primaryChapterHeaderDetails'][0].isSSICertified,
                        doubleStoreyArea: data.data['primaryChapterHeaderDetails'][0].DoubleStoreyArea,
                        InternationalArea: data.data['primaryChapterHeaderDetails'][0].InternationalArea,
                        olddoubleStoreyArea: data.data['primaryChapterHeaderDetails'][0].DoubleStoreyArea,
                        TMMAITAMMA: data.data['primaryChapterHeaderDetails'][0].TMMA_ITAMMA != null ? data.data['primaryChapterHeaderDetails'][0].TMMA_ITAMMA == 'TMMA' ? 1 : 2 : '',
                        // TMMAITAMMAfilePath: data.data[0].TMMA_ITAMMA_DocumentPath
                    })
                    // Fill List Calling ForDropDown
                    this.getFillList(countryActionId, '', '', countryId, '', '');
                    this.getFillList(stateActionId, '', '', countryId, '', '');
                    this.getFillList(cityActionId, '', '', countryId, '', '');
                    this.getFillList(pincodeActionId, '', '', countryId, '', '');
                    this.getFillList(GSTvalidationActionId, '', "", countryId, "", "").then(() => {
                        console.log("stateList data------->1", data.data);
                        this.state.gstValidtionList.map(item => {
                            if (item.regState == data.data['registrationDetails'][0]['State']) {
                                this.setState({ stateId: item.StateID })
                            }
                        })
                    });

                    // Split Phone Numbers and country Code 
                    // Registration Mobile No
                    var mob1 = data.data['registrationDetails'][0]['MobileNo']
                    const parts = mob1.split("-");
                    const regMob1Code = parts[0]
                    const regMob1No = parts[1]
                    // Registration Alternate Mobile No
                    var mob2 = data.data['registrationDetails'][0]['AlternateMobileNo']
                    const parts2 = mob2.split("-")
                    const regMob2Code = parts2[0]
                    const regMob2No = parts2[1]
                    // Registration Telephone No
                    var tel = data.data['registrationDetails'][0]['Telephone']
                    var parts3 = tel.split("-")
                    const regTelCode = parts3[0]
                    const regTelNo = parts3[1]
                    // Registration Telephone No 
                    var tel1 = data.data['registrationDetails'][0]['Telephone1']
                    const parts4 = tel1.split("-")
                    const tel1Code = parts4[0]
                    const tel1No = parts4[1]
                    // Registration Owner Mobile No 
                    var ownerMobile = data.data['registrationDetails'][0]['Mobile']
                    const parts5 = ownerMobile.split("-")
                    const ownerMobileCode = parts5[0]
                    const ownerMobileNumber = parts5[1]
                    // Invoice Mobile No
                    var invMob = data.data['registrationDetails'][0]['InvMobileNo']
                    const parts6 = invMob.split("-")
                    const invMobCode = parts6[0]
                    const invMobNo = parts6[1]
                    // Invoice Alternate Mob No
                    var invMob2 = data.data['registrationDetails'][0]['InvAlternateMobileNo']
                    const parts7 = invMob2.split("-")
                    const invMob2Code = parts7[0]
                    const invMob2No = parts7[1]
                    // Invoice TelePhone No 
                    var invTel = data.data['registrationDetails'][0]['InvTelephone']
                    const parts8 = invTel.split("-")
                    const invTelCode = parts8[0]
                    const invTelNo = parts8[1]
                    // Invoice TelePhone 1 No 
                    var invTel1 = data.data['registrationDetails'][0]['InvTelephone1']
                    const parts9 = invTel1.split("-")
                    const invTel1Code = parts9[0]
                    const invTel1No = parts9[1]

                    console.log(new Date().setHours(0, 0, 0, 0) > new Date(moment(data.data['registrationDetails'][0]['DueDate'], "DD-MM-YYYY").format("YYYY-MM-DD")).setHours(0, 0, 0, 0), '///////////////', data.data['registrationDetails'][0]['DueDate'], new Date().setHours(0, 0, 0, 0), new Date(moment(data.data['registrationDetails'][0]['DueDate'], "DD-MM-YYYY").format("YYYY-MM-DD")),)
                    this.setState({
                        dueDate: data.data['registrationDetails'][0]['DueDate'] != null && data.data['registrationDetails'][0]['DueDate'] != '' && data.data['registrationDetails'][0]['DueDate'] != undefined ? new Date(moment(data.data['registrationDetails'][0]['DueDate'], "DD-MM-YYYY").format("YYYY-MM-DD")) : ''
                    })

                    async function seqnoFormat(arr) {
                        for (var i = 0; i < arr.length; i++) {
                            if (arr[i].seqno != '' && arr[i].seqno != null) {
                                arr[i].ChapterName.trim()
                                // console.log(arr[i].ChapterName)
                                if (/^\d$/.test(arr[i].ChapterName[0])) {
                                    for (var j = 0; j < arr[i].ChapterName.length; j++) {
                                        if (arr[i].ChapterName[j] == ' ') {
                                            var str = arr[i].ChapterName.slice(j)
                                            var finalName = arr[i].seqno + str
                                            arr[i].ChapterName = finalName
                                            // console.log("primaryChapterListActionId 121212", i, finalName)
                                            break
                                        }
                                    }
                                } else {
                                    var str = arr[i].ChapterName
                                    var finalName = arr[i].seqno + ' ' + str
                                    arr[i].ChapterName = finalName
                                }
                            }
                        }
                        return
                    }
                    for (var i = 0; i < data.data['primaryChapterListDetails']['primaryChapter'].length; i++) {
                        for (var j = 0; j < data.data['primaryChapterListDetails']['primaryChapter'].length - 1 - i; j++) {
                            var seq1 = data.data['primaryChapterListDetails']['primaryChapter'][j].seqno
                            var seq2 = data.data['primaryChapterListDetails']['primaryChapter'][j + 1].seqno
                            if ((parseFloat(seq1) > parseFloat(seq2))) {
                                var temp = data.data['primaryChapterListDetails']['primaryChapter'][j]
                                data.data['primaryChapterListDetails']['primaryChapter'][j] = data.data['primaryChapterListDetails']['primaryChapter'][j + 1]
                                data.data['primaryChapterListDetails']['primaryChapter'][j + 1] = temp;
                                // console.log(i, j, arr[j])
                            }
                        }
                        if (data.data['primaryChapterListDetails']['primaryChapter'][i].seqno == null || data.data['primaryChapterListDetails']['primaryChapter'][i].seqno == undefined) {
                            console.log(data.data['primaryChapterListDetails']['primaryChapter'][i].seqno, i)
                        }
                        // seqnoFormat(data.data['primaryChapterListDetails']['primaryChapter'])
                    }
                    for (var i = 0; i < data.data['primaryChapterListDetails']['level2'].length; i++) {
                        for (var j = 0; j < data.data['primaryChapterListDetails']['level2'].length - 1 - i; j++) {
                            var seq1 = data.data['primaryChapterListDetails']['level2'][j].seqno
                            var seq2 = data.data['primaryChapterListDetails']['level2'][j + 1].seqno
                            if ((parseFloat(seq1) > parseFloat(seq2))) {
                                var temp = data.data['primaryChapterListDetails']['level2'][j]
                                data.data['primaryChapterListDetails']['level2'][j] = data.data['primaryChapterListDetails']['level2'][j + 1]
                                data.data['primaryChapterListDetails']['level2'][j + 1] = temp;
                                // console.log(i, j, arr[j])
                            }
                        }
                        if (data.data['primaryChapterListDetails']['level2'][i].seqno == null || data.data['primaryChapterListDetails']['level2'][i].seqno == undefined) {
                            console.log(data.data['primaryChapterListDetails']['level2'][i].seqno, i)
                        }
                        seqnoFormat(data.data['primaryChapterListDetails']['level2'])
                    }
                    // console.log("prr", data.data['level2'])
                    for (var i = 0; i < data.data['primaryChapterListDetails']['level3'].length; i++) {
                        for (var j = 0; j < data.data['primaryChapterListDetails']['level3'].length - 1 - i; j++) {

                            var seq1 = data.data['primaryChapterListDetails']['level3'][j].seqno
                            seq1 = seq1 != null && seq1.replaceAll('.', '')
                            var seq2 = data.data['primaryChapterListDetails']['level3'][j + 1].seqno
                            seq2 = seq2 != null && seq2.replaceAll('.', '')

                            if ((parseFloat(seq1) > parseFloat(seq2))) {
                                var temp = data.data['primaryChapterListDetails']['level3'][j]
                                data.data['primaryChapterListDetails']['level3'][j] = data.data['primaryChapterListDetails']['level3'][j + 1]
                                data.data['primaryChapterListDetails']['level3'][j + 1] = temp;
                            }
                        }
                        if (data.data['primaryChapterListDetails']['level3'][i].seqno == null || data.data['primaryChapterListDetails']['level3'][i].seqno == undefined) {
                            console.log(data.data['primaryChapterListDetails']['level3'][i].seqno, i)
                        }
                        seqnoFormat(data.data['primaryChapterListDetails']['level3'])
                    }
                    for (var i = 0; i < data.data['primaryChapterListDetails']['level4'].length; i++) {
                        for (var j = 0; j < data.data['primaryChapterListDetails']['level4'].length - 1 - i; j++) {
                            var seq1 = data.data['primaryChapterListDetails']['level4'][j].seqno
                            seq1 = seq1 != null && seq1.replaceAll('.', '')
                            var seq2 = data.data['primaryChapterListDetails']['level4'][j + 1].seqno
                            seq2 = seq2 != null && seq2.replaceAll('.', '')
                            if ((parseFloat(seq1) > parseFloat(seq2))) {
                                var temp = data.data['primaryChapterListDetails']['level4'][j]
                                data.data['primaryChapterListDetails']['level4'][j] = data.data['primaryChapterListDetails']['level4'][j + 1]
                                data.data['primaryChapterListDetails']['level4'][j + 1] = temp;
                                // console.log(i, j, arr[j])
                            }
                        }
                        if (data.data['primaryChapterListDetails']['level4'][i].seqno == null || data.data['primaryChapterListDetails']['level4'][i].seqno == undefined) {
                            console.log(data.data['primaryChapterListDetails']['level4'][i].seqno, i)
                        }
                        seqnoFormat(data.data['primaryChapterListDetails']['level4'])
                    }
                    // for (var i = 0; i < data.data['primaryChapterListDetails']['primaryChapter'].length; i++) {
                    //     for (var j = 0; j < data.data['primaryChapterListDetails']['primaryChapter'].length - 1 - i; j++) {
                    //         var seq1 = data.data['primaryChapterListDetails']['primaryChapter'][j].seqno
                    //         var seq2 = data.data['primaryChapterListDetails']['primaryChapter'][j + 1].seqno
                    //         if ((parseFloat(seq1) > parseFloat(seq2))) {
                    //             var temp = data.data['primaryChapterListDetails']['primaryChapter'][j]
                    //             data.data['primaryChapterListDetails']['primaryChapter'][j] = data.data['primaryChapterListDetails']['primaryChapter'][j + 1]
                    //             data.data['primaryChapterListDetails']['primaryChapter'][j + 1] = temp;
                    //             // console.log(i, j, arr[j])
                    //         }
                    //     }
                    //     if (data.data['primaryChapterListDetails']['primaryChapter'][i].seqno == null || data.data['primaryChapterListDetails']['primaryChapter'][i].seqno == undefined) {
                    //         // console.log(data.data['primaryChapter'][i].seqno, i)
                    //     }
                    //     // seqnoFormat(data.data['primaryChapter'])
                    // }

                    for (var i = 0; i < data.data['primaryChapterListDetails']['level2'].length; i++) {
                        data.data['primaryChapterListDetails']['level2'][i].isHighlight = false;
                    }

                    var exhibitlist = []
                    // console.log("level2 get", level2)
                    data.data['primaryChapterListDetails']['level2'].length > 0 && data.data['primaryChapterListDetails']['level2'].map(level2Data => {
                        level2Data.DocumentName = ''
                        level2Data.DocumentType = ''
                        level2Data.DocumentFile = ''
                        level2Data.DocumentPath = ''
                        level2Data.DocDeleted = true
                        if (level2Data.IsSelect && level2Data.IsCheckbox) {
                            // console.log("level2Data get", level2Data)
                            var temppath = (level2Data.isMachine || level2Data.IsAccessory) ? level2Data.Document : ''
                            var temparr = temppath != null &&
                                temppath != "" ? temppath.split("/") : []
                            var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
                            level2Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
                            level2Data.DocumentType = ''
                            level2Data.DocumentFile = ''
                            level2Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
                            level2Data.DocDeleted = temppath != '' && temppath != null ? false : true
                            level2Data.Area = parseFloat(level2Data.Length || 0) * parseFloat(level2Data.Breadth || 0)
                            exhibitlist.push(level2Data)
                        }
                    })
                    data.data['primaryChapterListDetails']['level3'].length > 0 && data.data['primaryChapterListDetails']['level3'].map(level3Data => {
                        level3Data.DocumentName = ''
                        level3Data.DocumentType = ''
                        level3Data.DocumentFile = ''
                        level3Data.DocumentPath = ''
                        level3Data.DocDeleted = true
                        if (level3Data.IsSelect && level3Data.IsCheckbox) {
                            var temppath = (level3Data.isMachine || level3Data.IsAccessory) ? level3Data.Document : ''
                            var temparr = temppath != null &&
                                temppath != "" ? temppath.split("/") : []
                            var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
                            level3Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
                            level3Data.DocumentType = ''
                            level3Data.DocumentFile = ''
                            level3Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
                            level3Data.DocDeleted = temppath != '' && temppath != null ? false : true
                            level3Data.Area = parseFloat(level3Data.Length || 0) * parseFloat(level3Data.Breadth || 0)
                            exhibitlist.push(level3Data)
                        }
                    })
                    data.data['primaryChapterListDetails']['level4'].length > 0 && data.data['primaryChapterListDetails']['level4'].map(level4Data => {
                        level4Data.DocumentName = ''
                        level4Data.DocumentType = ''
                        level4Data.DocumentFile = ''
                        level4Data.DocumentPath = ''
                        level4Data.DocDeleted = true
                        if (level4Data.IsSelect && level4Data.IsCheckbox) {
                            var temppath = (level4Data.isMachine || level4Data.IsAccessory) ? level4Data.Document : ''
                            var temparr = temppath != null &&
                                temppath != "" ? temppath.split("/") : []
                            var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
                            level4Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
                            level4Data.DocumentType = ''
                            level4Data.DocumentFile = ''
                            level4Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
                            level4Data.DocDeleted = temppath != '' && temppath != null ? false : true
                            level4Data.Area = parseFloat(level4Data.Length || 0) * parseFloat(level4Data.Breadth || 0)
                            exhibitlist.push(level4Data)
                        }
                    })
                    exhibitlist.sort((a, b) => (a.ChapterID > b.ChapterID) ? 1 : -1);
                    data.data['primaryChapterListDetails']['level0'].length > 0 && data.data['primaryChapterListDetails']['level0'].map(level0Data => {
                        level0Data.DocumentName = ''
                        level0Data.DocumentType = ''
                        level0Data.DocumentFile = ''
                        level0Data.DocumentPath = ''
                        level0Data.DocDeleted = true
                        if (level0Data.IsSelect) {
                            // console.log("level2Data get", level2Data)
                            var temppath = (level0Data.isMachine || level0Data.IsAccessory) ? level0Data.Document : ''
                            var temparr = temppath != null &&
                                temppath != "" ? temppath.split("/") : []
                            var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
                            level0Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
                            level0Data.DocumentType = ''
                            level0Data.DocumentFile = ''
                            level0Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
                            level0Data.DocDeleted = temppath != '' && temppath != null ? false : true
                            level0Data.Area = parseFloat(level0Data.Length || 0) * parseFloat(level0Data.Breadth || 0)
                            exhibitlist.push(level0Data)
                        }
                    })
                    const totalArea = exhibitlist.reduce((sum, obj) => sum + obj.Area, 0)
                    // if (data.data['primaryChapterHeaderDetails'][0].StallArea < totalArea) {
                    //     this.setState({ lengthWidthErr: 'Total area of sum cannot be greater than stall area' })
                    // } else {
                    //     this.setState({ lengthWidthErr: '' })
                    // }
                    console.log('exhibitlist==', exhibitlist)
                    const filterArray = exhibitlist.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                    // const filterArrayBroSome = exhibitlist.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                    // var total = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                    // if (filterArrayBroSome) {
                    //     console.log('totaltotal', total, data.data['primaryChapterHeaderDetails'][0].StallArea, internationalAreaSlabList, filterArray)
                    //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
                    //         console.log(data.data['primaryChapterHeaderDetails'][0].StallArea, total)
                    //         if (internationalAreaSlabList[i].FromRange < data.data['primaryChapterHeaderDetails'][0].StallArea && data.data['primaryChapterHeaderDetails'][0].StallArea <= internationalAreaSlabList[i].ToRange) {
                    //             if (total >= internationalAreaSlabList[i].MinArea) {
                    //                 total = total
                    //             } else {
                    //                 total = internationalAreaSlabList[i].MinArea
                    //             }
                    //         }
                    //     }
                    // }
                    var totalBare = 0
                    var totalShell = 0
                    exhibitlist.length > 0 && exhibitlist.map(item => {
                        if (item.SinglePhasePower == '' || item.SinglePhasePower == null) {
                            item.SinglePhasePower = 0
                        }
                        if (item.ThreePhasePower == '' || item.ThreePhasePower == null) {
                            item.ThreePhasePower = 0
                        }
                        if (item.WaterConsumption == '' || item.WaterConsumption == null) {
                            item.WaterConsumption = 0
                        }
                        if (item.InletQuantity == '' || item.InletQuantity == null) {
                            item.InletQuantity = 0
                        }
                        if (item.OutletQuantity == '' || item.OutletQuantity == null) {
                            item.OutletQuantity = 0
                        }
                        if (item.MaxCompressedAir == '' || item.MaxCompressedAir == null) {
                            item.MaxCompressedAir = 0
                        }
                        item.errArr = []
                        if (data.data['registrationDetails'][0]['CountryID'] != 91) {
                            item.CalculatedArea = 0
                            item.ShellScheme = ''
                        }
                        if (item.ShellScheme == 1) {
                            totalBare = totalBare + item.CalculatedArea
                        }
                        if (item.ShellScheme == 2) {
                            totalShell = totalShell + item.CalculatedArea
                        }
                    })
                    var isAllBrochure = true
                    if (filterArray.length > 0) {
                        for (var i = 0; i < filterArray.length; i++) {
                            if (filterArray[i].IsAccessory || filterArray[i].isMachine) {
                                isAllBrochure = false
                            }
                        }
                    }
                    this.setState({
                        subChapters: exhibitlist, IAbare: totalBare, IAshell: totalShell, isShowInternationalArea: filterArray.length > 0, isAllBro: filterArray.length > 0 ? isAllBrochure : false
                        //  InternationalArea: filterArray.length > 0 ? total : 0 
                    }, () => {
                        setTimeout(() => {
                            // this.adjustIntAreaNew(data.data['primaryChapterHeaderDetails'][0].StallArea, 1)
                        }, 200);
                    })

                    var checkboxArr = []
                    var ExhibitDetailsNoteArr = []
                    if (data.data['estimateNote'] != undefined) {
                        // for (var i = 0; i < data.data['estimateNote'].length; i++) {
                        //     if (data.data['estimateNote'][i].NoteType == 'Estimate Checkbox Note') {
                        //         console.log('data.data[', data.data['estimateNote'])
                        //         var obj = {}
                        //         obj.label = data.data['estimateNote'][i].Description
                        //         obj.value = data.data['estimateNote'][i].ExhRegistrationNotesId
                        //         obj.checked = false
                        //         obj.ExhRegistrationNotesId = data.data['estimateNote'][i].ExhRegistrationNotesId
                        //         // if (JSON.parse(sessionStorage.getItem('loginDataSS')).CountryName.toLowerCase().trim() != 'India ') {
                        //         data.data['estimateNote'][i].ExhRegistrationNotesId == 19 && checkboxArr.push(obj)
                        //         // }
                        //         // else {
                        //         //     checkboxArr.push(obj)
                        //         // }
                        //     }
                        // }
                        this.setState({
                            ExhibitDetailsNote: []
                        }, () => {
                            for (var i = 0; i < data.data['estimateNote'].length; i++) {
                                if (data.data['estimateNote'][i].NoteType == 'Estimate Checkbox Note') {
                                    var obj = {}
                                    obj.label = data.data['estimateNote'][i].Description
                                    obj.value = data.data['estimateNote'][i].ExhRegistrationNotesId
                                    obj.checked = false
                                    obj.ExhRegistrationNotesId = data.data['estimateNote'][i].ExhRegistrationNotesId
                                    // if (JSON.parse(sessionStorage.getItem('loginDataSS')).CountryName.toLowerCase().trim() != 'India ') {
                                    // data.data['estimateNote'][i].ExhRegistrationNotesId == 1041 && checkboxArr.push(obj)
                                    if (data.data['estimateNote'][i]['Description'].toLowerCase().includes('claims')) {
                                        if (data.data['configurationDetails'][0]['isAgreeClaim']) {
                                            checkboxArr.push(obj)
                                        }
                                    }
                                    if (data.data['estimateNote'][i]['Description'].toLowerCase().includes('rules and regulation')) {
                                        if (data.data['configurationDetails'][0]['isAgreeRule']) {
                                            checkboxArr.push(obj)
                                        }
                                    }
                                    if (data.data['estimateNote'][i]['Description'].toLowerCase().includes('manufactured')) {
                                        if (data.data['configurationDetails'][0]['isAgreeMFG']) {
                                            checkboxArr.push(obj)
                                        }
                                    }
                                    // if (data.data['estimateNote'][i]['Description'].toLowerCase().includes('undertaking')) {
                                    //     if (data.data['configurationDetails'][0]['isAgreeUndertaking']) {
                                    //         checkboxArr.push(obj)
                                    //     }
                                    // }
                                    if (data.data['estimateNote'][i]['Description'].toLowerCase().includes('email') && data.data['estimateNote'][i]['Description'].toLowerCase().includes('sms') && data.data['estimateNote'][i]['Description'].toLowerCase().includes('whatsapp')) {
                                        if (data.data['configurationDetails'][0]['isAgreeConsent']) {
                                            checkboxArr.push(obj)
                                        }
                                    }

                                    this.setState({
                                        isFlag1: data.data['configurationDetails'][0]['isAgreeClaim'],
                                        isFlag3: data.data['configurationDetails'][0]['isAgreeMFG'],
                                        isFlag4: data.data['configurationDetails'][0]['isAgreeRule'],
                                        isFlag5: false,
                                        isFlag6: data.data['configurationDetails'][0]['isAgreeConsent'],
                                    })

                                    // }
                                    // else {
                                    //     checkboxArr.push(obj)
                                    // }
                                }
                                if (data.data['estimateNote'][i].NoteType == 'exhibit details') {
                                    ExhibitDetailsNoteArr.push(data.data['estimateNote'][i])
                                }

                            }
                        })
                        // else {
                        // if (JSON.parse(sessionStorage.getItem('loginDataSS')).CountryName.toLowerCase().trim() != 'India ') {
                        //     checkboxArr.pop()
                        //     checkboxArr.pop()
                        // }

                        // }
                    }
                    console.log('checkboxArr', checkboxArr)
                    console.log("id1------------>", checkboxArr)
                    for (var i = 0; i < checkboxArr.length; i++) {
                        if (checkboxArr[i].label.includes('claims')) {
                            checkboxArr[i].checked = data.data['descriptionDetails'][0]['Is_AgreeClaim'] != null ? data.data['descriptionDetails'][0]['Is_AgreeClaim'] : false
                        }
                        // if (checkboxArr[i].ExhRegistrationNotesId == 1041) {
                        if (checkboxArr[i].label.includes('Rules and Regulation')) {
                            checkboxArr[i].checked = data.data['descriptionDetails'][0]['Is_AgreeRules'] != null ? data.data['descriptionDetails'][0]['Is_AgreeRules'] : false
                        }
                        if (checkboxArr[i].label.includes('manufactured')) {
                            checkboxArr[i].checked = data.data['descriptionDetails'][0]['Is_AgreeMFG'] != null ? data.data['descriptionDetails'][0]['Is_AgreeMFG'] : false
                        }
                        if (checkboxArr[i].label.includes('undertaking')) {
                            checkboxArr[i].checked = data.data['descriptionDetails'][0]['isAgreeUndertaking'] != null ? data.data['descriptionDetails'][0]['isAgreeUndertaking'] : false
                        }
                        if (checkboxArr[i].label.toLowerCase().includes('email') && checkboxArr[i].label.toLowerCase().includes('sms') && checkboxArr[i].label.toLowerCase().includes('whatsapp')) {
                            checkboxArr[i].checked = data.data['descriptionDetails'][0]['isAgreeConsent'] != null ? data.data['descriptionDetails'][0]['isAgreeConsent'] : false
                        }
                    }
                    // for (var i = 0; i < checkboxArr.length; i++) {
                    //     if (checkboxArr[i].ExhRegistrationNotesId == 18) {
                    //         checkboxArr[i].checked = data.data['descriptionDetails'][0]['Is_AgreeClaim'] != null ? data.data['descriptionDetails'][0]['Is_AgreeClaim'] : false
                    //     }
                    //     if (checkboxArr[i].ExhRegistrationNotesId == 19) {
                    //         checkboxArr[i].checked = data.data['descriptionDetails'][0]['Is_AgreeRules'] != null ? data.data['descriptionDetails'][0]['Is_AgreeRules'] : false
                    //     }
                    //     if (checkboxArr[i].ExhRegistrationNotesId == 20) {
                    //         checkboxArr[i].checked = data.data['descriptionDetails'][0]['Is_AgreeMFG'] != null ? data.data['descriptionDetails'][0]['Is_AgreeMFG'] : false
                    //     }
                    //     if (checkboxArr[i].ExhRegistrationNotesId == 21) {
                    //         checkboxArr[i].checked = data.data['descriptionDetails'][0]['isAgreeUndertaking'] != null ? data.data['descriptionDetails'][0]['isAgreeUndertaking'] : false
                    //     }
                    // }
                    // estimateDetails: data.data['estimateDetails'].length > 0 ? data.data['estimateDetails'] : '',
                    console.log(data.data['estimateDetails'], '/////////////////////////////////////////////')
                    for (var i = 0; i < data.data['estimateDetails'].length; i++) {
                        if (data.data['estimateDetails'][i].Description.includes("--")) {
                            data.data['estimateDetails'][i].Description = data.data['estimateDetails'][i].Description.replace(/\n/g, ' ')
                            data.data['estimateDetails'][i].Description = data.data['estimateDetails'][i].Description.replace(/--/g, '\n')
                        }
                    }
                    var undertakingContent = []
                    data.data['descriptionDetails'][0]['UndertakingContent1'] != null && data.data['descriptionDetails'][0]['UndertakingContent1'] != undefined && undertakingContent.push(data.data['descriptionDetails'][0]['UndertakingContent1'])
                    data.data['descriptionDetails'][0]['UndertakingContent2'] != null && data.data['descriptionDetails'][0]['UndertakingContent2'] != undefined && undertakingContent.push(data.data['descriptionDetails'][0]['UndertakingContent2'])
                    // data.data['descriptionDetails'][0]['UndertakingContent3'] != null && data.data['descriptionDetails'][0]['UndertakingContent3'] != undefined && undertakingContent.push(data.data['descriptionDetails'][0]['UndertakingContent3'])
                    data.data['descriptionDetails'][0]['UndertakingContent5'] != null && data.data['descriptionDetails'][0]['UndertakingContent5'] != undefined && undertakingContent.push(data.data['descriptionDetails'][0]['UndertakingContent5'])
                    data.data['descriptionDetails'][0]['UndertakingContent4'] != null && data.data['descriptionDetails'][0]['UndertakingContent4'] != undefined && undertakingContent.push(data.data['descriptionDetails'][0]['UndertakingContent4'])
                    var multiSelectNotes = []
                    // var exhibitDetailsNote = []
                    for (var i = 0; i < data.data['estimateNote'].length; i++) {
                        // if (data.data[1][i].NoteType == 'Guidelines') {
                        //     guideLines.push(data.data[1][i])
                        // }
                        // if (data.data[1][i].NoteType == 'Chapter Notes') {
                        //     notes.push(data.data[1][i])
                        // }
                        if (data.data['estimateNote'][i].NoteType == 'PrimaryChapter MultiSelect') {
                            multiSelectNotes.push(data.data['estimateNote'][i])
                        }
                        // if (data.data[1][i].NoteType == 'exhibit details') {
                        //     exhibitDetailsNote.push(data.data[1][i])
                        // }
                    }
                    console.log(data.data['registrationDetails'][0].PrimaryChapter, "data.data['primaryChapterHeaderDetails']")
                    var primaryChapterListTemp = data.data['registrationDetails'][0].PrimaryChapter != null ? typeof data.data['registrationDetails'][0].PrimaryChapter == 'string' ? data.data['registrationDetails'][0].PrimaryChapter.split(',') : [data.data['registrationDetails'][0].PrimaryChapter] : []
                    if (primaryChapterListTemp.length > 0) {
                        for (var i = 0; i < primaryChapterListTemp.length; i++) {
                            primaryChapterListTemp[i] = typeof primaryChapterListTemp[i] == 'string' ? parseInt(primaryChapterListTemp[i].trim()) : primaryChapterListTemp[i]
                        }
                    }
                    var mainPrimary = data.data['primaryChapterHeaderDetails'][0].PrimaryChapter != null ? data.data['primaryChapterHeaderDetails'][0].PrimaryChapter : ''
                    this.setState({
                        isLoading: false,
                        MultiSelectNotes: multiSelectNotes,
                        countryId: data.data['registrationDetails'][0]['CountryID'] != null ? data.data['registrationDetails'][0]['CountryID'] : '',
                        adminRemark: data.data['registrationDetails'][0]['AdminRemark'] != null ? data.data['registrationDetails'][0]['AdminRemark'] : '',
                        isCorrespondence: data.data['registrationDetails'][0]['SameAsCorrespondence'] != null ? data.data['registrationDetails'][0]['SameAsCorrespondence'] : '',
                        undertakingContent: undertakingContent,
                        exbRegNo: data.data['registrationDetails'][0]['ExhRegistrationNo'] != null ? data.data['registrationDetails'][0]['ExhRegistrationNo'] : '',
                        personInchFirst: data.data['registrationDetails'][0]['PersonIncharge'] != null ? data.data['registrationDetails'][0]['PersonIncharge'] : '',
                        preFixPersonInch: data.data['registrationDetails'][0]['Title_PersonIncharge'] != null ? data.data['registrationDetails'][0]['Title_PersonIncharge'] : '',
                        checkboxList: checkboxArr,
                        ExhibitDetailsNote: ExhibitDetailsNoteArr,
                        // InternationalArea: data.data['registrationDetails'][0]['InternationalArea'] != null ? data.data['registrationDetails'][0]['InternationalArea'] : '',
                        isOtherPreFixPersonInch: data.data['registrationDetails'][0]['Title_PersonIncharge'] != null && data.data['registrationDetails'][0]['Title_PersonIncharge'] != "" && namePrefix.includes(data.data['registrationDetails'][0]['Title_PersonIncharge']) ? false : true,
                        personInchLast: data.data['registrationDetails'][0]['LastNamePersonIncharge'] != null ? data.data['registrationDetails'][0]['LastNamePersonIncharge'] : '',
                        regDesignation: data.data['registrationDetails'][0]['Designation'] != null ? data.data['registrationDetails'][0]['Designation'] : '',
                        regCompany: data.data['registrationDetails'][0]['CompanyName'] != null ? data.data['registrationDetails'][0]['CompanyName'] : '',
                        fasciaName: data.data['registrationDetails'][0]['FasciaName'] != null ? data.data['registrationDetails'][0]['FasciaName'] : '',
                        regAdd1: data.data['registrationDetails'][0]['Address1'] != null ? data.data['registrationDetails'][0]['Address1'] : '',
                        regAdd2: data.data['registrationDetails'][0]['Address2'] != null ? data.data['registrationDetails'][0]['Address2'] : '',
                        regPin: data.data['registrationDetails'][0]['Pin'] != null ? data.data['registrationDetails'][0]['Pin'] : '',
                        regCity: data.data['registrationDetails'][0]['City'] != null ? data.data['registrationDetails'][0]['City'] : '',
                        regState: data.data['registrationDetails'][0]['State'] != null ? data.data['registrationDetails'][0]['State'] : '',
                        regCountry: data.data['registrationDetails'][0]['CountryName'] != null ? data.data['registrationDetails'][0]['CountryName'].trim() : '',
                        regCountryId: data.data['registrationDetails'][0]['CountryID'] != null ? data.data['registrationDetails'][0]['CountryID'] : '',
                        UUID: data.data['registrationDetails'][0]['UUID'] != null ? data.data['registrationDetails'][0]['UUID'] : '',
                        regMob1: data.data['registrationDetails'][0]['MobileNo'] != null ? regMob1No : '',
                        preRegMob1: data.data['registrationDetails'][0]['MobileNo'] != null ? regMob1Code : '',
                        PreMobileAuthorizedPerson: data.data['registrationDetails'][0]['MobileNo'] != null ? regMob1Code : '',
                        ExhPrimaryChapterComment: data.data['registrationDetails'][0]['ExhPrimaryChapterComment'] != null ? data.data['registrationDetails'][0]['ExhPrimaryChapterComment'] : '',
                        regMob2: data.data['registrationDetails'][0]['AlternateMobileNo'] != null ? regMob2No : '',
                        preRegMob2: data.data['registrationDetails'][0]['AlternateMobileNo'] != null ? regMob2Code : '',
                        regTel: data.data['registrationDetails'][0]['Telephone'] != null ? regTelNo : '',
                        preRegTel: data.data['registrationDetails'][0]['Telephone'] != null ? regTelCode : '',
                        regTel1: data.data['registrationDetails'][0]['Telephone1'] != null ? tel1No : '',
                        preRegTel1: data.data['registrationDetails'][0]['Telephone1'] != null ? tel1Code : '',
                        regTelFax: data.data['registrationDetails'][0]['TeleFax'] != null ? data.data['registrationDetails'][0]['TeleFax'] : '',
                        regPrimaryEmail: data.data['registrationDetails'][0]['PrimaryEmail'] != null ? data.data['registrationDetails'][0]['PrimaryEmail'] : '',
                        regSecondaryEmail: data.data['registrationDetails'][0]['SecondaryEmail'] != null ? data.data['registrationDetails'][0]['SecondaryEmail'] : '',
                        regWeb: data.data['registrationDetails'][0]['Website'] != null ? data.data['registrationDetails'][0]['Website'] : '',
                        ownerNameFirst: data.data['registrationDetails'][0]['Name_Of_CEO_MD_President_Owner'] != null ? data.data['registrationDetails'][0]['Name_Of_CEO_MD_President_Owner'] : '',
                        preOwnerNameFirst: data.data['registrationDetails'][0]['Title_Name_Of_CEO_MD_President_Owner'] != null ? data.data['registrationDetails'][0]['Title_Name_Of_CEO_MD_President_Owner'] : '',
                        isOtherOwnerFirstName: data.data['registrationDetails'][0]['Title_Name_Of_CEO_MD_President_Owner'] != null && data.data['registrationDetails'][0]['Title_Name_Of_CEO_MD_President_Owner'] != "" && namePrefix.includes(data.data['registrationDetails'][0]['Title_Name_Of_CEO_MD_President_Owner']) ? false : true,
                        ownerNameLast: data.data['registrationDetails'][0]['LastName'] != null ? data.data['registrationDetails'][0]['LastName'] : '',
                        ownerDesignation: data.data['registrationDetails'][0]['OwnerDesignation'] != null ? data.data['registrationDetails'][0]['OwnerDesignation'] : '',
                        ownerMob: data.data['registrationDetails'][0]['Mobile'] != null ? ownerMobileNumber : '',
                        preOwnerMob: data.data['registrationDetails'][0]['Mobile'] != null ? ownerMobileCode : '',
                        ownerEmail: data.data['registrationDetails'][0]['Email'] != null ? data.data['registrationDetails'][0]['Email'] : '',
                        billPersonInchFirst: data.data['registrationDetails'][0]['InvPersonIncharge'] != null ? data.data['registrationDetails'][0]['InvPersonIncharge'] : '',
                        preFixBillPersonInch: data.data['registrationDetails'][0]['Title_InvPersonIncharge'] != null ? data.data['registrationDetails'][0]['Title_InvPersonIncharge'] : '',
                        isOtherBillPersonInchFirst: data.data['registrationDetails'][0]['Title_InvPersonIncharge'] != null && data.data['registrationDetails'][0]['Title_InvPersonIncharge'] != "" && namePrefix.includes(data.data['registrationDetails'][0]['Title_InvPersonIncharge']) ? false : true,
                        billPersonInchLast: data.data['registrationDetails'][0]['InvLastNamePersonIncharge'] != null ? data.data['registrationDetails'][0]['InvLastNamePersonIncharge'] : '',
                        billDesignation: data.data['registrationDetails'][0]['InvDesignation'] != null ? data.data['registrationDetails'][0]['InvDesignation'] : '',
                        billCompany: data.data['registrationDetails'][0]['InvCompanyName'] != null ? data.data['registrationDetails'][0]['InvCompanyName'] : '',
                        billAdd1: data.data['registrationDetails'][0]['InvAddress1'] != null ? data.data['registrationDetails'][0]['InvAddress1'] : '',
                        billAdd2: data.data['registrationDetails'][0]['InvAddress2'] != null ? data.data['registrationDetails'][0]['InvAddress2'] : '',
                        billPin: data.data['registrationDetails'][0]['InvPin'] != null ? data.data['registrationDetails'][0]['InvPin'] : '',
                        billCity: data.data['registrationDetails'][0]['InvCity'] != null ? data.data['registrationDetails'][0]['InvCity'] : '',
                        billState: data.data['registrationDetails'][0]['InvState'] != null ? data.data['registrationDetails'][0]['InvState'] : '',
                        billCountry: data.data['registrationDetails'][0]['InvCountryName'] != null ? data.data['registrationDetails'][0]['InvCountryName'].trim() : '',
                        SSIMaxArea: data.data['primaryChapterHeaderDetails'][0]['SSIArea'] != null ? data.data['primaryChapterHeaderDetails'][0]['SSIArea'] : '',
                        billCountryId: data.data['registrationDetails'][0]['InvCountryID'] != null ? data.data['registrationDetails'][0]['InvCountryID'] : '',
                        billMob1: data.data['registrationDetails'][0]['InvMobileNo'] != null ? invMobNo : '',
                        preBillMob1: data.data['registrationDetails'][0]['InvMobileNo'] != null ? invMobCode : '',
                        billMob2: data.data['registrationDetails'][0]['InvAlternateMobileNo'] != null ? invMob2No : '',
                        preBillMob2: data.data['registrationDetails'][0]['InvAlternateMobileNo'] != null ? invMob2Code : '',
                        billTel: data.data['registrationDetails'][0]['InvTelephone'] != null ? invTelNo : '',
                        preBillTel: data.data['registrationDetails'][0]['InvTelephone'] != null ? invTelCode : '',
                        billTel1: data.data['registrationDetails'][0]['InvTelephone1'] != null ? invTel1No : '',
                        preBillTel1: data.data['registrationDetails'][0]['InvTelephone1'] != null ? invTel1Code : '',
                        billTelFax: data.data['registrationDetails'][0]['InvTeleFax'] != null ? data.data['registrationDetails'][0]['InvTeleFax'] : '',
                        billPrimaryEmail: data.data['registrationDetails'][0]['InvPrimaryEmail'] != null ? data.data['registrationDetails'][0]['InvPrimaryEmail'] : '',
                        billSecondaryEmail: data.data['registrationDetails'][0]['InvSecondaryEmail'] != null ? data.data['registrationDetails'][0]['InvSecondaryEmail'] : '',
                        billWeb: data.data['registrationDetails'][0]['InvWebsite'] != null ? data.data['registrationDetails'][0]['InvWebsite'] : '',
                        companyRegNo: data.data['registrationDetails'][0]['CompanyRegistrationNo'] != null ? data.data['registrationDetails'][0]['CompanyRegistrationNo'] : '',
                        panNo: data.data['registrationDetails'][0]['PanNo'] != null ? data.data['registrationDetails'][0]['PanNo'] : '',
                        panName: data.data['registrationDetails'][0]['NameOnPanCard'] != null ? data.data['registrationDetails'][0]['NameOnPanCard'] : '',
                        gstNo: data.data['registrationDetails'][0]['GSTNo'] != null ? data.data['registrationDetails'][0]['GSTNo'] : '',
                        tanNo: data.data['registrationDetails'][0]['Tan'] != null ? data.data['registrationDetails'][0]['Tan'] : '',
                        iecCode: data.data['registrationDetails'][0]['IECCode'] != null ? data.data['registrationDetails'][0]['IECCode'] : '',
                        accName: data.data['registrationDetails'][0]['AccountName'] != null ? data.data['registrationDetails'][0]['AccountName'] : '',
                        accNo: data.data['registrationDetails'][0]['AccountNo'] != null ? data.data['registrationDetails'][0]['AccountNo'] : '',
                        accType: data.data['registrationDetails'][0]['AccountType'] != null ? data.data['registrationDetails'][0]['AccountType'] : '',
                        bankName: data.data['registrationDetails'][0]['BankName'] != null ? data.data['registrationDetails'][0]['BankName'] : '',
                        branchName: data.data['registrationDetails'][0]['BranchName'] != null ? data.data['registrationDetails'][0]['BranchName'] : '',
                        ifsc: data.data['registrationDetails'][0]['SwiftCode_IFSCCode'] != null ? data.data['registrationDetails'][0]['SwiftCode_IFSCCode'] : '',
                        primaryChapterHeaderList: data.data['primaryChapterHeaderDetails'].length > 0 ? data.data['primaryChapterHeaderDetails'] : '',
                        primaryChapterName: data.data['registrationDetails'][0]['PrimaryChapterName'] != null && data.data['registrationDetails'][0]['PrimaryChapterName'] != '' ? data.data['registrationDetails'][0]['PrimaryChapterName'] : '',
                        // primaryChpName
                        subChapters: finalSubChap,
                        oldsubChapters: finalSubChap.length > 0 ? JSON.parse(JSON.stringify(finalSubChap)) : [],
                        stallArea: primaryChapterStallArea,
                        oldstallArea: primaryChapterStallArea,
                        area: data.data['primaryChapterHeaderDetails'][0].StallArea,
                        isMixRuleAgree: data.data['registrationDetails'][0].IsMixRuleAgree != null ? data.data['registrationDetails'][0].IsMixRuleAgree : false,
                        openSlides: data.data['primaryChapterHeaderDetails'][0].OpenSidesID,
                        oldopenSlides: data.data['primaryChapterHeaderDetails'][0].OpenSidesID,
                        minArea: data.data['configurationDetails'][0].DoubleStoreyArea,
                        minAreaPercent: data.data['configurationDetails'][0].DoubleStoreyAreaPercentage,
                        estimateDetails: data.data['estimateDetails'].length > 0 ? data.data['estimateDetails'] : '',
                        isAgree: data.data['descriptionDetails'][0]['Is_AgreeClaim'] != null ? data.data['descriptionDetails'][0]['Is_AgreeClaim'] : '',
                        isAgree2: data.data['descriptionDetails'][0]['Is_AgreeRules'] != null ? data.data['descriptionDetails'][0]['Is_AgreeRules'] : '',
                        isAgree3: data.data['descriptionDetails'][0]['Is_AgreeMFG'] != null ? data.data['descriptionDetails'][0]['Is_AgreeMFG'] : '',
                        primaryChapterId: mainPrimary != '' ? parseInt(mainPrimary) : '',
                        selectedPrimaryChapterId: mainPrimary != '' ? parseInt(mainPrimary) : '',
                        selectedPrimaryChapterIdList: primaryChapterListTemp.length > 0 ? primaryChapterListTemp : [],
                        // primaryChapterListData: data.data['primaryChapterListDetails']['primaryChapter'].length > 0 ? data.data['primaryChapterListDetails']['primaryChapter'] : []
                        lev2: data.data['primaryChapterListDetails']['level2'].length > 0 ? data.data['primaryChapterListDetails']['level2'] : [],
                        lev3: data.data['primaryChapterListDetails']['level3'].length > 0 ? data.data['primaryChapterListDetails']['level3'] : [],
                        lev4: data.data['primaryChapterListDetails']['level4'].length > 0 ? data.data['primaryChapterListDetails']['level4'] : [],
                        AuthorizedPersonName: data.data['descriptionDetails'][0]['ExhUndertakingPersonName'] != null ? data.data['descriptionDetails'][0]['ExhUndertakingPersonName'] : '',
                        DesignationAuthorizedPerson: data.data['descriptionDetails'][0]['ExhUndertakingDesignation'] != null ? data.data['descriptionDetails'][0]['ExhUndertakingDesignation'] : '',
                        ExhibitorCompanyName: data.data['descriptionDetails'][0]['ExhUndertakingCompanyName'] != null ? data.data['descriptionDetails'][0]['ExhUndertakingCompanyName'] : '',
                        EmailAuthorizedPerson: data.data['descriptionDetails'][0]['ExhUndertakingEmail'] != null ? data.data['descriptionDetails'][0]['ExhUndertakingEmail'] : '',
                        MobileAuthorizedPerson: data.data['descriptionDetails'][0]['ExhUndertakingMobileNo'] != null ? data.data['descriptionDetails'][0]['ExhUndertakingMobileNo'] : '',
                        StallTypeName: data.data['primaryChapterHeaderDetails'].length > 0 ? data.data['primaryChapterHeaderDetails'][0].StallTypeName : '',
                        stallTypeId: data.data['primaryChapterHeaderDetails'].length > 0 ? data.data['primaryChapterHeaderDetails'][0].StallTypeID : '',
                        isSSifileType: '',
                        oldstallTypeId: data.data['primaryChapterHeaderDetails'].length > 0 ? data.data['primaryChapterHeaderDetails'][0].StallTypeID : '',
                        isSSifileType: '',
                        TMMAITAMMAfileType: '',
                        SSIdiscount: data.data['primaryChapterHeaderDetails'].length > 0 ? data.data['primaryChapterHeaderDetails'][0].SSIDiscountStatusID : '',
                        comment: data.data['descriptionDetails'].length > 0 ? data.data['descriptionDetails'][0].Comment : '',

                        is1stPiCreated: data.data['registrationDetails'][0]['isFirstPIcreated'] != null ? data.data['registrationDetails'][0]['isFirstPIcreated'] : false,
                        is2ndPiCreated: data.data['registrationDetails'][0]['isSecondPIcreated'] != null ? data.data['registrationDetails'][0]['isSecondPIcreated'] : false,
                        IS_SSI_Manual_Approved: data.data['registrationDetails'][0]['IS_SSI_Manual_Approved'] != null ? data.data['registrationDetails'][0]['IS_SSI_Manual_Approved'] : false,
                        isReceiptGenerated: data.data['registrationDetails'][0]['isReceiptGenerate'] != null ? data.data['registrationDetails'][0]['isReceiptGenerate'] : false,
                        ExhPrimaryUndertakingMobileNo: data.data['registrationDetails'][0].ExhPrimaryUndertakingMobileNo != null ? data.data['registrationDetails'][0].ExhPrimaryUndertakingMobileNo.split('-').length == 2 ? data.data['registrationDetails'][0].ExhPrimaryUndertakingMobileNo.split('-')[1] : data.data['registrationDetails'][0].ExhPrimaryUndertakingMobileNo.split('-')[0] : '',
                        PreExhPrimaryUndertakingMobileNo: data.data['registrationDetails'][0].ExhPrimaryUndertakingMobileNo != null ? data.data['registrationDetails'][0].ExhPrimaryUndertakingMobileNo.split('-').length == 2 ? data.data['registrationDetails'][0].ExhPrimaryUndertakingMobileNo.split('-')[0] : '' : '',
                        ExhPrimaryUndertakingPersonName: data.data['registrationDetails'][0].ExhPrimaryUndertakingPersonName,
                        ExhPrimaryUndertakingDesignation: data.data['registrationDetails'][0].ExhPrimaryUndertakingDesignation,
                        ExhPrimaryUndertakingCompanyName: data.data['registrationDetails'][0].ExhPrimaryUndertakingCompanyName,
                        ExhPrimaryUndertakingEmail: data.data['registrationDetails'][0].ExhPrimaryUndertakingEmail,

                    }, () => {
                        setTimeout(() => {
                            // if (PrimaryChapId != '') {
                            for (var i = 0; i < data.data['primaryChapterListDetails']['primaryChapter'].length; i++) {
                                console.log('selectedPrimaryChapterIdListselectedPrimaryChapterIdList', data.data['primaryChapterListDetails']['primaryChapter'][i].ChapterID, selectedPrimaryChapterIdList)
                                if (primaryChapterListTemp.length > 0) {
                                    for (var j = 0; j < primaryChapterListTemp.length; j++) {
                                        if (data.data['primaryChapterListDetails']['primaryChapter'][i].ChapterID == parseInt(primaryChapterListTemp[j])) {
                                            data.data['primaryChapterListDetails']['primaryChapter'][i].isChecked = true;
                                        }
                                    }
                                } else {
                                    if (data.data['primaryChapterListDetails']['primaryChapter'][i].ChapterID == PrimaryChapId) {
                                        data.data['primaryChapterListDetails']['primaryChapter'][i].isChecked = true;
                                    } else {
                                        data.data['primaryChapterListDetails']['primaryChapter'][i].isChecked = false;
                                    }
                                }
                            }
                            data.data['primaryChapterListDetails']['primaryChapter'].filter(item => item.isChecked).length > 1 &&
                                this.setState({
                                    isOpenAgree: true,
                                })
                            data.data['primaryChapterListDetails']['primaryChapter'].sort((a, b) =>
                                a.ChapterName.toLowerCase().localeCompare(b.ChapterName.toLowerCase())
                            );
                            console.log('data.data]', data.data['primaryChapterListDetails']['primaryChapter'], data.data['primaryChapterListDetails']['primaryChapter'].filter(item => item.isChecked).length > 1)
                            this.setState({
                                primaryChapterListData: data.data['primaryChapterListDetails']['primaryChapter'],
                            })
                            // }
                            this.setState({
                                compareObjArr: [
                                    { name: 'regCompany', oldValue: this.state.regCompany, newValue: this.state.regCompany, display: 'Name of the Company' },
                                    { name: 'fasciaName', oldValue: this.state.fasciaName, newValue: this.state.fasciaName, display: 'Fascia Name (Shell Scheme Only)' },
                                    { name: 'regAdd1', oldValue: this.state.regAdd1, newValue: this.state.regAdd1, display: 'Address Line 1' },
                                    { name: 'regAdd2', oldValue: this.state.regAdd2, newValue: this.state.regAdd2, display: 'Address Line 2' },
                                    { name: 'regCity', oldValue: this.state.regCity, newValue: this.state.regCity, display: 'City' },
                                    { name: 'regState', oldValue: this.state.regState, newValue: this.state.regState, display: 'state' },
                                    { name: 'regPin', oldValue: this.state.regPin, newValue: this.state.regPin, display: 'Pincode' },
                                    { name: 'regCountry', oldValue: this.state.regCountry, newValue: this.state.regCountry, display: 'Country' },
                                    { name: 'personInchFirst', oldValue: this.state.personInchFirst, newValue: this.state.personInchFirst, display: 'First Name of Person Incharge' },
                                    { name: 'personInchLast', oldValue: this.state.personInchLast, newValue: this.state.personInchLast, display: 'Last Name of Person Incharge' },
                                    { name: 'regDesignation', oldValue: this.state.regDesignation, newValue: this.state.regDesignation, display: 'Designation' },
                                    { name: 'regMob1', oldValue: this.state.regMob1 != '' && this.state.regMob1 != null ? this.state.preRegMob1 != '' && this.state.preRegMob1 != null ? `${this.state.preRegMob1}-${this.state.regMob1}` : `${this.state.regMob1}` : '', newValue: this.state.regMob1 != '' && this.state.regMob1 != null ? this.state.preRegMob1 != '' && this.state.preRegMob1 != null ? `${this.state.preRegMob1}-${this.state.regMob1}` : `${this.state.regMob1}` : '', display: 'Mobile' },
                                    { name: 'regMob2', oldValue: this.state.regMob2 != '' && this.state.regMob2 != null ? this.state.preRegMob2 != '' && this.state.preRegMob2 != null ? `${this.state.preRegMob2}-${this.state.regMob2}` : `${this.state.regMob2}` : '', newValue: this.state.regMob2 != '' && this.state.regMob2 != null ? this.state.preRegMob2 != '' && this.state.preRegMob2 != null ? `${this.state.preRegMob2}-${this.state.regMob2}` : `${this.state.regMob2}` : '', display: 'Alternate Mobile No' },
                                    { name: 'regTel', oldValue: this.state.regTel != '' && this.state.regTel != null ? this.state.preRegTel != '' && this.state.preRegTel != null ? `${this.state.preRegTel}-${this.state.regTel}` : `${this.state.regTel}` : '', newValue: this.state.regTel != '' && this.state.regTel != null ? this.state.preRegTel != '' && this.state.preRegTel != null ? `${this.state.preRegTel}-${this.state.regTel}` : `${this.state.regTel}` : '', display: 'Telephone' },
                                    { name: 'regTel1', oldValue: this.state.regTel1 != '' && this.state.regTel1 != null ? this.state.preRegTel1 != '' && this.state.preRegTel1 != null ? `${this.state.preRegTel1}-${this.state.regTel1}` : `${this.state.regTel1}` : '', newValue: this.state.regTel1 != '' && this.state.regTel1 != null ? this.state.preRegTel1 != '' && this.state.preRegTel1 != null ? `${this.state.preRegTel1}-${this.state.regTel1}` : `${this.state.regTel1}` : '', display: 'Telephone 1' },
                                    { name: 'regTelFax', oldValue: this.state.regTelFax, newValue: this.state.regTelFax, display: 'Telefax' },
                                    { name: 'regPrimaryEmail', oldValue: this.state.regPrimaryEmail, newValue: this.state.regPrimaryEmail, display: 'Primary Email' },
                                    { name: 'regSecondaryEmail', oldValue: this.state.regSecondaryEmail, newValue: this.state.regSecondaryEmail, display: 'Secondary Email' },
                                    { name: 'regWeb', oldValue: this.state.regWeb, newValue: this.state.regWeb, display: 'Website' },
                                    { name: 'ownerNameFirst', oldValue: this.state.ownerNameFirst, newValue: this.state.ownerNameFirst, display: 'First Name of CEO/MD/President/Owner' },
                                    { name: 'ownerNameLast', oldValue: this.state.ownerNameLast, newValue: this.state.ownerNameLast, display: 'Last Name of CEO/MD/President/Owner' },
                                    { name: 'ownerDesignation', oldValue: this.state.ownerDesignation, newValue: this.state.ownerDesignation, display: 'Owner Designation' },
                                    { name: 'ownerMob', oldValue: this.state.ownerMob != '' && this.state.ownerMob != null ? this.state.preOwnerMob != '' && this.state.preOwnerMob != null ? `${this.state.preOwnerMob}-${this.state.ownerMob}` : `${this.state.ownerMob}` : '', newValue: this.state.ownerMob != '' && this.state.ownerMob != null ? this.state.preOwnerMob != '' && this.state.preOwnerMob != null ? `${this.state.preOwnerMob}-${this.state.ownerMob}` : `${this.state.ownerMob}` : '', display: 'Owner Mobile No' },
                                    { name: 'ownerEmail', oldValue: this.state.ownerEmail, newValue: this.state.ownerEmail, display: 'Owner Email' },

                                    { name: 'billCompany', oldValue: this.state.billCompany, newValue: this.state.billCompany, display: 'Invoice Details- Name of the Company' },
                                    { name: 'billAdd1', oldValue: this.state.billAdd1, newValue: this.state.billAdd1, display: 'Invoice Details- Address Line 1' },
                                    { name: 'billAdd2', oldValue: this.state.billAdd2, newValue: this.state.billAdd2, display: 'Invoice Details- Address Line 2' },
                                    { name: 'billCity', oldValue: this.state.billCity, newValue: this.state.billCity, display: 'Invoice Details- City' },
                                    { name: 'billState', oldValue: this.state.billState, newValue: this.state.billState, display: 'Invoice Details- State' },
                                    { name: 'billPin', oldValue: this.state.billPin, newValue: this.state.billPin, display: 'Invoice Details- Pincode' },
                                    { name: 'billCountry', oldValue: this.state.billCountry, newValue: this.state.billCountry, display: 'Invoice Details- Country' },
                                    { name: 'billPersonInchFirst', oldValue: this.state.billPersonInchFirst, newValue: this.state.billPersonInchFirst, display: 'Invoice Details- First Name of Person Incharge' },
                                    { name: 'billPersonInchLast', oldValue: this.state.billPersonInchLast, newValue: this.state.billPersonInchLast, display: 'Invoice Details- Last Name of Person Incharge' },
                                    { name: 'billDesignation', oldValue: this.state.billDesignation, newValue: this.state.billDesignation, display: 'Invoice Details- Designation' },
                                    { name: 'billMob1', oldValue: this.state.billMob1 != '' && this.state.billMob1 != null ? this.state.preBillMob1 != '' && this.state.preBillMob1 != null ? `${this.state.preBillMob1}-${this.state.billMob1}` : `${this.state.billMob1}` : '', newValue: this.state.billMob1 != '' && this.state.billMob1 != null ? this.state.preBillMob1 != '' && this.state.preBillMob1 != null ? `${this.state.preBillMob1}-${this.state.billMob1}` : `${this.state.billMob1}` : '', display: 'Invoice Details- Mobile 1' },
                                    { name: 'billMob2', oldValue: this.state.billMob2 != '' && this.state.billMob2 != null ? this.state.preBillMob2 != '' && this.state.preBillMob2 != null ? `${this.state.preBillMob2}-${this.state.billMob2}` : `${this.state.billMob2}` : '', newValue: this.state.billMob2 != '' && this.state.billMob2 != null ? this.state.preBillMob2 != '' && this.state.preBillMob2 != null ? `${this.state.preBillMob2}-${this.state.billMob2}` : `${this.state.billMob2}` : '', display: 'Invoice Details- Alternate Mobile No' },
                                    { name: 'billTel', oldValue: this.state.billTel != '' && this.state.billTel != null ? this.state.preBillTel != '' && this.state.preBillTel != null ? `${this.state.preBillTel}-${this.state.billTel}` : `${this.state.billTel}` : '', newValue: this.state.billTel != '' && this.state.billTel != null ? this.state.preBillTel != '' && this.state.preBillTel != null ? `${this.state.preBillTel}-${this.state.billTel}` : `${this.state.billTel}` : '', display: 'Invoice Details- Telephone No' },
                                    { name: 'billTel1', oldValue: this.state.billTel1 != '' && this.state.billTel1 != null ? this.state.preBillTel1 != '' && this.state.preBillTel1 != null ? `${this.state.preBillTel1}-${this.state.billTel1}` : `${this.state.billTel1}` : '', newValue: this.state.billTel1 != '' && this.state.billTel1 != null ? this.state.preBillTel1 != '' && this.state.preBillTel1 != null ? `${this.state.preBillTel1}-${this.state.billTel1}` : `${this.state.billTel1}` : '', display: 'Invoice Details- Telephone 1' },
                                    { name: 'billTelFax', oldValue: this.state.billTelFax, newValue: this.state.billTelFax, display: 'Invoice Details- Telefax' },
                                    { name: 'billPrimaryEmail', oldValue: this.state.billPrimaryEmail, newValue: this.state.billPrimaryEmail, display: 'Invoice Details- Primary Email' },
                                    { name: 'billSecondaryEmail', oldValue: this.state.billSecondaryEmail, newValue: this.state.billSecondaryEmail, display: 'Invoice Details- Secondary Email' },
                                    { name: 'billWeb', oldValue: this.state.billWeb, newValue: this.state.billWeb, display: 'Invoice Details- Website' },

                                    { name: 'panName', oldValue: this.state.panName, newValue: this.state.panName, display: 'PAN Card Name' },
                                    { name: 'panNo', oldValue: this.state.panNo, newValue: this.state.panNo, display: 'PAN Card no' },
                                    { name: 'tanNo', oldValue: this.state.tanNo, newValue: this.state.tanNo, display: 'TAN Number' },
                                    { name: 'gstNo', oldValue: this.state.gstNo, newValue: this.state.gstNo, display: 'GST No' },
                                    { name: 'companyRegNo', oldValue: this.state.companyRegNo, newValue: this.state.companyRegNo, display: 'Company Registration No' },
                                    { name: 'iecCode', oldValue: this.state.iecCode, newValue: this.state.iecCode, display: 'IEC Code' },
                                    { name: 'accName', oldValue: this.state.accName, newValue: this.state.accName, display: 'Bank Details- Account Name' },
                                    { name: 'accNo', oldValue: this.state.accNo, newValue: this.state.accNo, display: 'Bank Details- Account No' },
                                    { name: 'accType', oldValue: this.state.accType, newValue: this.state.accType, display: 'Bank Details- Account Type' },
                                    { name: 'bankName', oldValue: this.state.bankName, newValue: this.state.bankName, display: 'Bank Details- Bank Name' },
                                    { name: 'branchName', oldValue: this.state.branchName, newValue: this.state.branchName, display: 'Bank Details- Branch Name' },
                                    { name: 'ifsc', oldValue: this.state.ifsc, newValue: this.state.ifsc, display: 'Bank Details- IFSC Code' },


                                    { name: 'primaryChapterName', oldValue: this.state.primaryChapterName, newValue: this.state.primaryChapterName, display: 'Selected Primary Chapter' },
                                    { name: 'stallTypeId', oldValue: this.state.stallTypeId, newValue: this.state.stallTypeId, display: 'Scheme Type' },
                                    { name: 'area', oldValue: this.state.area, newValue: this.state.area, display: 'Stall Area' },
                                    { name: 'openSlides', oldValue: this.state.openSlides, newValue: this.state.openSlides, display: 'Open Sides' },
                                    { name: 'doubleStoreyArea', oldValue: this.state.isDoubleStorey && this.state.doubleStoreyArea != '' && this.state.doubleStoreyArea != null ? this.state.doubleStoreyArea : 0, newValue: this.state.isDoubleStorey && this.state.doubleStoreyArea != '' && this.state.doubleStoreyArea != null ? this.state.doubleStoreyArea : 0, display: 'Double storey Area' },
                                    // { name: 'InternationalArea', oldValue: this.state.InternationalArea, newValue: this.state.InternationalArea, display: 'International Area' },
                                    { name: 'ExhPrimaryChapterComment', oldValue: this.state.ExhPrimaryChapterComment, newValue: this.state.ExhPrimaryChapterComment, display: 'Multi Chapter Remark' },
                                    { name: 'comment', oldValue: this.state.comment, newValue: this.state.comment, display: 'Comment' },

                                    { name: 'AuthorizedPersonName', oldValue: this.state.AuthorizedPersonName, newValue: this.state.AuthorizedPersonName, display: 'Authorized Person Name' },
                                    { name: 'DesignationAuthorizedPerson', oldValue: this.state.DesignationAuthorizedPerson, newValue: this.state.DesignationAuthorizedPerson, display: 'Designation of the Authorized person' },
                                    { name: 'ExhibitorCompanyName', oldValue: this.state.ExhibitorCompanyName, newValue: this.state.ExhibitorCompanyName, display: 'Exhibitor company Name' },
                                    { name: 'EmailAuthorizedPerson', oldValue: this.state.EmailAuthorizedPerson, newValue: this.state.EmailAuthorizedPerson, display: 'Email of the Authorized person' },
                                    { name: 'MobileAuthorizedPerson', oldValue: this.state.MobileAuthorizedPerson != '' && this.state.MobileAuthorizedPerson != null ? this.state.PreMobileAuthorizedPerson != '' && this.state.PreMobileAuthorizedPerson != null ? `${this.state.PreMobileAuthorizedPerson}-${this.state.MobileAuthorizedPerson}` : `${this.state.MobileAuthorizedPerson}` : '', newValue: this.state.MobileAuthorizedPerson != '' && this.state.MobileAuthorizedPerson != null ? this.state.PreMobileAuthorizedPerson != '' && this.state.PreMobileAuthorizedPerson != null ? `${this.state.PreMobileAuthorizedPerson}-${this.state.MobileAuthorizedPerson}` : `${this.state.MobileAuthorizedPerson}` : '', display: 'Mobile No. of the Authorized person' },
                                    { name: 'ExibitChapterList', oldValue: this.state.subChapters.length, newValue: this.state.subChapters.length, display: 'No of Exhibit details product' },
                                    { name: 'isExhibitDetailsModify', oldValue: '-', newValue: 'No', display: 'Exhibit Details modified' }
                                ]
                            })
                            console.log(' data.data[][0][] ', data.data['registrationDetails'][0]['isReceiptGenerate'])

                            console.log('1', isSSifileType, '2', TMMAITAMMAfileType)
                            setTimeout(() => {
                                this.getFillList(stallTypeActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')
                                this.getFillList(openSideListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')

                                var minAreaAsModule = 0
                                for (var i = 0; i < this.state.subChapters.length; i++) {
                                    if (parseInt(data.data['primaryChapterHeaderDetails'][0].StallTypeID) == 1) {
                                        console.log('subChapters[i].MinBareArea', this.state.subChapters[i].MinBareArea)
                                        if (this.state.subChapters[i].MinBareArea != '' && this.state.subChapters[i].MinBareArea != null) {
                                            if (minAreaAsModule < this.state.subChapters[i].MinBareArea) {
                                                minAreaAsModule = this.state.subChapters[i].MinBareArea
                                            }
                                        }
                                    } else if (parseInt(data.data['primaryChapterHeaderDetails'][0].StallTypeID) == 2) {
                                        if (this.state.subChapters[i].MinShellArea != '' && this.state.subChapters[i].MinShellArea != null) {
                                            if (minAreaAsModule < this.state.subChapters[i].MinShellArea) {
                                                minAreaAsModule = this.state.subChapters[i].MinShellArea
                                            }
                                        }
                                    }
                                }
                                console.log("level2.length00000000000000000", parseInt(data.data['primaryChapterHeaderDetails'][0].StallTypeID), minAreaAsModule, this.state.subChapters)

                                this.getFillList(stallSizeActionId, sessionStorage.getItem("sessionExhibitionID"), minAreaAsModule == 0 ? '' : minAreaAsModule, data.data['primaryChapterHeaderDetails'][0].StallTypeID, countryId, '')
                                this.getFillList(fullStallAreaActionId, sessionStorage.getItem("sessionExhibitionID"), minAreaAsModule == 0 ? '' : minAreaAsModule, data.data['primaryChapterHeaderDetails'][0].StallTypeID, countryId, '').then(() => {
                                    this.setState({
                                        subChapters: exhibitlist, oldsubChapters: exhibitlist.length > 0 ? JSON.parse(JSON.stringify(exhibitlist)) : [],
                                        isShowInternationalArea: filterArray.length > 0, isAllBro: filterArray.length > 0 ? isAllBrochure : false
                                        //  InternationalArea: filterArray.length > 0 ? total : 0 
                                    }, () => {
                                        setTimeout(() => {
                                            // this.adjustIntAreaNew(data.data['primaryChapterHeaderDetails'][0].StallArea, 1)
                                            this.adjustCalculatedArea(data.data['primaryChapterHeaderDetails'][0].StallArea, 1)

                                        }, 200);
                                    })
                                })
                                this.setState({ isLoading: false })
                            }, 200)
                        }, 1000);
                    })
                    Promise.all([
                        this.getFillList(primaryChapterListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '', sessionStorage.getItem("sessionExhRegistrationID")),
                        this.getFillList(lengthActionId, sessionStorage.getItem("sessionExhibitionID"), '', data.data['primaryChapterHeaderDetails'][0].StallTypeID, countryId, ''),
                        this.getFillList(breadthActionId, sessionStorage.getItem("sessionExhibitionID"), '', data.data['primaryChapterHeaderDetails'][0].StallTypeID, countryId, ''),

                    ]).then(() => {
                        this.setState({ isLoading: false });
                    }).catch(error => {
                        console.error("Error in getFillList calls:", error);
                        this.setState({ isLoading: false });
                    });
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
    }

    handleSSIDelete(e) {
        const { isSSIExhibition, isSSi } = this.state
        e != undefined && e.preventDefault()
        return new Promise((resolve, reject) => {
            const { isDelOpen, logoImg, exhRegistrationID, isDel1Open, exhibitionID, SSIDocumentPath, isSSifile, isSSIdeleted } = this.state
            this.setState({ isLoading: true })
            this.props.deleteSSicertificate_action(parseInt(JSON.parse(sessionStorage.getItem('ExhibitorAccessData')).ExhRegistrationID), parseInt((sessionStorage.getItem('sessionExhibitionID'))))
                .then((data) => {
                    if (data.error != 1) {
                        isSSi && toastSuccess(" Document Deleted SuccessFully")
                        this.setState({ isLoading: false, isDel1Open: false, isSSifile: "", isSSifileReplacement: "", isSSIdeleted: true, })
                        console.log()
                        resolve(true)
                    } else {
                        isSSi && toastError(data.msg)
                        this.setState({ isLoading: false })
                    }
                }).catch((error) => {
                    console.log(error)
                })
        })
    }

    handleTMMAITAMMADelete(e) {
        const { isSSIExhibition, isSSi } = this.state
        e != undefined && e.preventDefault()
        return new Promise((resolve, reject) => {
            const { isDel2Open, logoImg, exhRegistrationID, isDel1Open, exhibitionID, SSIDocumentPath, isSSifile, isSSIdeleted, TMMAITAMMAfile, isTMMAITAMMAdeleted } = this.state
            this.setState({ isLoading: true })
            this.props.deleteTMMAITAMMA_action(parseInt(JSON.parse(sessionStorage.getItem('ExhibitorAccessData')).ExhRegistrationID), parseInt(sessionStorage.getItem('sessionExhibitionID')))
                .then((data) => {
                    if (data.error != 1) {
                        isSSi && toastSuccess(" Document Deleted SuccessFully")
                        this.setState({ isLoading: false, isDel2Open: false, TMMAITAMMAfile: "", isTMMAITAMMAdeleted: true, TMMAITAMMAfileReplacement: '' })
                        resolve(true)
                    } else {
                        isSSi && toastError(data.msg)
                        this.setState({ isLoading: false })
                    }
                }).catch((error) => {
                    console.log(error)
                })
        })
    }

    onSSIDocDelete() {
        const { isDel1Open } = this.state
        this.setState({ isDel1Open: !isDel1Open })
    }
    onTMMAITAMMADocDelete() {
        const { isDel2Open } = this.state
        this.setState({ isDel2Open: !isDel2Open })
    }

    onFilePickSSI = async (e, file) => {
        e.preventDefault()
        const { isSSifile } = this.state
        console.log('file', file)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {
                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFileSSI(file[0]);
                        this.setState({ isSSifileReplacement: image })
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelectSSI(file[0]);
                        this.setState({ isSSifileReplacement: image })
                    }
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")

                    }
                    this.setState({ isSSifileTypeReplacement: fileTypeList.length > 0 ? fileTypeList[1] : "", isSSifileErr: '', isSSIreplaced: true })
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                }
            }
        } else if (file.length == 0) {
            this.setState({ TMMAITAMMAfileTypeReplacement: "", TMMAITAMMAfileReplacement: '' })
            if (isSSifile != '' && isSSifile != null) {
                this.setState({ isSSIreplaced: false })
            }
        }

    }
    resizeFileSSI = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });
    onPdfSelectSSI = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });
    onCrossClickSSI() {
        console.log("pp")
        this.setState({ isSSifile: "" })
        document.getElementById("path").value = ""
        console.log(document.getElementById("path").value)
    }
    onFilePickITMATAMMA = async (e, file) => {
        e.preventDefault()
        const { TMMAITAMMAfile } = this.state
        console.log('file', file)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {
                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFileITMATAMMA(file[0]);
                        this.setState({ TMMAITAMMAfileReplacement: image })
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelectITMATAMMA(file[0]);
                        this.setState({ TMMAITAMMAfileReplacement: image })
                    }
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")

                    }
                    this.setState({ TMMAITAMMAfileTypeReplacement: fileTypeList.length > 0 ? fileTypeList[1] : "", TMMAITAMMAfileErr: '', isTAMMAITAMMAreplaced: true })
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                }
            }
        } else if (file.length == 0) {
            this.setState({ TMMAITAMMAfileTypeReplacement: "", TMMAITAMMAfileReplacement: '' })
            if (TMMAITAMMAfile != '' && TMMAITAMMAfile != null) {
                this.setState({ isTAMMAITAMMAreplaced: false })
            }
        }
    }
    resizeFileITMATAMMA = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });
    onPdfSelectITMATAMMA = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });
    onCrossClickITMATAMMA() {
        this.setState({ TMMAITAMMAfile: "" })
        document.getElementById("path2").value = ""
    }

    // Get Fill Lists
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        return new Promise((resolve, reject) => {

            this.setState({ isLoading: true })
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
                .then((data) => {
                    if (data.error != 1) {
                        // country list
                        if (actionID === countryActionId) {
                            console.log("country data", data.data)
                            this.setState({
                                countryList: data.data,
                                tempCountryList: data.data,
                                billTempCountryList: data.data,
                                isLoading: false,
                            })
                        }
                        // state list
                        if (actionID === stateActionId) {
                            console.log("stateList data", data.data)
                            this.setState({
                                stateList: data.data,
                                tempStateList: data.data,
                                billTempStateList: data.data,
                                isLoading: false,
                            })
                        }

                        if (actionID === stallTypeActionId) {
                            // console.log("country data", data.data)
                            this.setState({
                                stallTypeIdList: data.data,
                            })
                            if (data.data.length == 1) {
                                this.onstallTypeIdChange(null, data.data[0].Code)
                            }
                            // resolve(true)
                        }
                        if (actionID === internationalAreaSlabActionId) {
                            // console.log("country data", data.data)
                            this.setState({
                                internationalAreaSlabList: data.data,
                            })
                            resolve(true)
                        }
                        if (actionID === openSideListActionId) {
                            // console.log("country data", data.data)
                            this.setState({
                                openSideList: data.data,
                            })
                            // resolve(true)
                        }
                        if (actionID === fullStallAreaActionId) {
                            // console.log("country data", data.data)
                            this.setState({
                                referenceStallAreaArr: data.data,
                            })
                            resolve(true)
                        }
                        // stall Size
                        if (actionID === stallSizeActionId) {
                            // console.log("country data", data.data)
                            this.setState({
                                stallAreaList: data.data,
                            })
                            if (this.state.stallArea != '') {
                                for (var i = 0; i < data.data.length; i++) {
                                    if (data.data[i].Code == this.state.stallArea) {
                                        console.log('Description : ', data.data[i].Description);
                                        this.setState({ stallAreaName: data.data[i].Description })
                                    }
                                }
                            }
                            resolve(true)
                        }
                        // city list
                        if (actionID === cityActionId) {
                            console.log("city data", data.data)
                            this.setState({
                                cityList: data.data,
                                tempCityList: data.data,
                                billTempCityList: data.data,
                                isLoading: false,
                            })
                        }
                        if (actionID === BarActionId) {
                            // const array = data.data.length > 0 ? data.data.sort((a, b) => parseInt(a.Code) - parseInt(b.Code)) : []
                            this.setState({
                                barQuantityList: data.data,
                            });

                            resolve(true)
                        }
                        if (actionID === CFMActionId) {
                            // const array = data.data.length > 0 ? data.data.sort((a, b) => parseInt(a.Code) - parseInt(b.Code)) : []
                            this.setState({
                                CFMQuantityList: data.data,
                            });

                            resolve(true)
                        }
                        // pincode
                        if (actionID === pincodeActionId) {
                            console.log("pincode data", data.data)
                            this.setState({
                                pincodeList: data.data,
                                tempPincodeList: data.data,
                                billTempPincodeList: data.data,
                                isLoading: false,
                            })
                        }
                        if (actionID === GSTvalidationActionId) {
                            console.log("country data", data.data)
                            this.setState({
                                gstValidtionList: data.data, isLoading: false,
                            })
                        }
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    //Pincode Search
    onPincodeSearch(e) {
        const { pincodeList, tempPincodeList } = this.state
        // console.log("onPincodeSearch 123", tempPincodeList)
        if (e.target.value != '') {
            var searchPincodeList = tempPincodeList.filter(data => {
                return (
                    data
                        .Pincode
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            // console.log('pincodeCount', searchPincodeList.length)
            this.setState({
                regPin: e.target.value,
                regPinErr: '',
                tempPincodeList: searchPincodeList,
                isDisplayPincodeList: true
            })
        } else {
            this.setState({
                regPin: e.target.value,
                tempPincodeList: pincodeList,
                isDisplayPincodeList: false
            })
        }
    }

    // render pincode
    renderPincodeList() {
        const { tempPincodeList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempPincodeList.length > 0 && tempPincodeList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                regPin: data.Pincode,
                                isDisplayPincodeList: false
                            })}
                        >{data.Pincode}</li>
                    ))
                }
            </ul>
        )
    }

    // search city
    onCitySearch(e) {
        const { cityList, tempCityList } = this.state
        if (e.target.value != '') {
            var searchCityList = tempCityList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                regCity: e.target.value,
                regCityErr: '',
                tempCityList: searchCityList,
                isDisplayCityList: true
            })
        } else {
            this.setState({
                regCity: e.target.value,
                tempCityList: cityList,
                isDisplayCityList: false
            })
        }
    }

    // render city
    renderCityList() {
        const { tempCityList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempCityList.length > 0 && tempCityList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ regCity: data.Description, isDisplayCityList: false })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    // search state
    onStateSearch(e) {
        const { stateList, regState, tempStateList } = this.state;
        console.log("onStateSearch", stateList, tempStateList);
        if (e.target.value != "") {
            var searchStateList = tempStateList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                stateId: '',
                regState: e.target.value,
                regStateErr: "",
                tempStateList: searchStateList,
                isDisplayStateList: true,
            });
            // call pincode fill list pass city id and state id
            // this.getFillList(pincodeActionId, '', '', '', regState, '')
        } else {
            this.setState({
                stateId: '',
                regState: e.target.value,
                tempStateList: stateList,
                isDisplayStateList: false,
            });
        }
    }

    // state list
    callStateList(value, id) {
        const { stateList, regState, tempStateList } = this.state;
        this.setState({ regState: value, stateId: id, isDisplayStateList: false });
        this.getFillList(stateActionId, "", "", "", '', "", "");
    }

    // render state
    renderStateList() {
        const { stateList, regState, tempStateList } = this.state;
        return (
            <ul
                class="list-group pincode-drop"
                style={{ position: "absolute", zIndex: 1 }}
            >
                {tempStateList.length > 0 &&
                    tempStateList.map((data) => (
                        <li
                            class="list-group-item"
                            key={Math.random()}
                            onClick={(e) => this.callStateList(data.Description, data.Code)}
                        >
                            {data.Description}
                        </li>
                    ))}
            </ul>
        );
    }

    // Search Country
    onCountrySearch(e) {
        const { countryList, tempCountryList } = this.state
        this.setState({ regCountry: '' })
        if (e.target.value != '') {
            console.log("tempCountryList ++++----------->", tempCountryList)

            var searchCoutryList = tempCountryList.filter(data => {

                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            console.log("searchCoutryList ++++----------->", searchCoutryList)

            this.setState({
                regCountry: e.target.value,
                // regCountryId: searchCoutryList[0]['CountryCode'] != null ? searchCoutryList[0]['CountryCode'] : "",
                regCountryErr: '',
                tempCountryList: searchCoutryList,
                isDisplayCountryList: true
            })
        }
        else {
            console.log("123123123=======----------->", e.target.value, e.target.label)

            this.setState({
                regCountry: e.target.value,
                tempCountryList: countryList,
                isDisplayCountryList: false
            })
        }
    }

    // render Country
    // renderCountryList() {
    //     const { tempCountryList } = this.state
    //     return (
    //         <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
    //             {
    //                 tempCountryList.length > 0 && tempCountryList.map(data => (
    //                     <li class="list-group-item" key={Math.random()}
    //                         onClick={e => this.setState({ regCountry: data.Description, regCountryId: data.Code, isDisplayCountryList: false })}
    //                     >{data.Description}</li>
    //                 ))
    //             }
    //         </ul>
    //     )
    // }

    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    preventMinus = (e) => {
        (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    }


    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        // Replace the input value with the sanitized value
        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }

    // Bill Pincode Search
    onBillPincodeSearch(e) {
        const { pincodeList, billTempPincodeList, billCity } = this.state
        if (e.target.value != '') {
            var searchBillPincodeList = billTempPincodeList.filter(x => {
                return (
                    x
                        .Pincode
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                billPin: e.target.value,
                billPinErr: '',
                billTempPincodeList: searchBillPincodeList,
                isDisplayBillPincodeList: true
            })
        } else {
            this.setState({
                billPin: e.target.value,
                billTempPincodeList: pincodeList,
                isDisplayBillPincodeList: false
            })
        }
    }

    // render Bill pincode
    renderBillPincodeList() {
        const { billTempPincodeList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    billTempPincodeList.length > 0 && billTempPincodeList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                billPin: data.Pincode,
                                isDisplayBillPincodeList: false
                            })}
                        >{data.Pincode}</li>
                    ))
                }
            </ul>
        )
    }

    // search Bill city
    onBillCitySearch(e) {
        const { cityList, billTempCityList } = this.state
        if (e.target.value != '') {
            var searchBillCityList = billTempCityList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                billCity: e.target.value,
                billCityErr: '',
                billTempCityList: searchBillCityList,
                isDisplayBillCityList: true
            })
        } else {
            this.setState({
                billCity: e.target.value,
                billTempCityList: cityList,
                isDisplayBillCityList: false
            })
        }
    }

    // render Bill city
    renderBillCityList() {
        const { billTempCityList } = this.state
        return (
            <ul className="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    billTempCityList.length > 0 && billTempCityList.map(data => (
                        <li className="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ billCity: data.Description, isDisplayBillCityList: false })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    // search state
    onBillStateSearch(e) {
        const { stateList, billTempStateList } = this.state
        console.log("onStateSearch")
        if (e.target.value != '') {
            var searchBillStateList = billTempStateList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                billState: e.target.value,
                billStateErr: '',
                billTempStateList: searchBillStateList,
                isDisplayBillStateList: true
            })
        } else {
            this.setState({
                billState: e.target.value,
                billTempStateList: stateList,
                isDisplayBillStateList: false
            })
        }
    }

    // state list
    callBillStateList(value) {
        const { billState, billTempStateList, billCountryId } = this.state
        this.setState({ billState: value, isDisplayBillStateList: false })
        this.getFillList(stateActionId, '', '', '', billState, '', '')
    }

    // render Bill state
    renderBillStateList() {
        const { billTempStateList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    billTempStateList.length > 0 && billTempStateList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.callBillStateList(data.Description)}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    // search Bill city
    onBillCountrySearch(e) {
        const { countryList, billTempCountryList } = this.state
        if (e.target.value != '') {
            var searchBillCountryList = billTempCountryList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                billCountry: e.target.value,
                // billCountryId: searchBillCountryList[0]['CountryCode'] != null ? searchBillCountryList[0]['CountryCode'] : "",
                billCountryErr: '',
                billTempCountryList: searchBillCountryList,
                isDisplayBillCountryList: true
            })
        } else {
            this.setState({
                billCountry: e.target.value,
                billTempCountryList: countryList,
                isDisplayBillCountryList: false
            })
        }
    }


    // render Bill country 
    renderBillCountryList() {
        const { billTempCountryList } = this.state
        return (
            <ul className="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    billTempCountryList.length > 0 && billTempCountryList.map(data => (
                        <li className="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ billCountry: data.Description, billCountryId: data.Code, isDisplayBillCountryList: false })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    onEntersinglePhase(e, id, index) {
        const { level4, subChapters } = this.state
        console.log("id", id)
        var total = e.target.value
        for (var i = 0; i < subChapters.length; i++) {
            if (subChapters[i].SinglePhasePower != '' && subChapters[i].SinglePhasePower != null) {
                total = parseInt(subChapters[i].SinglePhasePower) + parseInt(total)
            }
        }
        console.log(total)
        if (total > 3 && e.target.value != '') {
            toastError("Maximum 3 quantities allowed for single phase. Apply for three phase for more")

            return
        }
        subChapters.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.SinglePhasePower = e.target.value
            }
        })
        setTimeout(() => {
            console.log(total)
            console.log("exhibitDetailsList", subChapters)
            setTimeout(() => {
                this.setState({ subChapters: subChapters })
            }, 100);

        }, 200);
    }
    onEnterThreePhase(e, id, index) {
        const { level4, subChapters } = this.state
        console.log("id", id)

        subChapters.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.ThreePhasePower = e.target.value
            }
        })
        setTimeout(() => {
            console.log("subChapters", subChapters)
            this.setState({ subChapters: subChapters, lengthWidthErr: '' })

        }, 200);
    }
    onEnterWaterConsumption(e, id, index) {
        const { level4, subChapters } = this.state
        console.log("id", id)

        subChapters.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.WaterConsumption = e.target.value
            }
        })
        setTimeout(() => {
            console.log("subChapters", subChapters)
            this.setState({ subChapters: subChapters, lengthWidthErr: '' })

        }, 200);
    }
    onEnterInletQuantity(e, id, index) {
        const { level4, subChapters } = this.state
        console.log("id", id)

        subChapters.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.InletQuantity = e.target.value
            }
        })
        setTimeout(() => {
            console.log("subChapters", subChapters)
            this.setState({ subChapters: subChapters, lengthWidthErr: '' })

        }, 200);
    }
    onEnterOutletQuantity(e, id, index) {
        const { level4, subChapters } = this.state
        console.log("id", id)

        subChapters.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.OutletQuantity = e.target.value
            }
        })
        setTimeout(() => {
            console.log("subChapters", subChapters)
            this.setState({ subChapters: subChapters, lengthWidthErr: '' })

        }, 200);
    }
    onEnterBar(e, id, index) {
        const { level4, subChapters } = this.state
        console.log("id", id)

        subChapters.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.BarQuantity = e.target.value
            }
        })
        setTimeout(() => {
            console.log("subChapters", subChapters)
            this.setState({ subChapters: subChapters, lengthWidthErr: '' })
            if (e.target.value != '') {
                this.getFillList(CFMActionId, sessionStorage.getItem("sessionExhibitionID"), e.target.value <= 6 ? 13 : e.target.value === 7 ? 14 : 17, "", e.target.value).then(() => {
                    this.setState({
                        isLoading: false
                    })
                })
            }

        }, 200);
    }
    onEnterCFM(e, id, index) {
        const { level4, subChapters } = this.state
        console.log("id", id)

        subChapters.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.CFMQuantity = e.target.value
            }
        })

        setTimeout(() => {
            console.log("subChapters", subChapters)
            this.setState({ subChapters: subChapters, lengthWidthErr: '' })

        }, 200);
    }
    onEnterMaxCompressed(e, id, index) {
        const { level4, subChapters } = this.state
        console.log("id", id)

        subChapters.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.MaxCompressedAir = e.target.value
            }
        })
        setTimeout(() => {
            console.log("subChapters", subChapters)
            this.setState({ subChapters: subChapters, lengthWidthErr: '' })

        }, 200);
    }

    // On Change Of Product Name In Exhibit Table
    onEnterProductName(e, index) {
        const { level4, subChapters } = this.state

        subChapters.map((data, i) => {
            if (index == i) {
                console.log("e.target.value", e.target.value)
                data.ChapterName = e.target.value
            }
        })

        subChapters.map((data, i) => {

        })

        // for (var i = 0; i < subChapters.length; i++) {
        //     console.log("onEnterProductName validate : ", index, ' ', i, ' ', subChapters[i].ChapterName.toString().trim().toLowerCase(), ' ', e.target.value.toString().trim().toLowerCase())
        //     if (index != i && subChapters[i].ChapterName.toString().trim().toLowerCase() == e.target.value.toString().trim().toLowerCase()) {
        //         this.setState({ lengthWidthErr: 'Product name must be unique.' })
        //         return;
        //     } else {
        //         this.setState({ lengthWidthErr: '' })
        //     }
        // }


        setTimeout(() => {
            console.log("subChapters", subChapters)
            this.setState({ subChapters: subChapters })

        }, 200);
    }
    onEnterCompanyEmail(e, id, index) {
        const { level4, subChapters } = this.state
        console.log("id", id)

        subChapters.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.CompanyEmail = e.target.value
            }
        })
        // setTimeout(() => {
        console.log("exhibitDetailsList", subChapters)
        this.setState({ subChapters: subChapters, lengthWidthErr: '' })

        // }, 200);
    }

    onEnterHQaddress(e, id, index) {
        const { level4, subChapters } = this.state
        console.log("id", id)

        subChapters.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.registrationHQaddress = e.target.value
            }
        })
        // setTimeout(() => {
        console.log("exhibitDetailsList", subChapters)
        this.setState({ subChapters: subChapters, lengthWidthErr: '' })

        // }, 200);
    }
    // On Machine Details Change In Exhibit Table
    onMachineDetailsChange(e, id, index) {
        const { level4, subChapters } = this.state
        subChapters.map((data, i) => {
            if (index == i) {
                data.MachineDetails = e.target.value
            }
        })
        setTimeout(() => {
            this.setState({ subChapters: subChapters })
        }, 100);
    }

    // On HSN No Change In Exhibit Table
    onEnterHSNCode(e, id, index) {
        const { level4, subChapters } = this.state
        console.log("id", id)

        subChapters.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.HSNCode = e.target.value
            }
        })
        setTimeout(() => {
            console.log("subChapters", subChapters)
            this.setState({ subChapters: subChapters })

        }, 200);
    }

    // On Length Change In Exhibit Table
    onLengthChange(e, id, index) {
        const { level4, subChapters, stallAreaName, area, internationalAreaSlabList } = this.state
        var breadth = 0;
        subChapters.map((data, i) => {
            if (index == i) {
                data.Length = e.target.value.replace(/[^0-9]/g, '')
                breadth = data.Breadth;
                data.Area = parseFloat(data.Length || 0) * parseFloat(data.Breadth || 0)
            }
        })
        // if (stallAreaName != null && stallAreaName != '' && e.target.value != null && e.target.value != '' && e.target.value != 0 &&
        //     breadth != null && breadth != 0) {
        //     var totalSpace;
        //     var totalEnterSpace;
        //     var lengthWidthList
        //     if (stallAreaName.includes('x')) {
        //         lengthWidthList = stallAreaName.split('x');
        //     } else if (stallAreaName.includes('X')) {
        //         lengthWidthList = stallAreaName.split('X');
        //     }
        //     totalSpace = parseFloat(lengthWidthList[0]) * parseFloat(lengthWidthList[1]);
        //     totalEnterSpace = parseFloat(e.target.value) * parseFloat(breadth);
        //     if (totalEnterSpace > totalSpace) {
        //         this.setState({ lengthWidthErr: 'Length and breadth must be below or equal to stall area.' })
        //     } else {
        //         this.setState({ lengthWidthErr: '' })
        //     }
        // }
        // const totalArea = subChapters.reduce((sum, obj) => sum + obj.Area, 0)
        // if (area < totalArea) {
        //     this.setState({ lengthWidthErr: 'Total area of sum cannot be greater than stall area' })
        // } else {
        //     this.setState({ lengthWidthErr: '' })
        // }

        // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        // const filterArrayBroSome = subChapters.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        // const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
        // var tempTotal = subChapters.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        // var total = 0
        // if (tempTotal == 0) {
        //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
        //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
        //             total = internationalAreaSlabList[i].MinArea
        //         }
        //     }
        // } else {
        //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //     if (totalInternational == 0) {
        //         if ((area - totalNational) > 0) {
        //             total = area - totalNational
        //         } else {
        //             total = 0
        //         }
        //     } else {
        //         if (area >= totalInternational) {
        //             total = totalInternational
        //         } else {
        //             total = 0
        //         }
        //     }
        // }
        // setTimeout(() => {
        //     if (filterArrayBroSome) {
        //         // if (minArea == 0) {
        //         //     const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
        //         //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //         //     if ((parseFloat(area) / 2) < totalNational) {
        //         //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
        //         //     } else {
        //         //         this.setState({ InternationalArea: (parseFloat(area) / 2) })
        //         //     }
        //         // } else {
        //         this.setState({ InternationalArea: total })
        //         // }
        //         // if (minArea != 0) {
        //         //     this.setState({ InternationalArea: total })
        //         // }
        //     } else {
        //         this.setState({ InternationalArea: 0 })
        //     }
        //     this.setState({ subChapters: subChapters })
        //     this.adjustInternationalArea(area)
        // }, 100);

        // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        // var total = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        // var minArea = 0
        // for (var i = 0; i < internationalAreaSlabList.length; i++) {
        //     console.log(area, total)
        //     if (internationalAreaSlabList[i].FromRange < area && area <= internationalAreaSlabList[i].ToRange) {
        //         if (total >= internationalAreaSlabList[i].MinArea) {
        //             total = total
        //             minArea = total
        //         } else {
        //             total = internationalAreaSlabList[i].MinArea
        //             minArea = internationalAreaSlabList[i].MinArea
        //         }
        //     }
        // }
        // setTimeout(() => {
        //     if (filterArray.length > 0) {
        //         if (minArea == 0) {
        //             const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
        //             var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //             if ((parseFloat(area) / 2) < totalNational) {
        //                 this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
        //             } else {
        //                 this.setState({ InternationalArea: (parseFloat(area) / 2) })
        //             }
        //         } else {
        //             this.setState({ InternationalArea: total })
        //         }
        //     } else {
        //         this.setState({ InternationalArea: 0 })
        //     }
        //     this.setState({ subChapters: subChapters })
        //     this.adjustInternationalArea(area)
        // }, 100);
        setTimeout(() => {
            // this.adjustIntAreaNew(area)
            this.adjustCalculatedArea(area)

        }, 100);

    }

    onBreadthChange(e, id, index) {
        const { level4, subChapters, stallAreaName, area, internationalAreaSlabList } = this.state
        var length = 0;
        subChapters.map((data, i) => {
            if (index == i) {
                data.Breadth = e.target.value.replace(/[^0-9]/g, '')
                length = data.Length;
                data.Area = parseFloat(data.Length || 0) * parseFloat(data.Breadth || 0)
            }
        })


        // if (stallAreaName != null && stallAreaName != '' && e.target.value != null && e.target.value != '' && e.target.value != 0 &&
        //     length != null && length != 0) {
        //     var totalSpace;
        //     var totalEnterSpace;
        //     var lengthWidthList
        //     if (stallAreaName.includes('x')) {
        //         lengthWidthList = stallAreaName.split('x');
        //     } else if (stallAreaName.includes('X')) {
        //         lengthWidthList = stallAreaName.split('X');
        //     }

        //     totalSpace = parseFloat(lengthWidthList[0]) * parseFloat(lengthWidthList[1]);
        //     console.log('totalSpace : ', totalSpace);
        //     totalEnterSpace = parseFloat(e.target.value) * parseFloat(length);
        //     if (totalEnterSpace > totalSpace) {
        //         subChapters.map((data, i) => {
        //             if (index == i) {
        //                 data.isLengthValidate = true;
        //             }
        //         })
        //         this.setState({ lengthWidthErr: 'Length and breadth must be below or equal to stall area.' })
        //     } else {
        //         subChapters.map((data, i) => {
        //             if (index == i) {
        //                 data.isLengthValidate = false;
        //             }
        //         })
        //         this.setState({ lengthWidthErr: '' })
        //     }
        // }
        // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        // const filterArrayBroSome = subChapters.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        // const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
        // var tempTotal = subChapters.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        // var total = 0
        // if (tempTotal == 0) {
        //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
        //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
        //             total = internationalAreaSlabList[i].MinArea
        //         }
        //     }
        // } else {
        //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //     if (totalInternational == 0) {
        //         if ((area - totalNational) > 0) {
        //             total = area - totalNational
        //         } else {
        //             total = 0
        //         }
        //     } else {
        //         if (area >= totalInternational) {
        //             total = totalInternational
        //         } else {
        //             total = 0
        //         }
        //     }
        // }
        // setTimeout(() => {
        //     if (filterArrayBroSome) {
        //         // if (minArea == 0) {
        //         //     const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
        //         //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //         //     if ((parseFloat(area) / 2) < totalNational) {
        //         //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
        //         //     } else {
        //         //         this.setState({ InternationalArea: (parseFloat(area) / 2) })
        //         //     }
        //         // } else {
        //         this.setState({ InternationalArea: total })
        //         // }
        //         // if (minArea != 0) {
        //         //     this.setState({ InternationalArea: total })
        //         // }
        //     } else {
        //         this.setState({ InternationalArea: 0 })
        //     }
        //     this.setState({ subChapters: subChapters })
        //     this.adjustInternationalArea(area)
        // }, 100);
        setTimeout(() => {
            // this.adjustIntAreaNew(area)
            this.adjustCalculatedArea(area)
        }, 100);
    }

    onHeightChange(e, id, index) {
        const { level4, subChapters } = this.state
        subChapters.map((data, i) => {
            if (index == i) {
                data.Height = e.target.value
            }
        })
        setTimeout(() => {
            this.setState({ subChapters: subChapters, lengthWidthErr: '' })
        }, 100);

        // if (e.target.value != null && e.target.value != '' && e.target.value != 0 && e.target.value > 3) {
        //     this.setState({ lengthWidthErr: 'Height must be less than or equal to 3.' })
        // } else {
        //     this.setState({ lengthWidthErr: '' })
        // }
    }

    onFloorCapacityChange(e, id, index) {
        const { level4, subChapters } = this.state
        subChapters.map((data, i) => {
            if (index == i) {
                data.FloorCapacity = e.target.value
            }
        })
        setTimeout(() => {
            this.setState({ subChapters: subChapters })
        }, 100);
    }

    onMachineWeightChange(e, id, index) {
        const { level4, subChapters } = this.state
        subChapters.map((data, i) => {
            if (index == i) {
                data.MachineWeight = e.target.value
            }
        })
        setTimeout(() => {
            this.setState({ subChapters: subChapters })
        }, 100);
    }

    onManufacturerNameChange(e, id, index) {
        const { level4, subChapters, area } = this.state
        subChapters.map((data, i) => {
            if (index == i) {
                data.ManufacturerName = e.target.value
            }
        })
        setTimeout(() => {
            this.setState({ subChapters: subChapters, lengthWidthErr: '' }, () => {
                // this.adjustIntAreaNew(area)
                this.adjustCalculatedArea(area)
            })
        }, 100);
    }

    // On Manufacturing Country Name Change
    onManufacturingCountryChange(e, id, index) {
        const { countryList, tempCountryList, subChapters, area } = this.state;

        subChapters.map((data, i) => {
            if (index == i) {
                // if (e.target.value.toLowerCase().trim() != 'india') {
                //     data.isMachine = false
                // }
                if (e.target.value != "") {
                    var searchStateList = tempCountryList.filter((data) => {
                        return data.Description.toLowerCase().includes(
                            e.target.value.toLowerCase()
                        );
                    });
                    data.ManufacturingCountry = e.target.value
                    this.setState({
                        tempCountryList: searchStateList,
                        isDisplayCountryList: true,
                        manufactureCountryIndex: index
                    });
                } else {
                    data.ManufacturingCountry = e.target.value
                    this.setState({
                        tempCountryList: countryList,
                        isDisplayCountryList: false,
                        manufactureCountryIndex: index
                    });
                }
            }
        })
        setTimeout(() => {
            this.setState({ subChapters: subChapters, lengthWidthErr: '' }, () => {
                // this.adjustIntAreaNew(this.state.area)
                this.adjustCalculatedArea(area)
            })
        }, 100);

    }

    renderCountryList() {
        const { countryList, tempCountryList } = this.state;
        return (
            <ul
                class="list-group pincode-drop"
                style={{ position: "absolute", zIndex: 1 }}
            >
                {tempCountryList.length > 0 &&
                    tempCountryList.map((data) => (
                        <li
                            class="list-group-item"
                            key={Math.random()}
                            onClick={(e) => this.callCountryList(data.Description, data.Code)}
                        >
                            {data.Description}
                        </li>
                    ))}
            </ul>
        );
    }

    callCountryList(value, id) {
        const { manufactureCountryIndex, subChapters, area, internationalAreaSlabList } = this.state
        subChapters.map((data, i) => {
            if (manufactureCountryIndex == i) {
                data.ManufacturingCountry = value
            }
        })
        // const totalArea = subChapters.reduce((sum, obj) => sum + obj.Area, 0)
        // if (area < totalArea) {
        //     this.setState({ lengthWidthErr: 'Total area of sum cannot be greater than stall area' })
        // } else {
        //     this.setState({ lengthWidthErr: '' })
        // }

        // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        // const filterArrayBroSome = subChapters.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        // const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
        // var tempTotal = subChapters.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        // var total = 0
        // if (tempTotal == 0) {
        //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
        //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
        //             total = internationalAreaSlabList[i].MinArea
        //         }
        //     }
        // } else {
        //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //     if (totalInternational == 0) {
        //         if ((area - totalNational) > 0) {
        //             total = area - totalNational
        //         } else {
        //             total = 0
        //         }
        //     } else {
        //         if (area >= totalInternational) {
        //             total = totalInternational
        //         } else {
        //             total = 0
        //         }
        //     }
        // }
        // setTimeout(() => {
        //     if (filterArrayBroSome) {
        //         // if (minArea == 0) {
        //         //     const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
        //         //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        //         //     if ((parseFloat(area) / 2) < totalNational) {
        //         //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
        //         //     } else {
        //         //         this.setState({ InternationalArea: (parseFloat(area) / 2) })
        //         //     }
        //         // } else {
        //         this.setState({ InternationalArea: total })
        //         // }
        //         // if (minArea != 0) {
        //         //     this.setState({ InternationalArea: total })
        //         // }
        //     } else {
        //         this.setState({ InternationalArea: 0 })
        //     }
        //     this.setState({ subChapters: subChapters })
        //     this.adjustInternationalArea(area)
        // }, 100);
        setTimeout(() => {
            // this.adjustIntAreaNew(area)
            this.adjustCalculatedArea(area)
        }, 100);

        this.setState({ isDisplayCountryList: false });
        this.getFillList(countryActionId, "", "", "", "", "", "");
    }

    onAddClick(e) {
        e.preventDefault()
        const { isOpen } = this.state
        this.setState({ isOpen: !isOpen })
    }

    // on check level 2
    onCheckLevel2(e, id) {
        const { lev2, subChapters, area } = this.state
        var tempsubChapters = []
        for (let i = 0; i < lev2.length; i++) {
            if (lev2[i]['ChapterID'] == id) {

                if (e.target.checked) {
                    if (!subChapters.includes(lev2[i])) {
                        lev2[i].isLengthValidate = false;
                        subChapters.push(lev2[i])
                        this.setState({ subChapters: subChapters })
                    }
                }
                else {
                    this.setState({ subChapters: subChapters.filter(item => item.ChapterID != lev2[i]['ChapterID']) })
                }

                lev2[i]['IsSelect'] = !lev2[i]['IsSelect']
            }
        }
        setTimeout(() => {
            this.setState({ lev2: lev2, isDoubleStorey: false, doubleStoreyArea: '', doubleStoreyAreaErr: '', stallTypeId: '', stallTypeIdErr: '', stallArea: '', stallAreaErr: '', stallAreaList: [], stallAreaName: '', area: '', exhibitDetailsTableErr: '', InternationalArea: '' }, () => {
                setTimeout(() => {
                    // this.adjustInternationalArea('')
                }, 200);
                setTimeout(() => {
                    // this.adjustIntAreaNew(area)
                    this.adjustCalculatedArea(area)
                }, 100);
            })
            // this.setState({})
        }, 200);
    }

    // on check level 3
    onCheckLevel3(e, id) {
        const { lev3, subChapters, area } = this.state
        var tempsubChapters = []
        for (let i = 0; i < lev3.length; i++) {
            if (lev3[i]['ChapterID'] == id) {

                if (e.target.checked) {
                    if (!subChapters.includes(lev3[i])) {
                        lev3[i].isLengthValidate = false;
                        subChapters.push(lev3[i])
                        this.setState({ subChapters: subChapters })
                    }
                }
                else {
                    this.setState({ subChapters: subChapters.filter(item => item.ChapterID != lev3[i]['ChapterID']) })
                }

                lev3[i]['IsSelect'] = !lev3[i]['IsSelect']
            }
        }
        setTimeout(() => {
            this.setState({ lev3: lev3, isDoubleStorey: false, doubleStoreyArea: '', doubleStoreyAreaErr: '', stallTypeId: '', stallTypeIdErr: '', stallArea: '', stallAreaErr: '', stallAreaList: [], stallAreaName: '', area: '', exhibitDetailsTableErr: '', InternationalArea: '' }, () => {
                setTimeout(() => {
                    // this.adjustInternationalArea('')
                }, 200);
                setTimeout(() => {
                    // this.adjustIntAreaNew(area)
                    this.adjustCalculatedArea(area)
                }, 100);
            })
            // this.setState({ })
        }, 200);
    }

    // on check level 4
    onSelectLevel4(e, id) {
        const { lev4, area, subChapters, stallArea, stallAreaErr, stallTypeId, stallAreaList, stallTypeIdErr, isDoubleStorey, doubleStoreyArea } = this.state
        var tempsubChapters = []
        for (let i = 0; i < lev4.length; i++) {
            if (lev4[i]['ChapterID'] == id) {

                if (e.target.checked) {
                    if (!subChapters.includes(lev4[i])) {
                        lev4[i].isLengthValidate = false;
                        subChapters.push(lev4[i])
                        this.setState({ subChapters: subChapters })
                    }
                }
                else {
                    this.setState({ subChapters: subChapters.filter(item => item.ChapterID != lev4[i]['ChapterID']) })
                }

                lev4[i]['IsSelect'] = !lev4[i]['IsSelect']
            }
        }
        setTimeout(() => {
            this.setState({ lev4: lev4, exbTableErr: '', isDoubleStorey: false, doubleStoreyArea: '', doubleStoreyAreaErr: '', stallTypeId: '', stallTypeIdErr: '', stallArea: '', stallAreaErr: '', stallAreaList: [], stallAreaName: '', area: '', exhibitDetailsTableErr: '', InternationalArea: '' }, () => {
                setTimeout(() => {
                    console.log(area, 'b4 ad')
                    // this.adjustInternationalArea('')
                }, 200);
                setTimeout(() => {
                    // this.adjustIntAreaNew(area)
                    this.adjustCalculatedArea(area)
                }, 100);
            })
        }, 200);
        // setTimeout(() => {
        //     this.setState({})
        // }, 200);

    }

    onMBclick(mode, id, index) {
        const { level4, exhibitDetailsList, subChapters, internationalAreaSlabList, area } = this.state
        console.log("id", id)

        subChapters.map((data, i) => {
            if (data.ChapterID == id) {
                if (mode == 0) {
                    if (data.isMachine) {
                        data.isMachine = false
                    } else {
                        data.isMachine = true
                    }
                } else if (mode == 1) {
                    if (data.isBrochure) {
                        data.isBrochure = false
                    } else {
                        data.isBrochure = true
                    }
                } else if (mode == 2) {
                    if (data.IsAccessory) {
                        data.IsAccessory = false
                    } else {
                        data.IsAccessory = true
                    }
                }
            }
        })
        setTimeout(() => {
            console.log("exhibitDetailsList", subChapters)
            this.setState({ subChapters: subChapters, lengthWidthErr: '' }
                , () => {

                    // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                    // const filterArrayBroSome = subChapters.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                    // const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
                    // var tempTotal = subChapters.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                    // var total = 0
                    // if (tempTotal == 0) {
                    //     for (var i = 0; i < internationalAreaSlabList.length; i++) {
                    //         if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
                    //             total = internationalAreaSlabList[i].MinArea
                    //         }
                    //     }
                    // } else {
                    //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                    //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                    //     if (totalInternational == 0) {
                    //         if ((area - totalNational) > 0) {
                    //             total = area - totalNational
                    //         } else {
                    //             total = 0
                    //         }
                    //     } else {
                    //         if (area >= totalInternational) {
                    //             total = totalInternational
                    //         } else {
                    //             total = 0
                    //         }
                    //     }
                    // }
                    // setTimeout(() => {
                    //     if (filterArrayBroSome) {
                    //         // if (minArea == 0) {
                    //         //     const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
                    //         //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                    //         //     if ((parseFloat(area) / 2) < totalNational) {
                    //         //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
                    //         //     } else {
                    //         //         this.setState({ InternationalArea: (parseFloat(area) / 2) })
                    //         //     }
                    //         // } else {
                    //         this.setState({ InternationalArea: total })
                    //         // }
                    //         // if (minArea != 0) {
                    //         //     this.setState({ InternationalArea: total })
                    //         // }
                    //     } else {
                    //         this.setState({ InternationalArea: 0 })
                    //     }
                    //     this.setState({ subChapters: subChapters })
                    //     this.adjustInternationalArea(area)
                    // }, 100);
                    setTimeout(() => {
                        // this.adjustIntAreaNew(area)
                        this.adjustCalculatedArea(area)
                    }, 100);
                }
            )

        }, 200);


    }

    // to call level third list 
    record(level2, level3, level4) {
        // var newdata = JSON.stringify(data);
        var tempLevel3 = [];
        for (var j = 0; j < level3.length; j++) {
            if (level2.ChapterID == level3[j]['ParentChapterID']) {
                tempLevel3.push(level3[j]);
            }
        }
        return (
            <>
                <div id={'collapse_l1_' + level2.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l1_' + level2.ChapterID} data-bs-parent="#accordionExample">
                    {
                        tempLevel3 && tempLevel3.map(level3data => {
                            return (
                                <div class="accordion-body">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id={'heading_l2_' + level3data.ChapterID}>
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={'#collapse_l2_' + level3data.ChapterID} aria-expanded="false" aria-controls={'collapse_l2_' + level3data.ChapterID}>
                                                {/* // checkbox for level3 */}
                                                {
                                                    level3data.IsCheckbox && <input type="checkbox" className="from-left-sp"
                                                        name="" key={level3data.ChapterID} checked={level3data.IsSelect}
                                                        onClick={e => this.onCheckLevel3(e, level3data.ChapterID)} />
                                                }

                                                {level3data.ChapterName} </button>
                                        </h2>
                                        {this.recordFour(level3data, level4)}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </>
        );
    }

    // to call level four list
    recordFour(level3data, level4) {
        var tempLevel4 = [];
        for (var j = 0; j < level4.length; j++) {
            if (level3data.ChapterID == level4[j]['ParentChapterID']) {
                tempLevel4.push(level4[j]);
            }
        }
        return (<>
            <div id={'collapse_l2_' + level3data.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l2_' + level3data.ChapterID}>
                {
                    tempLevel4 && tempLevel4.map(level4data => {
                        return (
                            <div class="accordion-body third-step">
                                {/* level4data.IsCheckbox && */}
                                <input type="checkbox" name="" key={level4data.ChapterID} checked={level4data.IsSelect}
                                    onClick={(e) => this.onSelectLevel4(e, level4data.ChapterID)} />
                                {level4data.ChapterName}
                            </div>
                        )
                    })
                }
            </div>
        </>);
    }

    onSSITMMAITAMMAClick() {
        const { TMMAITAMMA, isSSi, TMMAITAMMAfile, isTAMMAITAMMAreplaced, isTMMAITAMMAdeleted, isLoad1stTime, isSSifile, isSSIreplaced, isSSIdeleted, stallArea, SSIMaxArea, area } = this.state
        // console.log(stallArea)
        if (area != '' && area != null) {
            // if (area <= SSIMaxArea) {
            // console.log(isLoad1stTime, "SSSSSSSSSSSSi", isLoad1stTime == false && (isSSifile == '' || isSSifile == null))
            if (isLoad1stTime == false && (isSSifile == '' || isSSifile == null) && (TMMAITAMMAfile == '' || TMMAITAMMAfile == null)) {
                // console.log('-----------')
                this.setState({ isLoad1stTime: true, isSSIreplaced: true, isTAMMAITAMMAreplaced: true })
            } else if (isLoad1stTime && (isSSifile == '' || isSSifile == null)) {
                this.setState({ isLoad1stTime: true, isSSIreplaced: true, isSSifileReplacement: '' })
            } else if (isLoad1stTime && (TMMAITAMMAfile == '' || TMMAITAMMAfile == null)) {
                this.setState({ isLoad1stTime: true, isTAMMAITAMMAreplaced: true, TMMAITAMMAfileReplacement: '' })
            } else if (isLoad1stTime && (isSSifile == '' || isSSifile == null) && (TMMAITAMMAfile == '' || TMMAITAMMAfile == null)) {
                this.setState({ isLoad1stTime: true, isTAMMAITAMMAreplaced: true, TMMAITAMMAfileReplacement: '', isSSIreplaced: true, isSSifileReplacement: '' })
            }
            console.log(isSSi)
            if (isSSi == false) {
                this.setState({ isSSi: true, TMMAITAMMA: (isTMMAITAMMAdeleted) ? '1' : TMMAITAMMA, })
            }
            else {
                this.setState({
                    TMMAITAMMA: (isTMMAITAMMAdeleted) ? '' : TMMAITAMMA, isSSi: false,
                })
                if (isSSIdeleted) {
                    this.setState({ isSSifile: '', isSSifilePath: '', isSSifileType: '' })
                }
                if (isTMMAITAMMAdeleted) {
                    this.setState({ TMMAITAMMAfile: '', TMMAITAMMAfilePath: '', TMMAITAMMAfileType: '' })
                }
                // this.onCrossClickSSI()
                // this.onCrossClickITMATAMMA()
            }
            if ((isSSifile != '' && isSSifile != null) && isSSIreplaced) {
                // this.setState({ isSSifileReplacement: '', isSSifilePathReplacement: '', isSSifileTypeReplacement: '' })
                this.setState({ isSSIreplaced: !isSSIreplaced })
            }
            if ((TMMAITAMMAfile != '' && TMMAITAMMAfile != null) && isTAMMAITAMMAreplaced) {
                // this.setState({ isSSifileReplacement: '', isSSifilePathReplacement: '', isSSifileTypeReplacement: '' })
                this.setState({ isTAMMAITAMMAreplaced: !isTAMMAITAMMAreplaced })
            }
            // } else {
            //     toastError(`Maximum area allowed for SSI Discount is ${SSIMaxArea}sqm`)
            // }
        } else {
            toastError('please select Area')
        }
    }


    onSchemeTypeChange(e, id) {
        const { countryId, subChapters, stallTypeIdList, area, stallArea } = this.state
        console.log('id :', id, stallTypeIdList, subChapters);
        if (e) {
            e.preventDefault();
        }
        var minAreaAsModule = 0
        this.getFillList(lengthActionId, sessionStorage.getItem("sessionExhibitionID"), '', id, countryId, '')
        this.getFillList(breadthActionId, sessionStorage.getItem("sessionExhibitionID"), '', id, countryId, '')
        this.setState({ stallTypeId: id, schemeTypeErr: '', area: '', isDoubleStorey: false, doubleStoreyArea: '', isSSi: false, stallArea: '', stallTypeIdErr: '' })
        for (var i = 0; i < subChapters.length; i++) {
            if (id == 1) {
                if (subChapters[i].MinBareArea != '' && subChapters[i].MinBareArea != null) {
                    if (minAreaAsModule < subChapters[i].MinBareArea) {
                        minAreaAsModule = subChapters[i].MinBareArea
                    }
                }
            } else if (id == 2) {
                if (subChapters[i].MinShellArea != '' && subChapters[i].MinShellArea != null) {
                    if (minAreaAsModule < subChapters[i].MinShellArea) {
                        minAreaAsModule = subChapters[i].MinShellArea
                    }
                }
            }
        }
        this.setState({ isLoading: false })
        this.getFillList(stallSizeActionId, sessionStorage.getItem("sessionExhibitionID"), minAreaAsModule == 0 ? '' : minAreaAsModule, id, countryId, '').then(() => {
            this.getFillList(fullStallAreaActionId, sessionStorage.getItem("sessionExhibitionID"), minAreaAsModule == 0 ? '' : minAreaAsModule, id, countryId, '').then(() => {
                this.setState({ isLoading: false, InternationalArea: '' }, () => {
                    // this.adjustInternationalArea(area)
                    setTimeout(() => {
                        // this.adjustIntAreaNew(area)
                        this.adjustCalculatedArea(area)
                    }, 100);
                })
            })
        })
    }

    onLengthTypeChange(e) {
        this.setState({ stallArea: e.target.value, stallAreaErr: '' })
        console.log(e.target.value)
        const { stallAreaList, subChapters, isSSi, countryId, internationalAreaSlabList } = this.state
        for (var i = 0; i < stallAreaList.length; i++) {
            if (stallAreaList[i].Code == e.target.value) {
                var isForeginCountry = subChapters.some(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                if (isForeginCountry && stallAreaList[i].StallArea == 9 && countryId == 91) {
                    this.setState({ minAreaPop1: true, InternationalArea: 0, IAbare: 0, IAshell: 0, isShowInternationalArea: false })
                    return
                }
                if (isForeginCountry && stallAreaList[i].StallArea == 18 && countryId == 91) {
                    this.setState({ minAreaPop2: true })
                    return
                }
                // const totalArea = subChapters.reduce((sum, obj) => sum + obj.Area, 0)
                // console.log('stallAreaList[i].StallArea  : ', stallAreaList[i].StallArea);
                // console.log('totalArea  : ', totalArea);
                // if (stallAreaList[i].StallArea < totalArea) {
                //     this.setState({ lengthWidthErr: 'Total area of sum cannot be greater than stall area' })
                // } else {
                //     this.setState({ lengthWidthErr: '' })
                // }
                this.setState({ stallAreaName: stallAreaList[i].Description, area: stallAreaList[i].StallArea, openSlides: '', lengthWidthErr: '' })

                // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                // const filterArrayBroSome = subChapters.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                // const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
                // var tempTotal = subChapters.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                // var total = 0
                // if (tempTotal == 0) {
                //     for (var j = 0; j < internationalAreaSlabList.length; j++) {
                //         if (internationalAreaSlabList[j].FromRange - 1 < stallAreaList[i].StallArea && stallAreaList[i].StallArea <= internationalAreaSlabList[j].ToRange) {
                //             total = internationalAreaSlabList[j].MinArea
                //         }
                //     }
                // } else {
                //     var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                //     if (totalInternational == 0) {
                //         if ((stallAreaList[i].StallArea - totalNational) > 0) {
                //             total = stallAreaList[i].StallArea - totalNational
                //         } else {
                //             total = 0
                //         }
                //     } else {
                //         if (stallAreaList[i].StallArea >= totalInternational) {
                //             total = totalInternational
                //         } else {
                //             total = 0
                //         }
                //     }
                // }
                // // setTimeout(() => {
                // if (filterArrayBroSome) {
                //     // if (minArea == 0) {
                //     //     const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
                //     //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                //     //     if ((parseFloat(area) / 2) < totalNational) {
                //     //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
                //     //     } else {
                //     //         this.setState({ InternationalArea: (parseFloat(area) / 2) })
                //     //     }
                //     // } else {
                //     this.setState({ InternationalArea: total })
                //     // }
                //     // if (minArea != 0) {
                //     //     this.setState({ InternationalArea: total })
                //     // }
                // } else {
                //     this.setState({ InternationalArea: 0 })
                // }
                // // this.setState({ subChapters: subChapters })
                // this.adjustInternationalArea(stallAreaList[i].StallArea)
                // // }, 100);
                // this.adjustIntAreaNew(stallAreaList[i].StallArea)
                this.adjustCalculatedArea(stallAreaList[i].StallArea)


                // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                // var total = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                // var minArea = 0
                // for (var j = 0; j < internationalAreaSlabList.length; j++) {
                //     if (internationalAreaSlabList[j].FromRange < stallAreaList[i].StallArea && stallAreaList[i].StallArea <= internationalAreaSlabList[j].ToRange) {
                //         if (total >= internationalAreaSlabList[j].MinArea) {
                //             total = total
                //             minArea = total
                //         } else {
                //             total = internationalAreaSlabList[j].MinArea
                //             minArea = internationalAreaSlabList[j].MinArea
                //         }
                //     }
                // }
                this.setState({
                    isDoubleStorey: false,
                    doubleStoreyArea: '',
                    isSSIandTMMAITAMMMA: '',
                    isSSi: false
                })
                // if (filterArray.length > 0) {
                //     // if (minArea == 0) {
                //     //     const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
                //     //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                //     //     if ((parseFloat(area) / 2) < totalNational) {
                //     //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
                //     //     } else {
                //     //         this.setState({ InternationalArea: (parseFloat(area) / 2) })
                //     //     }
                //     // } else {
                //     this.setState({ InternationalArea: total })
                //     // }
                //     // if (minArea != 0) {
                //     //     this.setState({ InternationalArea: total })
                //     // }
                // } else {
                //     this.setState({ InternationalArea: 0 })
                // }
                // this.adjustInternationalArea(stallAreaList[i].StallArea)
            }
        }
    }

    onChangeDoubleStorey(e) {
        const { area, minAreaPercent, doubleStoreyArea } = this.state
        var newArea = e.target.value
        var maxArea = (area * (minAreaPercent / 100))
        if (area != '' && area != null) {
            if (newArea > maxArea) {
                this.setState({ doubleStoreyArea: '' })
                toastError(`Double storey area cannot be more than ${minAreaPercent}% of selected Area`)
            }
            else {
                this.setState({ doubleStoreyArea: newArea, doubleStoreyAreaErr: '' })
            }
        }
        else {
            toastError("please select area")
        }
    }

    onCheckdoubleStorey(e) {
        const { area, minArea, minAreaPercent, isDoubleStorey, doubleStoreyArea } = this.state
        console.log(area, minArea,)
        if (area < minArea) {
            toastError(`Please select Area that is more than or equal to ${minArea} to enable Double Storey`)
        }
        else {
            var tempArea = (area * (minAreaPercent / 100))
            this.setState({ isDoubleStorey: !isDoubleStorey, doubleStoreyArea: tempArea })
        }
    }

    adjustInternationalArea(area, flag) {
        const { isLoading, newPopCountry, exhRegistrationID, primaryChapterListData, primaryChapterRadio,
            level2, level3, level4, schemeType, schemeTypeList, countryId,
            stallAreaId, stallAreaList, openSlideRadio, openSlides, subChapters, undertakingNote,
            openSlidesErr, schemeTypeErr, primaryChapterIdErr, stallAreaIdErr, countryid, exhibitDetailsTableErr, lengthWidthErr, isDataLoad, url, DoubleStoreyPath, OpenSidePath, open, ExhPrimaryUndertakingPersonNameErr, ExhPrimaryUndertakingDesignationErr, ExhPrimaryUndertakingCompanyNameErr, ExhPrimaryUndertakingEmailErr, ExhPrimaryUndertakingMobileNoErr, MultiSelectNotes, ExhPrimaryChapterCommentErr, lengthList, breadthList, InternationalArea, InternationalAreaErr, ExhibitDetailsNote, internationalAreaSlabList, oldInternationalArea } = this.state
        if (area != '' && area != null) {
            this.setState({
                isShowInternationalArea: true
            })

            const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
            const filterArrayBroSome = subChapters.some(item => (item.isBrochure || item.IsAccessory) && !item.isMachine && item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
            const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
            var tempTotal = subChapters.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
            var total = 0
            var isErr = false
            var Err = ''
            console.log('tempTotaltempTotal', tempTotal, internationalAreaSlabList)
            if (tempTotal == 0) {
                for (var i = 0; i < internationalAreaSlabList.length; i++) {
                    // console.log('internationalAreaSlabList[i].FromRange', internationalAreaSlabList[i].FromRange, area)
                    if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
                        total = internationalAreaSlabList[i].MinArea
                    }
                }
            } else {
                var isIntBrochure = filterArray.some((item) => !item.isMachine && (item.isBrochure || item.IsAccessory))
                var totalInternational = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                if (isIntBrochure) {
                    if (totalInternational != 0) {
                        if (area >= totalInternational) {
                            total = totalInternational
                        } else {
                            total = 0
                        }
                    } else {
                        var remArea = 0
                        for (var i = 0; i < internationalAreaSlabList.length; i++) {
                            // console.log('internationalAreaSlabList[i].FromRange', internationalAreaSlabList[i].FromRange, area)
                            if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
                                remArea = area - internationalAreaSlabList[i].MinArea
                                total = internationalAreaSlabList[i].MinArea
                            }
                        }
                        if (remArea < (totalInternational + totalNational)) {
                            isErr = true
                        }
                    }
                } else {
                    if (totalInternational == 0) {
                        if ((area - totalNational) > 0) {
                            total = area - totalNational
                        } else {
                            total = 0
                        }
                    } else {
                        if (area >= totalInternational) {
                            total = totalInternational
                        } else {
                            total = 0
                        }
                    }
                }
            }
            // var minArea = 0
            // for (var i = 0; i < internationalAreaSlabList.length; i++) {
            //     console.log(area, total)
            //     if (internationalAreaSlabList[i].FromRange < area && area <= internationalAreaSlabList[i].ToRange) {
            //         if (total >= internationalAreaSlabList[i].MinArea) {
            //             total = total
            //             minArea = total
            //         } else {
            //             total = internationalAreaSlabList[i].MinArea
            //             minArea = internationalAreaSlabList[i].MinArea
            //         }
            //     }
            // }
            // setTimeout(() => {
            //     if (filterArray.length > 0) {
            //         // if (minArea == 0) {
            //         //     const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
            //         //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
            //         //     if ((parseFloat(area) / 2) < totalNational) {
            //         //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) })
            //         //     } else {
            //         //         this.setState({ InternationalArea: (parseFloat(area) / 2) })
            //         //     }
            //         // } else {
            //         this.setState({ InternationalArea: total })
            //         // }
            //         // if (minArea != 0) {
            //         //     this.setState({ InternationalArea: total })
            //         // }
            //     } else {
            //         this.setState({ InternationalArea: 0 })
            //     }
            //     this.setState({ subChapters: subChapters })
            //     this.adjustInternationalArea(area)
            // }, 100);


            // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
            // var total = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
            // var minArea = 0
            // for (var j = 0; j < internationalAreaSlabList.length; j++) {
            //     if (internationalAreaSlabList[j].FromRange < area && area <= internationalAreaSlabList[j].ToRange) {
            //         if (total >= internationalAreaSlabList[j].MinArea) {
            //             total = total
            //             minArea = total
            //         } else {
            //             total = internationalAreaSlabList[j].MinArea
            //             minArea = internationalAreaSlabList[j].MinArea
            //         }
            //     }
            // }
            if (filterArrayBroSome) {
                // if (minArea == 0) {
                //     const filterArrayNational = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() == 'india' && item.ManufacturingCountry != '')
                //     var totalNational = filterArrayNational.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                //     if ((parseFloat(area) / 2) < totalNational) {
                //         this.setState({ InternationalArea: parseFloat(area) - parseFloat(totalNational) }, () => {
                //             console.log('here 1', parseFloat(area), parseFloat(totalNational))
                //         })
                //     } else {
                //         this.setState({ InternationalArea: (parseFloat(area) / 2) }, () => {
                //             console.log('here 2', (parseFloat(area) / 2))
                //         })
                //     }
                // } else {
                this.setState({ InternationalArea: total, isLoading: false, oldInternationalArea: flag == 1 ? total : oldInternationalArea }, () => {
                    console.log('here 3', total)
                })
                // }
            } else {
                this.setState({ InternationalArea: 0, isShowInternationalArea: false, isLoading: false, oldInternationalArea: flag == 1 ? 0 : oldInternationalArea }, () => {
                    console.log('here 4', 0)
                })
            }
        } else {
            this.setState({ InternationalArea: 0, isShowInternationalArea: false, isLoading: false, oldInternationalArea: flag == 1 ? 0 : oldInternationalArea }, () => {
                console.log('here 4', 0)
            })
        }
        this.setState({
            isLoading: false
        })
    }

    viewPI = async (flag) => {
        this.setState({ isLoading: true });
        var country = this.state.regCountry != '' && this.state.regCountry != null ? this.state.regCountry.toLowerCase().trim() == "india" ? 1 : 0 : 0
        try {
            var list = [];
            const mapdata1 = {
                "ParameterName": "@ExhRegistrationID",
                "ParameterValue": JSON.parse(sessionStorage.getItem('ExhibitorAccessData')).ExhRegistrationID,
                "ParameterDataType": "int"
            }

            list.push(mapdata1);
            const mapData = {
                // "user_id": request.body.UserID,
                "report_name": flag ? country ? '1stInstallment_India_view.rpt' : '1stInstallment_view.rpt' : country ? '2ndInstallment_india_view.rpt' : '2ndInstallment_view.rpt',
                "parameter_details": list
            }
            console.log("xxxxxxxxxxxxxxxxxxxxx", mapData)
            const res = await axiosPost(fetchAuthReport, mapData);
            this.setState({ isLoading: false });

            if (res != null) {
                var url = `${downloadReport}?SessionIdentifier=${res}`;
                const win = window.open(url, '_blank', 'noopener,noreferrer');
                if (win != null) {
                    win.focus();
                }
            }
        } catch (err) {
            console.error(err);
        }
    }

    fillInternationalForm() {
        const { isLoading, newPopCountry, exhRegistrationID, internationalAreaSlabList, primaryChapterListData, primaryChapterRadio,
            lev2, lev3, lev4, schemeType, schemeTypeList, countryId, isShowInternationalArea,
            stallAreaId, stallAreaList, openSlideRadio, openSlides, subChapters, undertakingNote,
            openSlidesErr, schemeTypeErr, primaryChapterIdErr, stallAreaIdErr, countryid, exhibitDetailsTableErr, lengthWidthErr, isDataLoad, url, DoubleStoreyPath, OpenSidePath, open, ExhPrimaryUndertakingPersonNameErr, ExhPrimaryUndertakingDesignationErr, ExhPrimaryUndertakingCompanyNameErr, ExhPrimaryUndertakingEmailErr, ExhPrimaryUndertakingMobileNoErr, MultiSelectNotes, ExhPrimaryChapterCommentErr, lengthList, breadthList, InternationalArea, InternationalAreaErr, ExhibitDetailsNote, area, minAreaPercent, doubleStoreyArea, isDoubleStorey, minArea } = this.state
        var tempStallArea = parseFloat(area) - parseFloat(InternationalArea)
        var tempInternationalArea = InternationalArea
        var tempInternationalId = ''
        // var newArea = 0
        var total = 0

        console.log(tempStallArea, tempInternationalArea)
        for (var i = 0; i < stallAreaList.length; i++) {

            if (stallAreaList[i].StallArea >= tempStallArea) {
                if (isDoubleStorey) {
                    if (stallAreaList[i].StallArea < minArea) {
                        this.setState({ isDoubleStorey: false, doubleStoreyArea: '' })
                    } else {
                        var maxArea = (stallAreaList[i].StallArea * (minAreaPercent / 100))
                        if (doubleStoreyArea > maxArea) {
                            this.setState({ doubleStoreyArea: maxArea })
                            // toastError(`Double storey area cannot be more than ${minAreaPercent}% of selected Area`)
                        }
                    }
                }
                // var newArea = e.target.value
                // newArea = stallAreaList[i].StallArea
                for (var j = 0; j < subChapters.length; j++) {
                    if (subChapters[j].ManufacturingCountry != '' && subChapters[j].ManufacturingCountry != null) {
                        if (subChapters[j].ManufacturingCountry.toLowerCase().trim() != 'india' && (subChapters[j].isBrochure || subChapters[j].IsAccessory) && !subChapters[j].isMachine) {
                            for (var k = 0; k < internationalAreaSlabList.length; k++) {
                                // console.log('internationalAreaSlabList[i].FromRange', internationalAreaSlabList[i].FromRange, area)
                                if (internationalAreaSlabList[k].FromRange - 1 < stallAreaList[i].StallArea && stallAreaList[i].StallArea <= internationalAreaSlabList[k].ToRange) {
                                    // remArea = stallAreaList[i].StallArea - internationalAreaSlabList[k].MinArea
                                    total = internationalAreaSlabList[k].MinArea
                                }
                            }
                            console.log("totalllll", total, subChapters[j].ManufacturingCountry.toLowerCase().trim())
                        }
                    }
                }
                this.setState({ stallAreaName: stallAreaList[i].Description, area: stallAreaList[i].StallArea, stallArea: stallAreaList[i].Code, InternationalArea: total, isShowInternationalArea: total != 0 ? true : false })
                break
            }
        }
        for (var i = 0; i < this.state.stallAreaList.length; i++) {
            // console.log(' this.state.InternationalFormAreaNew', this.state.stallAreaList[i].StallArea, this.state.InternationalFormAreaNew)
            if (this.state.stallAreaList[i].StallArea >= tempInternationalArea) {
                tempInternationalArea = this.state.stallAreaList[i].StallArea
                tempInternationalId = this.state.stallAreaList[i].Code
                // this.setState({
                //     stallAreaId: this.state.stallAreaList[i].Code,
                //     area: this.state.stallAreaList[i].StallArea,
                // })
                break
            }
            // else if (this.state.stallAreaList[i].StallArea > this.state.InternationalFormAreaNew) {
            //     this.setState({
            //         stallAreaId: this.state.stallAreaList[i].Code,
            //         area: this.state.stallAreaList[i].StallArea,
            //     })
            //     break
            // }
        }
        for (var i = 0; i < subChapters.length; i++) {
            if (subChapters[i].ManufacturingCountry != '' && subChapters[i].ManufacturingCountry != null) {
                if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].isMachine) {
                    for (var j = 0; j < lev2.length; j++) {
                        if (subChapters[i].ChapterID == lev2[j].ChapterID) {
                            lev2[j].IsSelect = false
                        }
                    }
                    for (var j = 0; j < lev3.length; j++) {
                        if (subChapters[i].ChapterID == lev3[j].ChapterID) {
                            lev3[j].IsSelect = false
                        }
                    }
                    for (var j = 0; j < lev4.length; j++) {
                        if (subChapters[i].ChapterID == lev4[j].ChapterID) {
                            lev4[j].IsSelect = false
                        }
                    }
                }
            }
        }

        this.setState({
            lev2: lev2, lev3: lev3, lev4: lev4
        }, () => {
            var newsubChapters = subChapters.filter(data => data.ManufacturingCountry != '' && data.ManufacturingCountry != null ? data.ManufacturingCountry.toLowerCase().trim() == 'india' ? data.ManufacturingCountry.toLowerCase().trim() == 'india' : !data.isMachine : '');
            console.log(newsubChapters, '++++')
            this.setState({ subChapters: newsubChapters })
            setTimeout(() => {
                // this.handleStep2Insert(1).then(() => {
                this.setState({ toNewPop: false })
                var url = `${link_BASE_URL}registration/${this.state.UUID}#&${JSON.parse(sessionStorage.getItem('ExhibitorAccessData')).ExhRegistrationID}#&${newPopCountry}#&${tempInternationalArea}#&${tempInternationalId}`;
                // var url = `${link_BASE_URL}primary_chapter/${this.state.UUID}#&${exhRegistrationID}#&${newPopCountry}#&${tempInternationalArea}`;
                const win = window.open(url, '_blank', 'noopener,noreferrer');
                if (win != null) {
                    win.focus();
                }
                // })
            }, 500);
        })

    }



    onCancelClick() {
        this.props.navigate('/exhibitorlist')
    }

    onFilePick = async (e, file, i) => {
        e.preventDefault()
        const { subChapters } = this.state
        // console.log("File01010101------", file, key)
        const { } = this.state
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {

                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFile(file[0]);
                        // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                        subChapters[i].DocumentFile = image
                        subChapters[i].DocumentName = file[0]['name'].toString()
                        //     visitorGroupList[i].passportFileErr = ''
                        this.setState({ subChapters: subChapters })
                        // } else {
                        // this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString() })
                        // }

                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        // if (key == 1) {
                        // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                        subChapters[i].DocumentFile = image
                        subChapters[i].DocumentName = file[0]['name'].toString()
                        this.setState({ subChapters: subChapters })
                        // } else {
                        // this.setState({ passportFile: image, passportFileErr: "" })
                        // }
                        // this.setState({ passportFile: image, passportFileErr: "" })

                    }

                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")
                    }
                    // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                    //     visitorGroupList[i].passportFileType = fileTypeList.length > 0 ? fileTypeList[1] : ""
                    //     this.setState({ visitorGroupList: visitorGroupList })
                    // } else {
                    subChapters[i].DocumentType = fileTypeList.length > 0 ? fileTypeList[1] : ""

                    // this.setState({ passportFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                    // }
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                    document.getElementById(`file${i}`).value = ""

                    // if (key == 1) {
                    //     this.setState({ passportFile: "" })
                    //     document.getElementById("passportFile").value = ""
                    // } else if (key == 2) {
                    //     this.setState({ visitorLetterFile: "" })
                    //     document.getElementById("visitorLetter").value = ""
                    // }
                }
            }
        }
    }

    // If Pdf is selected in file
    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });

    // File resize
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    onCrossClick(i) {
        const { subChapters } = this.state
        // i = i - 1
        // console.log(isPassportFilePresent, i + 1)
        // if (sessionStorage.getItem('VisitorTypeID') == 1) {
        // console.log('isPassportFilePresent', isPassportFilePresent)
        if (subChapters[i].isFilePresent) {
            // const { isOpen3 } = this.state
            // this.setState({ isOpen3: !isOpen3 })
            console.log("condition------------1111111111")
        } else {
            console.log("condition------------2222222222")
            // if (key == 1) {
            // if (mode == 1) {
            //     this.setState({ passportFile: "", isVisaApplied: false })
            // } else {
            subChapters[i].DocumentFile = ""
            this.setState({ subChapters: subChapters })
            document.getElementById(`file${i}`).value = ""
            // }
            // } else if (key == 2) {
            //     this.setState({ visitorLetterFile: "" })
            //     document.getElementById("visitorLetter").value = ""
            // }
        }
    }

    renderNewImage = (img) => {
        const { imageBase64 } = this.state;
        const newWindow = window.open();
        if (newWindow) {
            newWindow.document.write(
                `<img src="${img}" style="width:100%;height:auto;" />`
            );
        } else {
            alert("Please allow popups for this website");
        }
    };

    handleClickSelectPrimaryChapter(data, id) {
        const { primaryChapterRadio, primaryChapterListData, primaryChapterId, selectedPrimaryChapterId, isOpenAgree, selectedPrimaryChapterIdList, isShowHighlightChapters, level2 } = this.state
        data.IsSelect = !data.IsSelect
        // data.isChecked = !data.IsSelect
        var listData = [...primaryChapterListData]
        if (id != '') {
            for (var i = 0; i < listData.length; i++) {
                if (listData[i].ChapterID == id) {
                    if (listData[i].isChecked == true) {
                        console.log("p1")
                        listData[i].isChecked = false;
                        for (var j = 0; j < selectedPrimaryChapterIdList.length; j++) {
                            if (selectedPrimaryChapterIdList[j] == listData[i].ChapterID) {
                                selectedPrimaryChapterIdList.splice(j, 1)
                            }
                        }
                        this.setState({
                            selectedPrimaryChapterIdList: selectedPrimaryChapterIdList,
                        })
                        this.setState({
                            selectedPrimaryChapterId: selectedPrimaryChapterIdList.length == 1 ? selectedPrimaryChapterIdList[0] : selectedPrimaryChapterIdList.length > 1 ? parseInt(id) != parseInt(selectedPrimaryChapterId) ? selectedPrimaryChapterId : "" : '',
                            primaryChapterId: selectedPrimaryChapterIdList.length == 1 ? selectedPrimaryChapterIdList[0] : selectedPrimaryChapterIdList.length > 1 ? parseInt(id) != parseInt(primaryChapterId) ? primaryChapterId : "" : '',
                        })
                    } else {
                        console.log("p2")
                        selectedPrimaryChapterIdList.push(listData[i].ChapterID)
                        listData[i].isChecked = true;
                        this.setState({
                            selectedPrimaryChapterId: selectedPrimaryChapterIdList.length == 1 ? id : selectedPrimaryChapterIdList.includes(1382) ? 1382 : '',
                            primaryChapterId: selectedPrimaryChapterIdList.length == 1 ? id : selectedPrimaryChapterIdList.includes(1382) ? 1382 : '',
                            primaryChapterIdErr: '',
                            selectedPrimaryChapterIdList: selectedPrimaryChapterIdList
                        })
                    }
                }
            }
            console.log('updated list : ', this.state.selectedPrimaryChapterId, this.state.primaryChapterId, selectedPrimaryChapterIdList, listData);
            if (listData) {
                listData.sort((a, b) =>
                    a.ChapterName.toLowerCase().localeCompare(b.ChapterName.toLowerCase())
                );
                this.setState({
                    primaryChapterListData: listData,
                })
            }
            // var lev2List = [...level2]
            // console.log('isShowHighlightChapters', isShowHighlightChapters)
            // if (isShowHighlightChapters) {
            //     var parentIDArr = []
            //     for (var j = 0; j < listData.length; j++) {
            //         if (listData[j].isChecked == true) {
            //             parentIDArr.push(listData[j].ChapterID == 2033 ? 2046 : listData[j].ChapterID)
            //         }
            //     }
            //     for (var i = 0; i < lev2List.length; i++) {
            //         if (lev2List[i].ParentChapterIDs != null) {
            //             var isParent = false
            //             var ParentChapterIDs = lev2List[i].ParentChapterIDs.split(',')
            //             for (var j = 0; j < ParentChapterIDs.length; j++) {
            //                 ParentChapterIDs[j] = parseInt(ParentChapterIDs[j])
            //             }
            //             for (var j = 0; j < ParentChapterIDs.length; j++) {
            //                 if (parentIDArr.includes(ParentChapterIDs[j])) {
            //                     console.log(ParentChapterIDs)
            //                     isParent = true
            //                     lev2List[i]['isHighlight'] = true;
            //                 }
            //             }
            //             if (!isParent) {
            //                 lev2List[i]['isHighlight'] = false;
            //             }
            //         } else {
            //             var isParent = false
            //             if (parentIDArr.includes(lev2List[i].ParentChapterID)) {
            //                 isParent = true
            //                 lev2List[i]['isHighlight'] = true;
            //             }
            //             if (!isParent) {
            //                 lev2List[i]['isHighlight'] = false;
            //             }
            //         }
            //     }
            // }
            // primaryChapterListData.filter(item => item.isChecked).length > 1 && !isOpenAgree && this.setState({
            //     open: true
            // })
            primaryChapterListData.filter(item => item.isChecked).length > 1 ? this.setState({
                isOpenAgree: true
            }) : this.setState({
                isOpenAgree: false
            })
            // this.setState({
            //     level2: lev2List,
            // })
        }


        // if (selectedPrimaryChapterIdList.length == 1) {
        //     this.setState({
        //         defaultprimaryChapterIdErr: ''
        //     })
        // }
        // this.setState({ primaryChapterRadio: id == 2033 ? 2046 : id })
        // primaryChapterListData.length > 0 && primaryChapterListData.map(data => {
        //     if (data.ChapterID == id) {
        //         data.IsSelect = !data.IsSelect
        //         this.setState({ primaryChapterListData : primaryChapterListData})

        //     }
        // })

    }

    checkSame(id) {
        var flag = false
        this.state.selectedPrimaryChapterIdList.length > 0 && this.state.selectedPrimaryChapterIdList.map(item => {
            if (item == id)
                flag = true
        })
        return flag
    }

    changetoExpArea() {
        const { isLoading, newPopCountry, internationalAreaSlabList, exhRegistrationID, primaryChapterListData, primaryChapterRadio,
            level2, level3, isOpen2, level4, schemeType, schemeTypeList, countryId, selectedPrimaryChapterId, selectedPrimaryChapterIdList,
            stallAreaId, stallAreaList, isOpen4,
            expectedArea, openSlideRadio, openSlides, subChapters, undertakingNote,
            openSlidesErr, schemeTypeErr, primaryChapterIdErr, stallAreaIdErr, countryid, exhibitDetailsTableErr, lengthWidthErr, isDataLoad, url, DoubleStoreyPath, OpenSidePath, open, ExhPrimaryUndertakingPersonNameErr, ExhPrimaryUndertakingDesignationErr, ExhPrimaryUndertakingCompanyNameErr, ExhPrimaryUndertakingEmailErr, ExhPrimaryUndertakingMobileNoErr, MultiSelectNotes, ExhPrimaryChapterCommentErr, lengthList, breadthList, InternationalArea, InternationalAreaErr, ExhibitDetailsNote, area, isOpenConfirmationModal, stallAreaName } = this.state
        console.log(this.state.expectedAreaId, stallAreaList, expectedArea)
        return new Promise((resolve, reject) => {

            stallAreaList.map(item => {
                if (item.Code == this.state.expectedAreaId) {
                    this.setState({ area: expectedArea, stallArea: this.state.expectedAreaId, isOpen4: false, isOpen10: false, lengthWidthErr: '' })
                    toastSuccess(`Stall Area updated to ${expectedArea}`)
                }
            })
            setTimeout(() => {
                resolve(true)
                // this.adjustIntAreaNew(expectedArea)
            }, 200);
        })
    }

    adjustIntAreaNew(area, flag) {
        const { isLoading, newPopCountry, exhRegistrationID, primaryChapterListData, primaryChapterRadio, compareObjArr,
            level2, level3, level4, schemeType, schemeTypeList, countryId, subChapters, oldInternationalArea, referenceStallAreaArr,
            stallAreaId, stallAreaList, openSlideRadio, openSlides, exhibitDetailsList, undertakingNote,
            openSlidesErr, schemeTypeErr, primaryChapterIdErr, stallAreaIdErr, countryid, exhibitDetailsTableErr, lengthWidthErr, isDataLoad, url, DoubleStoreyPath, OpenSidePath, open, ExhPrimaryUndertakingPersonNameErr, ExhPrimaryUndertakingDesignationErr, ExhPrimaryUndertakingCompanyNameErr, ExhPrimaryUndertakingEmailErr, ExhPrimaryUndertakingMobileNoErr, MultiSelectNotes, ExhPrimaryChapterCommentErr, lengthList, breadthList, InternationalArea, InternationalAreaErr, ExhibitDetailsNote, internationalAreaSlabList, } = this.state
        if (countryId == 91) {
            if (area != '' && area != null) {
                var total = 0
                var psuedoList = []
                var isAllBrochure = true
                const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                if (filterArray.length > 0) {
                    for (var i = 0; i < filterArray.length; i++) {
                        var tempJSON = {}
                        if (filterArray[i].isBrochure) {
                            tempJSON = JSON.parse(JSON.stringify(filterArray[i]))
                            tempJSON.IsAccessory = false
                            tempJSON.isMachine = false
                            psuedoList.push(tempJSON)
                        }
                        if (filterArray[i].IsAccessory) {
                            tempJSON = JSON.parse(JSON.stringify(filterArray[i]))
                            isAllBrochure = false
                            tempJSON.isBrochure = false
                            tempJSON.isMachine = false
                            psuedoList.push(tempJSON)
                        }
                        if (filterArray[i].isMachine) {
                            tempJSON = JSON.parse(JSON.stringify(filterArray[i]))
                            isAllBrochure = false
                            tempJSON.IsAccessory = false
                            tempJSON.isBrochure = false
                            psuedoList.push(tempJSON)
                        }
                    }
                    // for (var i = 0; i < psuedoList.length; i++) {
                    var brochureArea = 0
                    // if (containsBrochure) {
                    for (var i = 0; i < internationalAreaSlabList.length; i++) {
                        if (internationalAreaSlabList[i].FromRange - 1 < area && area <= internationalAreaSlabList[i].ToRange) {
                            brochureArea = internationalAreaSlabList[i].MinArea
                        }
                    }
                    // }
                    var accNew = true
                    var uniqueManuNameAcc = []
                    var uniqueManuNameManuCountry = []
                    var uniqueManuNameBro = []
                    var uniqueManuNameMachine = []
                    if (isAllBrochure) {
                        total = brochureArea
                        this.setState({ isAllBro: true })
                    } else {
                        this.setState({ isAllBro: false })
                        for (var i = 0; i < psuedoList.length; i++) {
                            if (psuedoList[i].isMachine) {
                                total = psuedoList[i].Area ? total + psuedoList[i].Area : total
                                if (!uniqueManuNameMachine.includes(psuedoList[i].ManufacturerName.trim())) {
                                    uniqueManuNameMachine.push(psuedoList[i].ManufacturerName.trim())
                                }
                                uniqueManuNameManuCountry.push({ ManufacturerName: psuedoList[i].ManufacturerName.trim(), ManufacturingCountry: psuedoList[i].ManufacturingCountry.trim() })
                            }
                        }
                        console.log('total', total)
                        for (var i = 0; i < psuedoList.length; i++) {
                            if (psuedoList[i].IsAccessory) {
                                if (psuedoList[i].ManufacturerName != null && psuedoList[i].ManufacturerName != '') {
                                    console.log(uniqueManuNameManuCountry, psuedoList[i].ManufacturerName.trim())
                                    var isSameAcc = false
                                    for (var a = 0; a < uniqueManuNameManuCountry.length; a++) {
                                        if (uniqueManuNameManuCountry[a].ManufacturerName == psuedoList[i].ManufacturerName.trim() && uniqueManuNameManuCountry[a].ManufacturingCountry == psuedoList[i].ManufacturingCountry.trim()) {
                                            isSameAcc = true
                                        }
                                    }
                                    // if (uniqueManuNameMachine.includes(psuedoList[i].ManufacturerName.trim())) {
                                    //     isSameAcc = true
                                    // }
                                    // console.log('uniqueManuNameMachine', uniqueManuNameMachine, psuedoList)
                                    if (!isSameAcc) {
                                        uniqueManuNameManuCountry.push({ ManufacturerName: psuedoList[i].ManufacturerName.trim(), ManufacturingCountry: psuedoList[i].ManufacturingCountry.trim() })
                                        total = total + 18
                                    }
                                    if (!uniqueManuNameAcc.includes(psuedoList[i].ManufacturerName.trim())) {
                                        uniqueManuNameAcc.push(psuedoList[i].ManufacturerName.trim())
                                    }
                                }
                            }
                        }
                        console.log('total', total)
                        for (var i = 0; i < psuedoList.length; i++) {
                            if (psuedoList[i].isBrochure) {
                                if (psuedoList[i].ManufacturerName != null && psuedoList[i].ManufacturerName != '') {
                                    console.log(uniqueManuNameBro, psuedoList[i].ManufacturerName.trim(), '111')
                                    if (!uniqueManuNameBro.includes(psuedoList[i].ManufacturerName.trim()) && !uniqueManuNameAcc.includes(psuedoList[i].ManufacturerName.trim()) && !uniqueManuNameMachine.includes(psuedoList[i].ManufacturerName.trim())) {
                                        console.log(psuedoList[i].ManufacturerName.trim(), '222')
                                        uniqueManuNameBro.push(psuedoList[i].ManufacturerName.trim())
                                        total = total + 9
                                    }
                                }
                            }
                        }
                    }
                    console.log('000000000000000000000000', uniqueManuNameAcc,
                        uniqueManuNameBro,
                        uniqueManuNameMachine)
                    console.log('total', total)
                    // var tempStallArea = JSON.parse(JSON.stringify(stallAreaList))
                    // tempStallArea.unshift({ StallArea: 9 })
                    var newArea = total
                    if (!isAllBrochure) {
                        for (var i = 0; i < referenceStallAreaArr.length; i++) {
                            if (total <= referenceStallAreaArr[i].StallArea) {
                                newArea = referenceStallAreaArr[i].StallArea
                                break
                            }
                        }
                    }

                    setTimeout(() => {
                        if (flag == 1) {
                            compareObjArr.push({ name: 'InternationalArea', oldValue: newArea, newValue: newArea, display: 'International Area' })
                            this.setState({ compareObjArr: compareObjArr })
                        }
                        this.setState({ InternationalArea: newArea, isShowInternationalArea: true, oldInternationalArea: flag == 1 ? newArea : oldInternationalArea }, () => {
                            console.log('here 4', 0)
                        })
                    }, 250);
                } else {
                    if (flag == 1) {
                        compareObjArr.push({ name: 'InternationalArea', oldValue: total, newValue: total, display: 'International Area' })
                        this.setState({ compareObjArr: compareObjArr })
                    }
                    this.setState({ InternationalArea: 0, isShowInternationalArea: false, oldInternationalArea: flag == 1 ? total : oldInternationalArea }, () => {
                        console.log('here 4', 0)
                    })
                }
            } else {
                if (flag == 1) {
                    compareObjArr.push({ name: 'InternationalArea', oldValue: total, newValue: total, display: 'International Area' })
                    this.setState({ compareObjArr: compareObjArr })
                }
                this.setState({ InternationalArea: 0, isShowInternationalArea: false, oldInternationalArea: flag == 1 ? total : oldInternationalArea }, () => {
                    console.log('here 4', 0)
                })
            }
        } else {
            if (flag == 1) {
                compareObjArr.push({ name: 'InternationalArea', oldValue: 0, newValue: 0, display: 'International Area' })
                this.setState({ compareObjArr: compareObjArr })
            }
            this.setState({ InternationalArea: 0, isShowInternationalArea: false, oldInternationalArea: 0 }, () => {
                console.log('here 4', 0)
            })
        }
        this.setState({ InternationalAreaErr: '', lengthWidthErr: '' })
    }
    getUpdateAccess() {
        const { loginAccesslist } = this.state;
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == "9");
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false;
        }
        return false;
    }

    onCountryBlur(value, index) {
        const { manufactureCountryIndex, isMixRuleAgree, countryId, OpenMixExhibitorRule, SSRCountryList, countryList, subChapters, exhibitDetailsList, area, internationalAreaSlabList } = this.state
        var err = false
        // if (SSRCountryList.length > 0) {
        //     SSRCountryList.map(item2 => {
        //         if (item2.CountryName.toLowerCase().trim() == value.toLowerCase().trim()) {
        //             err = true
        //             exhibitDetailsList.map((data, i) => {
        //                 if (index == i) {
        //                     data.ManufacturingCountry = ''
        //                     this.setState({
        //                         tempCountryList: countryList,
        //                         isDisplayCountryList: false,
        //                         manufactureCountryIndex: index
        //                     });
        //                 }
        //             })

        //             this.setState({
        //                 isOpen2: true
        //             })
        //             this.setState({ isDisplayCountryList: false, exhibitDetailsList: exhibitDetailsList });
        //             return
        //         }
        //     })
        // }
        setTimeout(() => {
            if (subChapters[index].ManufacturingCountry.toLowerCase().trim() != 'india') {
                if (area == 9 && area != '' && area != null && countryId == 91) {
                    this.setState({ minAreaPop1: true, InternationalArea: 0, IAbare: 0, IAshell: 0, isShowInternationalArea: false })
                    return
                }
                if (area == 18 && area != '' && area != null && countryId == 91) {
                    this.setState({ minAreaPop2: true })
                    return
                }
                if (!isMixRuleAgree) {
                    // for (var i = 0; i < exhibitDetailsList.length; i++) {
                    //     if (index == i) {
                    if (subChapters[index].ManufacturingCountry.toLowerCase().trim() != 'india' && countryId == 91) {
                        this.setState({ intAreaRulesPop: true })
                    }
                    // }
                    // }
                }
            } else {
                this.checksameMFandCountry()
            }
            console.log(value.toLowerCase().trim(), '2')
        }, 500);
    }

    checksameMFandCountry() {
        const { subChapters, countryId, regCompany } = this.state;
        return new Promise((resolve, reject) => {
            if (countryId == 91) {
                var returnvalue = true
                // var isCheckAll = true
                // for (var i = 0; i < exhibitDetailsList.length; i++) {
                //     if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() != 'india') {
                //         isCheckAll = false
                //         break
                //     }
                // }
                // if (isCheckAll) {
                for (var i = 0; i < subChapters.length; i++) {
                    if (subChapters[i].ManufacturingCountry != '' && subChapters[i].ManufacturerName != '') {
                        if (subChapters[i].ManufacturingCountry.toLowerCase().trim() == 'india') {
                            if (subChapters[i].ManufacturerName.toLowerCase().trim() != regCompany.toLowerCase().trim()) {
                                subChapters[i].ManufacturerName = ''
                                returnvalue = false
                                this.setState({ OpensameCountryManuErr: true })
                                // break
                            }
                        }
                    }
                }
                this.setState({ subChapters: subChapters })
                // }
                resolve(returnvalue)
            } else {
                var returnvalue = true
                for (var i = 0; i < subChapters.length; i++) {
                    if (subChapters[i].ManufacturingCountry != '' && subChapters[i].ManufacturerName != '') {
                        // if (exhibitDetailsList[i].ManufacturingCountry.toLowerCase().trim() == 'india') {
                        if (subChapters[i].ManufacturerName.toLowerCase().trim() != regCompany.toLowerCase().trim()) {
                            subChapters[i].ManufacturerName = ''
                            returnvalue = false
                            this.setState({ OpensameCountryManuErr: true })
                            // break
                        }
                    }
                    // }
                }
                this.setState({ subChapters: subChapters })
                resolve(returnvalue)
            }
        })
    }

    adjustCalculatedArea(area) {
        const { isLoading, newPopCountry, exhRegistrationID, primaryChapterListData, primaryChapterRadio,
            level2, level3, level4, schemeType, schemeTypeList, countryId, referenceStallAreaArr, stallTypeId,
            stallAreaId, stallAreaList, openSlideRadio, openSlides, subChapters, undertakingNote,
            openSlidesErr, schemeTypeErr, primaryChapterIdErr, stallAreaIdErr, countryid, exhibitDetailsTableErr, lengthWidthErr, isDataLoad, url, DoubleStoreyPath, OpenSidePath, open, ExhPrimaryUndertakingPersonNameErr, ExhPrimaryUndertakingDesignationErr, ExhPrimaryUndertakingCompanyNameErr, ExhPrimaryUndertakingEmailErr, ExhPrimaryUndertakingMobileNoErr, MultiSelectNotes, ExhPrimaryChapterCommentErr, lengthList, breadthList, InternationalArea, InternationalAreaErr, ExhibitDetailsNote, internationalAreaSlabList, } = this.state
        console.log('areaaaaaaaaaaaaaaaaa', area)
        var machineArea = 0
        var accArea = 0
        var broArea = 0
        if (area != '' && area != null) {
            var total = 0
            var totalBare = 0
            var totalShell = 0
            var psuedoList = []
            var isAllBrochure = true
            const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '' && (item.isMachine || item.IsAccessory || item.isBrochure))
            console.log('filterArrayfilterArray', filterArray)
            if (filterArray.length > 0 && countryId == 91) {
                const check1 = subChapters.every(item => !item.isMachine)
                const check2 = subChapters.every(item => !item.IsAccessory)
                const check3 = subChapters.some(item => item.isBrochure)
                if (check1 && check2 && check3) {
                    var uniqueManuNameBro = []
                    this.setState({ isAllBro: true })
                    const isAllManuCountry = subChapters.every(item => item.ManufacturingCountry != null && item.ManufacturingCountry != '')
                    const isAllMB = subChapters.every(item => item.isMachine != undefined && item.isBrochure != undefined && item.IsAccessory != undefined ? item.isMachine || item.isBrochure || item.IsAccessory : false)
                    // console.log('14785', isAllManuCountry && isAllMB && stallAreaId != '' && stallAreaId != null, isAllManuCountry, isAllMB, stallAreaId)
                    console.log('this.state.prefferedPopAsk', isAllMB, isAllManuCountry, schemeType, area)
                    if (isAllManuCountry && isAllMB && stallTypeId == 1 && area <= 72) {
                        if (!this.state.prefferedPopAsk && countryId == 91) {
                            this.setState({ prefferedPop: true })
                            return
                        }
                    }
                    for (var i = 0; i < subChapters.length; i++) {
                        if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].ManufacturingCountry != '') {
                            // if (!subChapters[i].isMachine && !subChapters[i].IsAccessory && subChapters[i].isBrochure) {
                            if (subChapters[i].ManufacturerName != null && subChapters[i].ManufacturerName != '') {
                                var isSameBro = false
                                if (uniqueManuNameBro.includes(subChapters[i].ManufacturerName.toLowerCase().trim())) {
                                    isSameBro = true
                                }
                                if (!isSameBro) {
                                    uniqueManuNameBro.push(subChapters[i].ManufacturerName.toLowerCase().trim())
                                }
                            } else {
                                subChapters[i].CalculatedArea = 0
                                subChapters[i].ShellScheme = ''
                            }
                            // }
                        } else {
                            subChapters[i].CalculatedArea = 0
                            subChapters[i].ShellScheme = ''
                        }
                    }
                    var manuList = []
                    for (var i = 0; i < uniqueManuNameBro.length; i++) {
                        manuList.push({ 'ManufacturerName': uniqueManuNameBro[i].toLowerCase().trim(), isShow: 0, isRepeat: 0 })
                    }
                    if (uniqueManuNameBro.length != 0) {
                        var criteriaBArea = uniqueManuNameBro.length * 3
                        for (var i = 0; i < referenceStallAreaArr.length; i++) {
                            if (criteriaBArea <= referenceStallAreaArr[i].StallArea) {
                                criteriaBArea = referenceStallAreaArr[i].StallArea
                                break
                            }
                        }

                        var criteriaAArea = 0
                        for (var i = 0; i < internationalAreaSlabList.length; i++) {
                            if (area < internationalAreaSlabList[0].FromRange) {
                                criteriaAArea = internationalAreaSlabList[0].MinArea
                            }
                            else if (internationalAreaSlabList[i].FromRange <= area && area <= internationalAreaSlabList[i].ToRange) {
                                console.log(area, internationalAreaSlabList[i])
                                criteriaAArea = internationalAreaSlabList[i].MinArea
                            }
                        }
                        console.log(criteriaBArea, criteriaAArea, 'criteriaBArea > criteriaAArea', uniqueManuNameBro)
                        if (criteriaBArea >= criteriaAArea) {
                            var noBro = criteriaBArea / 9
                            var calculatedAreaAssigned = 0
                            console.log('noBronoBronoBro', manuList, uniqueManuNameBro, noBro)
                            var gap = 0
                            for (var i = 0; i < subChapters.length; i++) {
                                if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].ManufacturingCountry != '') {
                                    if (uniqueManuNameBro.includes(subChapters[i].ManufacturerName.toLowerCase().trim())) {
                                        if (calculatedAreaAssigned < noBro) {
                                            for (var j = 0; j < manuList.length; j++) {
                                                if (manuList[j].ManufacturerName.toLowerCase().trim() == subChapters[i].ManufacturerName.toLowerCase().trim()) {
                                                    if (manuList[j].isRepeat == 0) {
                                                        if (gap == 0) {
                                                            subChapters[i].CalculatedArea = 9
                                                            subChapters[i].ShellScheme = 2
                                                            calculatedAreaAssigned = calculatedAreaAssigned + 1
                                                            manuList[j].isRepeat = 1
                                                            gap = 2
                                                        } else {
                                                            subChapters[i].CalculatedArea = 0
                                                            subChapters[i].ShellScheme = ''
                                                            gap = gap - 1
                                                            manuList[j].isRepeat = 1
                                                        }
                                                    } else {
                                                        subChapters[i].CalculatedArea = 0
                                                        subChapters[i].ShellScheme = ''
                                                    }
                                                }
                                            }
                                        } else {
                                            for (var j = 0; j < uniqueManuNameBro.length; j++) {
                                                if (uniqueManuNameBro[j].toLowerCase().trim() == subChapters[i].ManufacturerName.toLowerCase().trim()) {
                                                    subChapters[i].CalculatedArea = 0
                                                    subChapters[i].ShellScheme = ''
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    subChapters[i].CalculatedArea = 0
                                    subChapters[i].ShellScheme = ''
                                }
                            }
                            total = criteriaBArea
                        } else {
                            var areainsert = false
                            for (var i = 0; i < subChapters.length; i++) {
                                if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].ManufacturingCountry != '') {
                                    for (var j = 0; j < uniqueManuNameBro.length; j++) {
                                        if (uniqueManuNameBro[j].toLowerCase().trim() == subChapters[i].ManufacturerName.toLowerCase().trim()) {
                                            if (!areainsert) {
                                                subChapters[i].CalculatedArea = criteriaAArea
                                                subChapters[i].ShellScheme = 2
                                                areainsert = true
                                            } else {
                                                subChapters[i].CalculatedArea = 0
                                                subChapters[i].ShellScheme = ''
                                            }
                                        }
                                    }
                                } else {
                                    subChapters[i].CalculatedArea = 0
                                    subChapters[i].ShellScheme = ''
                                }
                            }
                            total = criteriaAArea
                        }
                    }

                } else {
                    var uniqueManuNameMachine = []
                    var uniqueManuNameAcc = []
                    var uniqueManuNameManuCountry = []
                    var uniqueManuNameBro = []
                    for (var i = 0; i < subChapters.length; i++) {
                        if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].ManufacturingCountry != '' && !subChapters[i].isMachine && !subChapters[i].IsAccessory && !subChapters[i].isBrochure) {
                            subChapters[i].CalculatedArea = 0
                            subChapters[i].ShellScheme = ''
                        }
                    }

                    for (var i = 0; i < subChapters.length; i++) {
                        // console.log('++++++++++++++++++', subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].ManufacturingCountry != '' && (subChapters[i].isMachine || subChapters[i].IsAccessory || subChapters[i].isBrochure), subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].ManufacturingCountry != '', subChapters[i].isMachine, subChapters[i].IsAccessory, subChapters[i].isBrochure)
                        if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].ManufacturingCountry != '') {
                            if (subChapters[i].isMachine) {
                                if (subChapters[i].ManufacturerName != null && subChapters[i].ManufacturerName != '') {
                                    subChapters[i].tempArea = (subChapters[i].Length * subChapters[i].Breadth)
                                    if (!uniqueManuNameMachine.includes(subChapters[i].ManufacturerName.toLowerCase().trim())) {
                                        for (var j = 0; j < referenceStallAreaArr.length; j++) {
                                            if (subChapters[i].tempArea <= referenceStallAreaArr[j].StallArea && referenceStallAreaArr[j].StallArea >= 18) {
                                                subChapters[i].CalculatedArea = referenceStallAreaArr[j].StallArea
                                                subChapters[i].ShellScheme = referenceStallAreaArr[j].StallArea > 18 ? 1 : 2
                                                break
                                            }
                                        }
                                        uniqueManuNameMachine.push(subChapters[i].ManufacturerName.toLowerCase().trim())
                                    } else {
                                        for (var j = 0; j < subChapters.length; j++) {
                                            if (subChapters[j].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[j].ManufacturingCountry != '' && (subChapters[j].isMachine || subChapters[j].IsAccessory || subChapters[j].isBrochure)) {
                                                if (subChapters[j].isMachine) {
                                                    if (subChapters[i].ManufacturerName.toLowerCase().trim() == subChapters[j].ManufacturerName.toLowerCase().trim()) {
                                                        subChapters[j].tempArea = subChapters[j].tempArea + (subChapters[i].Length * subChapters[i].Breadth)
                                                        for (var k = 0; k < referenceStallAreaArr.length; k++) {
                                                            if (subChapters[j].tempArea <= referenceStallAreaArr[k].StallArea && referenceStallAreaArr[k].StallArea >= 18) {
                                                                subChapters[j].CalculatedArea = referenceStallAreaArr[k].StallArea
                                                                subChapters[j].ShellScheme = referenceStallAreaArr[k].StallArea > 18 ? 1 : 2
                                                                break
                                                            }
                                                        }
                                                        break
                                                    }
                                                }
                                            }
                                        }
                                        subChapters[i].CalculatedArea = 0
                                        subChapters[i].ShellScheme = ''
                                    }
                                } else {
                                    subChapters[i].CalculatedArea = 0
                                    subChapters[i].ShellScheme = ''
                                }
                            }
                        } else {
                            subChapters[i].CalculatedArea = 0
                            subChapters[i].ShellScheme = ''
                        }
                    }
                    for (var i = 0; i < subChapters.length; i++) {
                        if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].ManufacturingCountry != '') {

                            var isSameAcc = false
                            if (!subChapters[i].isMachine && subChapters[i].IsAccessory) {
                                if (subChapters[i].ManufacturerName.toLowerCase().trim() != '' && subChapters[i].ManufacturerName.toLowerCase().trim() != null) {
                                    if (uniqueManuNameMachine.includes(subChapters[i].ManufacturerName.toLowerCase().trim())) {
                                        subChapters[i].CalculatedArea = 0
                                        subChapters[i].ShellScheme = ''
                                        isSameAcc = true
                                    }
                                    for (var a = 0; a < uniqueManuNameManuCountry.length; a++) {
                                        if (uniqueManuNameManuCountry[a].ManufacturerName == subChapters[i].ManufacturerName.toLowerCase().trim() && uniqueManuNameManuCountry[a].ManufacturingCountry == subChapters[i].ManufacturingCountry.toLowerCase().trim()) {
                                            subChapters[i].CalculatedArea = 0
                                            subChapters[i].ShellScheme = ''
                                            isSameAcc = true
                                        }
                                    }
                                    console.log('isSameAcc', isSameAcc, uniqueManuNameMachine, subChapters[i])
                                    if (!isSameAcc) {
                                        uniqueManuNameManuCountry.push({ ManufacturerName: subChapters[i].ManufacturerName.toLowerCase().trim(), ManufacturingCountry: subChapters[i].ManufacturingCountry.toLowerCase().trim() })
                                        subChapters[i].CalculatedArea = 18
                                        subChapters[i].ShellScheme = 2
                                        accArea = accArea + 18
                                    } else {
                                        subChapters[i].CalculatedArea = 0
                                        subChapters[i].ShellScheme = ''
                                    }
                                    if (!uniqueManuNameAcc.includes(subChapters[i].ManufacturerName.toLowerCase().trim())) {
                                        uniqueManuNameAcc.push(subChapters[i].ManufacturerName.toLowerCase().trim())
                                    }
                                } else {
                                    subChapters[i].CalculatedArea = 0
                                    subChapters[i].ShellScheme = ''
                                }
                            }
                        } else {
                            subChapters[i].CalculatedArea = 0
                            subChapters[i].ShellScheme = ''
                        }
                    }
                    for (var i = 0; i < subChapters.length; i++) {
                        if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].ManufacturingCountry != '') {
                            if (!subChapters[i].isMachine && !subChapters[i].IsAccessory && subChapters[i].isBrochure) {
                                if (subChapters[i].ManufacturerName != null && subChapters[i].ManufacturerName != '') {
                                    var isSameBro = false
                                    if (uniqueManuNameMachine.includes(subChapters[i].ManufacturerName.toLowerCase().trim())) {
                                        subChapters[i].CalculatedArea = 0
                                        subChapters[i].ShellScheme = ''
                                        isSameBro = true
                                    }
                                    if (uniqueManuNameAcc.includes(subChapters[i].ManufacturerName.toLowerCase().trim())) {
                                        subChapters[i].CalculatedArea = 0
                                        subChapters[i].ShellScheme = ''
                                        isSameBro = true
                                    }
                                    if (uniqueManuNameBro.includes(subChapters[i].ManufacturerName.toLowerCase().trim())) {
                                        subChapters[i].CalculatedArea = 0
                                        subChapters[i].ShellScheme = ''
                                        isSameBro = true
                                    }
                                    if (!isSameBro) {
                                        uniqueManuNameBro.push(subChapters[i].ManufacturerName.toLowerCase().trim())
                                    }
                                } else {
                                    subChapters[i].CalculatedArea = 0
                                    subChapters[i].ShellScheme = ''
                                }
                            }
                        } else {
                            subChapters[i].CalculatedArea = 0
                            subChapters[i].ShellScheme = ''
                        }
                    }
                    for (var i = 0; i < subChapters.length; i++) {
                        if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].ManufacturingCountry != '') {
                            if (subChapters[i].isMachine) {
                                machineArea = machineArea + subChapters[i].CalculatedArea
                            }
                        }
                    }
                    var manuList = []
                    for (var i = 0; i < uniqueManuNameBro.length; i++) {
                        manuList.push({ 'ManufacturerName': uniqueManuNameBro[i].toLowerCase().trim(), isShow: 0, isRepeat: 0 })
                    }
                    console.log('uniqueManuNameBro', uniqueManuNameBro)
                    if (uniqueManuNameBro.length != 0) {
                        if ((accArea + machineArea) >= area) {
                            var criteriaBArea = uniqueManuNameBro.length * 3
                            for (var i = 0; i < referenceStallAreaArr.length; i++) {
                                if (criteriaBArea <= referenceStallAreaArr[i].StallArea) {
                                    criteriaBArea = referenceStallAreaArr[i].StallArea
                                    break
                                }

                            }
                            var noBro = criteriaBArea / 9
                            var calculatedAreaAssigned = 0
                            console.log('noBronoBronoBro', noBro)
                            var gap = 0
                            for (var i = 0; i < subChapters.length; i++) {
                                if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].ManufacturingCountry != '') {
                                    if (uniqueManuNameBro.includes(subChapters[i].ManufacturerName.toLowerCase().trim())) {
                                        if (calculatedAreaAssigned < noBro) {
                                            for (var j = 0; j < manuList.length; j++) {
                                                if (manuList[j].ManufacturerName.toLowerCase().trim() == subChapters[i].ManufacturerName.toLowerCase().trim()) {
                                                    if (manuList[j].isRepeat == 0) {
                                                        if (gap == 0) {
                                                            subChapters[i].CalculatedArea = 9
                                                            subChapters[i].ShellScheme = 2
                                                            calculatedAreaAssigned = calculatedAreaAssigned + 1
                                                            manuList[j].isRepeat = 1
                                                            gap = 2
                                                        } else {
                                                            subChapters[i].CalculatedArea = 0
                                                            subChapters[i].ShellScheme = ''
                                                            gap = gap - 1
                                                            manuList[j].isRepeat = 1
                                                        }
                                                    } else {
                                                        subChapters[i].CalculatedArea = 0
                                                        subChapters[i].ShellScheme = ''
                                                    }
                                                }
                                            }
                                        } else {
                                            for (var j = 0; j < uniqueManuNameBro.length; j++) {
                                                if (uniqueManuNameBro[j].toLowerCase().trim() == subChapters[i].ManufacturerName.toLowerCase().trim()) {
                                                    subChapters[i].CalculatedArea = 0
                                                    subChapters[i].ShellScheme = ''
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    subChapters[i].CalculatedArea = 0
                                    subChapters[i].ShellScheme = ''
                                }
                            }
                            broArea = criteriaBArea
                        } else {
                            var rem = area - (accArea + machineArea)
                            var criteriaBArea = uniqueManuNameBro.length * 3
                            for (var i = 0; i < referenceStallAreaArr.length; i++) {
                                if (criteriaBArea <= referenceStallAreaArr[i].StallArea) {
                                    criteriaBArea = referenceStallAreaArr[i].StallArea
                                    break
                                }

                            }
                            var criteriaAArea = 0
                            for (var i = 0; i < internationalAreaSlabList.length; i++) {
                                if (rem < internationalAreaSlabList[0].FromRange) {
                                    criteriaAArea = internationalAreaSlabList[0].MinArea
                                }
                                else if (internationalAreaSlabList[i].FromRange <= rem && rem <= internationalAreaSlabList[i].ToRange) {
                                    console.log(rem, internationalAreaSlabList[i])
                                    criteriaAArea = internationalAreaSlabList[i].MinArea
                                }
                            }
                            console.log('noBronoBronoBro', criteriaBArea, criteriaAArea)

                            if (criteriaBArea >= criteriaAArea) {
                                var noBro = criteriaBArea / 9
                                var calculatedAreaAssigned = 0
                                var gap = 0
                                for (var i = 0; i < subChapters.length; i++) {
                                    if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].ManufacturingCountry != '') {
                                        if (uniqueManuNameBro.includes(subChapters[i].ManufacturerName.toLowerCase().trim())) {
                                            if (calculatedAreaAssigned < noBro) {
                                                for (var j = 0; j < manuList.length; j++) {
                                                    if (manuList[j].ManufacturerName.toLowerCase().trim() == subChapters[i].ManufacturerName.toLowerCase().trim()) {
                                                        if (manuList[j].isRepeat == 0) {
                                                            if (gap == 0) {
                                                                console.log(manuList[j], gap, subChapters[i].ManufacturerName)
                                                                subChapters[i].CalculatedArea = 9
                                                                subChapters[i].ShellScheme = 2
                                                                calculatedAreaAssigned = calculatedAreaAssigned + 1
                                                                manuList[j].isRepeat = 1
                                                                gap = 2
                                                            } else {
                                                                subChapters[i].CalculatedArea = 0
                                                                subChapters[i].ShellScheme = ''
                                                                gap = gap - 1
                                                                manuList[j].isRepeat = 1
                                                            }
                                                        } else {
                                                            subChapters[i].CalculatedArea = 0
                                                            subChapters[i].ShellScheme = ''
                                                        }
                                                    }
                                                }
                                            } else {
                                                for (var j = 0; j < uniqueManuNameBro.length; j++) {
                                                    if (uniqueManuNameBro[j].toLowerCase().trim() == subChapters[i].ManufacturerName.toLowerCase().trim()) {
                                                        subChapters[i].CalculatedArea = 0
                                                        subChapters[i].ShellScheme = ''
                                                    }
                                                }
                                            }
                                        }
                                    } else {
                                        subChapters[i].CalculatedArea = 0
                                        subChapters[i].ShellScheme = ''
                                    }
                                }
                                broArea = criteriaBArea
                            } else {
                                var areainsert = false
                                for (var i = 0; i < subChapters.length; i++) {
                                    if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].ManufacturingCountry != '') {
                                        for (var j = 0; j < uniqueManuNameBro.length; j++) {
                                            if (uniqueManuNameBro[j].toLowerCase().trim() == subChapters[i].ManufacturerName.toLowerCase().trim()) {
                                                if (!areainsert) {
                                                    subChapters[i].CalculatedArea = criteriaAArea
                                                    subChapters[i].ShellScheme = 2
                                                    areainsert = true
                                                } else {
                                                    subChapters[i].CalculatedArea = 0
                                                    subChapters[i].ShellScheme = ''
                                                }
                                            }
                                        }
                                    } else {
                                        subChapters[i].CalculatedArea = 0
                                        subChapters[i].ShellScheme = ''
                                    }
                                }
                                broArea = criteriaAArea
                            }

                            // for (var i = 0; i < subChapters.length; i++) {
                            //     if (subChapters[i].ManufacturingCountry.toLowerCase().trim() != 'india' && subChapters[i].ManufacturingCountry != '') {
                            //         for (var j = 0; j < uniqueManuNameBro.length; j++) {
                            //             if (uniqueManuNameBro[j].toLowerCase().trim() == subChapters[i].ManufacturerName.toLowerCase().trim()) {
                            //                 if (j == 0) {
                            //                     subChapters[i].CalculatedArea = criteriaAArea
                            //                     subChapters[i].ShellScheme = 2
                            //                 } else {
                            //                     subChapters[i].CalculatedArea = 0
                            //                     subChapters[i].ShellScheme = ''
                            //                 }
                            //             }
                            //         }
                            //     }
                            // }

                        }
                    }

                    total = machineArea + accArea + broArea


                }
                this.setState({ InternationalArea: total, lengthWidthErr: '', isShowInternationalArea: total == 0 ? false : true }, () => {
                    console.log('here 4', 0)
                })
            } else {
                this.setState({ InternationalArea: 0, IAbare: 0, IAshell: 0, lengthWidthErr: '', isShowInternationalArea: false }, () => {
                    console.log('here 4', 0)
                })
                for (var i = 0; i < subChapters.length; i++) {
                    subChapters[i].CalculatedArea = 0
                    subChapters[i].ShellScheme = ''
                }
                this.setState({ subChapters: subChapters })
            }
        } else {
            this.setState({ InternationalArea: 0, lengthWidthErr: '', IAbare: 0, IAshell: 0, isShowInternationalArea: false }, () => {
                console.log('here 4', 0)
            })
            for (var i = 0; i < subChapters.length; i++) {
                subChapters[i].CalculatedArea = 0
                subChapters[i].ShellScheme = ''
                this.setState({ subChapters: subChapters })
            }
        }
        setTimeout(() => {
            this.setState({ subChapters: subChapters }, () => {
                for (var i = 0; i < subChapters.length; i++) {
                    console.log('subChapters[i]', subChapters[i])
                    if (subChapters[i].ShellScheme == 1) {
                        totalBare = totalBare + subChapters[i].CalculatedArea
                    } else if (subChapters[i].ShellScheme == 2) {
                        totalShell = totalShell + subChapters[i].CalculatedArea
                    }
                }
                this.setState({ IAbare: totalBare, IAshell: totalShell, })
            })
        }, 20);
    }

    render() {
        const { isLoading, firstName, comment, lastName, preFixPersonInch, ExhPrimaryChapterComment, personInchFirst, personInchLast, regDesignation, regCompany,
            fasciaName, regAdd1, regAdd2, regPin, regCity, regState, regCountry, regMob1, regMob2, regTel, regTel1, regTelFax, isReceiptGenerated, stallTypeIdList, stallTypeId, stallTypeIdErr, stallArea, stallAreaList, stallAreaErr, url, openSlides, lengthWidthErr, exhibitDetailsTableErr, InternationalArea, InternationalAreaErr, ExhibitDetailsNote, OpenSidePath, openSlidesErr, selectedPrimaryChapterId, toKeepOpen, isOpen2, primaryChapterListData, selectedPrimaryChapterIdList, MultiSelectNotes, primaryChapterId, ExhPrimaryChapterCommentErr, isOpen4, expectedArea, expectedAreaId,
            regPrimaryEmail, regSecondaryEmail, regWeb, preOwnerNameFirst, ownerNameFirst, ownerNameLast, ownerMob, preOwnerMob,
            ownerEmail, billPersonInchFirst, billPersonInchLast, billDesignation, billCompany, billAdd1, billAdd2, billPin, adminRemark,
            billCity, billState, billCountry, billMob1, billMob2, billTel, preBillTel1, billTel1, billTelFax, billPrimaryEmail,
            billSecondaryEmail, billWeb, companyRegNo, panNo, panName, gstNo, tanNo, iecCode, accName, accNo, accType, OpensameCountryManuErr,
            bankName, branchName, ifsc, personInchFirstErr, personInchLastErr, regDesignationErr, regCompanyErr, fasciaNameErr, isOpen10,
            regAdd1Err, regPinErr, regCityErr, regStateErr, regCountryErr, regMob1Err, regPrimaryEmailErr, ownerNameFirstErr,
            ownerEmailErr, billPersonInchFirstErr, billDesignationErr, billCompanyErr, billAdd1Err, billPinErr, billCityErr, intAreaRulesPop,
            billStateErr, billCountryErr, billMob1Err, billMob2Err, billPrimaryEmailErr, panNoErr, dueDate, internationalAreaSlabList,
            panNameErr, gstNoErr, statusErr, tanNoErr, uanNoErr, accNameErr, accNoErr, ifscErr, isMixRuleAgree, OpenMixExhibitorRule,
            isDisplayPincodeList, isDisplayCityList, isDisplayStateList, isDisplayCountryList, preRegMob1, preRegMob2,
            preRegTel, preRegTel1, isDisplayBillPincodeList, isDisplayBillCityList, isDisplayBillStateList, area,
            isDisplayBillCountryList, preBillMob1, preBillMob2, preBillTel, preFixBillPersonInch, billPersonInchLastErr, isView,
            isOtherPreFixPersonInch, otherPersonInchFirst, isOtherOwnerFirstName, otherOwnerFirstName, isOtherBillPersonInchFirst,
            otherBillPersonInchFirst, primaryChapterHeaderList, primaryChapterName, subChapters, exbTableErr, estimateDetails,
            isAgree, isAgree2, isAgree3, accTypeOthers, isPreviousOrSameDate, isOpen, lev2, lev3, lev4, countryId, AuthorizedPersonName, DesignationAuthorizedPerson, ExhibitorCompanyName, EmailAuthorizedPerson, SSIdiscount, MobileAuthorizedPerson, PreMobileAuthorizedPerson } = this.state
        console.log(InternationalArea, 'InternationalArea', this.state.oldsubChapters, subChapters)
        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };
        var mandatorymix = false
        subChapters.map(item => {
            if (item.ManufacturingCountry.toLowerCase().trim() != 'india' && countryId == 91) {
                mandatorymix = true
            }
        })
        var showMandatoryMark = false
        // showMandatoryMark = subChapters.length > 0 && subChapters.some(item => item.isMachine)
        var isAllBrochure = false
        const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india')
        if (filterArray.length > 0) {
            for (var i = 0; i < filterArray.length; i++) {
                if (!filterArray[i].isBrochure && !filterArray[i].IsAccessory && !filterArray[i].IsAccessory) {
                    isAllBrochure = false
                    break
                }
                if (filterArray[i].ManufacturingCountry.trim() == '' || filterArray[i].ManufacturingCountry.trim() == null) {
                    isAllBrochure = false
                    break
                }
                if (filterArray[i].isBrochure) {
                    isAllBrochure = true
                }
                if (filterArray[i].IsAccessory || filterArray[i].isMachine) {
                    isAllBrochure = false
                    break
                }
            }
        } else {
            isAllBrochure = false
        }
        const ExhibitionEmail = sessionStorage.getItem('sessionExhibitionEmail') != '' && sessionStorage.getItem('sessionExhibitionEmail') != null ? JSON.parse(sessionStorage.getItem('sessionExhibitionEmail')) : []
        const ExhibitionMobileNo = sessionStorage.getItem('sessionExhibitionMobileNo') != '' && sessionStorage.getItem('sessionExhibitionMobileNo') != null ? JSON.parse(sessionStorage.getItem('sessionExhibitionMobileNo')) : []
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <AdminDrawer />
                <div className="page">
                    <div className="page-main">
                        <div className="main-content with-dr-container com-height" style={{ marginTop: '6rem' }}>
                            <div className="row">
                                <div className="step-name">
                                    <p>Exhibitor Spacebooking</p>
                                </div>
                            </div>
                            {/* {console.log(JSON.parse(sessionStorage.getItem('loginDataSS')))} */}
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-xl-12 p-0">
                                        <div className="card rounded-0">
                                            <div className="card-body p-0">
                                                {/* <h6 className="" style={{ padding: "5px 7px 3px 0px" }}>
                                                    Dear {JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['CompanyName'] != null &&
                                                        JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['CompanyName']}
                                                </h6> */}
                                                <div className="row mt-1">
                                                    <div className="col-md-12">
                                                        <h6 style={{ padding: "5px 7px 0px 0px", color: "#0072ff" }}>
                                                            Registration Details
                                                        </h6>
                                                    </div>
                                                    <div className="col-xl-6">
                                                        <label htmlFor="validationCustom03">
                                                            Name of the Company <span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            disabled={isView}
                                                            value={regCompany}
                                                            onChange={(e) => this.setState({ regCompany: e.target.value, regCompanyErr: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{regCompanyErr}</span>}
                                                    </div>
                                                    <div className="col-xl-6">
                                                        <label htmlFor="validationCustom03">
                                                            Fascia Name (Shell Scheme Only)<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            maxLength={'250'}
                                                            disabled={isView}
                                                            value={fasciaName}
                                                            onChange={(e) => this.setState({ fasciaName: e.target.value, fasciaNameErr: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{fasciaNameErr}</span>}
                                                    </div>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-xl-6">
                                                        <label htmlFor="validationCustom03">
                                                            Address Line 1<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            disabled={isView} type="text"
                                                            maxLength={'200'}
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            value={regAdd1}
                                                            onChange={(e) => this.setState({ regAdd1: e.target.value, regAdd1Err: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{regAdd1Err}</span>}
                                                    </div>
                                                    <div className="col-xl-6">
                                                        <label htmlFor="validationCustom03">Address Line 2</label>
                                                        <input
                                                            type="text"
                                                            disabled={isView} className="form-control"
                                                            maxLength={'200'}
                                                            id="validationCustom03"
                                                            value={regAdd2}
                                                            onChange={(e) => this.setState({ regAdd2: e.target.value })}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">
                                                            City<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            disabled={isView} value={regCity}
                                                            onChange={(e) => this.onCitySearch(e)}
                                                        />
                                                        {isDisplayCityList && this.renderCityList()}
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{regCityErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">
                                                            {regCountry.toLowerCase().trim() == "india" ? 'state' : 'State/Province'}
                                                            {regCountry.toLowerCase().trim() == "india" ? <span className="text-red">*</span> : ''}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            disabled={isView} value={regState}
                                                            onChange={(e) => this.onStateSearch(e)}
                                                        />
                                                        {isDisplayStateList && this.renderStateList()}
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{regStateErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">
                                                            {regCountry.toLowerCase().trim() == "india" ? 'Pincode' : 'Zipcode'}
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        {
                                                            regCountry.toLowerCase().trim() == "india" &&
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="validationCustom03"
                                                                value={regPin}
                                                                disabled={isView} maxLength={6}
                                                                onChange={(e) => this.onPincodeSearch(e)}
                                                            />
                                                        }
                                                        {
                                                            regCountry.toLowerCase().trim() != "india" &&
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="validationCustom03"
                                                                value={regPin}
                                                                disabled={isView} maxLength={10}
                                                                onChange={(e) => this.onPincodeSearch(e)}
                                                                onInput={toInputUppercase}
                                                            />
                                                        }
                                                        {isDisplayPincodeList && this.renderPincodeList()}
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{regPinErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">
                                                            Country<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            disabled={isView} value={regCountry}
                                                            onChange={(e) => this.onCountrySearch(e)}
                                                        // onChange={(e) => console.log("country/0988988908_____",e)}
                                                        />
                                                        {isDisplayCountryList && this.renderCountryList()}
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{regCountryErr}</span>}
                                                    </div>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">
                                                            First Name of Person Incharge
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        {
                                                            isOtherPreFixPersonInch &&
                                                            <input
                                                                type="text"
                                                                disabled={isView} className="form-control-1 other-fil"
                                                                value={otherPersonInchFirst}
                                                                onChange={e => this.setState({ otherPersonInchFirst: e.target.value })}
                                                                placeholder={'Other'}
                                                                style={{
                                                                    // position: "absolute",
                                                                    paddingLeft: '5px'
                                                                }}
                                                            />
                                                        }
                                                        <input
                                                            type="text"
                                                            disabled={isView} className="form-control"
                                                            id="validationCustom03"
                                                            value={personInchFirst}
                                                            maxLength={'100'}
                                                            onChange={(e) => this.setState({ personInchFirst: e.target.value, personInchFirstErr: "" })}
                                                            style={{
                                                                // position: "absolute",
                                                                paddingLeft: '50px'
                                                            }}
                                                        />
                                                        <div className="col-xl-1 mb-3">
                                                            <div
                                                                className="form-group"
                                                                style={{
                                                                    width: '45px',
                                                                    position: "absolute",
                                                                    top: "-58px",
                                                                    left: '0px'
                                                                }}
                                                            >
                                                                <label />
                                                                <select
                                                                    disabled={isView}
                                                                    className="form-control-1 select2 select-hidden-accessible"
                                                                    id="roledb"
                                                                    style={{
                                                                        paddingLeft: '0px',
                                                                        paddingRight: '0px',
                                                                        borderTop: "none",
                                                                        borderBottom: "none",
                                                                        marginTop: '0px',
                                                                        textAlign: "left"
                                                                    }}
                                                                    value={preFixPersonInch}
                                                                    onChange={(e) => this.setState({
                                                                        preFixPersonInch: e.target.value,
                                                                        isOtherPreFixPersonInch: e.target.value == "Other" && true
                                                                    })}
                                                                >
                                                                    <option value="Mr">Mr</option>
                                                                    <option value="Ms">Ms</option>
                                                                    <option value="DR">DR</option>
                                                                    <option value="Prof">Prof</option>
                                                                    <option value="Other">Other</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{personInchFirstErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label>
                                                            Last Name of Person Incharge<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            disabled={isView} type="text"
                                                            className="form-control"
                                                            maxLength={'100'}
                                                            value={personInchLast}
                                                            onChange={(e) => this.setState({ personInchLast: e.target.value, personInchLastErr: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{personInchLastErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">
                                                            Designation<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            disabled={isView} value={regDesignation}
                                                            onChange={(e) => this.setState({ regDesignation: e.target.value, regDesignationErr: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{regDesignationErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">
                                                            Mobile<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={regMob1}
                                                            disabled={isView} maxLength={regCountry.toLowerCase().trim() == "China" ? 11 : 10}
                                                            onInput={(e) => this.maxLengthCheck(e, 10)}
                                                            onKeyDown={(e) => this.preventMinus(e)}
                                                            onWheel={(e) => e.target.blur()}
                                                            onPaste={(e) => this.handlePaste(e)}
                                                            style={{ paddingLeft: '50px' }}
                                                            onChange={(e) => e.target.value >= 0 &&
                                                                this.setState({ regMob1: e.target.value, regMob1Err: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{regMob1Err}</span>}
                                                        <input
                                                            type="text"
                                                            className="form-control-1"
                                                            value={preRegMob1}
                                                            disabled={isView} placeholder="ISD"
                                                            onChange={(e) => this.setState({ preRegMob1: e.target.value })}
                                                            style={{
                                                                width: '45px',
                                                                position: "absolute",
                                                                top: '22px',
                                                                padding: "6px !important",
                                                                paddingLeft: '5px',
                                                                borderLeft: '0px',
                                                                borderTop: '0px',
                                                                background: "none",
                                                                borderBottom: '0px',
                                                                height: '35px'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">Alternate Mobile No</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            style={{ paddingLeft: 50 }}
                                                            disabled={isView} value={regMob2}
                                                            maxLength={regCountry.toLowerCase().trim() == "China" ? 11 : 10}
                                                            onInput={(e) => this.maxLengthCheck(e, 10)} size={'10'}
                                                            onKeyDown={(e) => this.preventMinus(e)}
                                                            onPaste={(e) => this.handlePaste(e)}
                                                            onWheel={(e) => e.target.blur()}
                                                            onChange={(e) => e.target.value >= 0 && this.setState({ regMob2: e.target.value })}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="form-control-1"
                                                            disabled={isView} value={preRegMob2}
                                                            onChange={(e) => this.setState({ preRegMob2: e.target.value })}
                                                            style={{
                                                                width: 45,
                                                                position: "absolute",
                                                                top: 22,
                                                                padding: "6px !important",
                                                                paddingLeft: 5,
                                                                borderLeft: 0,
                                                                borderTop: 0,
                                                                background: "none",
                                                                borderBottom: 0,
                                                                height: 35
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">
                                                            Telephone
                                                        </label>
                                                        <input
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            type="number"
                                                            className="form-control"
                                                            style={{ paddingLeft: 50 }}
                                                            value={regTel} maxLength={'10'}
                                                            onPaste={(e) => this.handlePaste(e)}
                                                            onInput={(e) => this.maxLengthCheck(e, 10)} size={'10'}
                                                            onKeyDown={(e) => this.preventMinus(e)}
                                                            onWheel={(e) => e.target.blur()}
                                                            onChange={(e) => e.target.value >= 0 && this.setState({ regTel: e.target.value })}
                                                        />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{regTelErr}</span>} */}
                                                        <input
                                                            type="text"
                                                            className="form-control-1"
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            value={preRegTel}
                                                            onChange={(e) => this.setState({ preRegTel: e.target.value })}
                                                            style={{
                                                                width: 45,
                                                                position: "absolute",
                                                                top: 21,
                                                                padding: "6px !important",
                                                                paddingLeft: 5,
                                                                borderLeft: 0,
                                                                borderTop: 0,
                                                                background: "none",
                                                                borderBottom: 0,
                                                                height: 35
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">
                                                            Telephone 1
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            style={{ paddingLeft: 50 }}
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            value={regTel1} maxLength={'10'}
                                                            onPaste={(e) => this.handlePaste(e)}
                                                            onInput={(e) => this.maxLengthCheck(e, 10)} size={'10'}
                                                            onKeyDown={(e) => this.preventMinus(e)}
                                                            onWheel={(e) => e.target.blur()}
                                                            onChange={(e) => e.target.value >= 0 && this.setState({ regTel1: e.target.value })}
                                                        />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{regTelErr}</span>} */}
                                                        <input
                                                            type="text"
                                                            className="form-control-1"
                                                            value={preRegTel1}
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            onChange={(e) => this.setState({ preRegTel1: e.target.value })}
                                                            style={{
                                                                width: 45,
                                                                position: "absolute",
                                                                top: 22,
                                                                padding: "6px !important",
                                                                paddingLeft: 5,
                                                                borderLeft: 0,
                                                                borderTop: 0,
                                                                background: "none",
                                                                borderBottom: 0,
                                                                height: 35
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom01">Telefax</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            maxLength={50}
                                                            value={regTelFax}
                                                            onChange={e => this.setState({ regTelFax: e.target.value })}
                                                        />
                                                    </div>
                                                </div>


                                                <div className="row mt-2">
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">
                                                            Primary Email<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            // disabled={true}
                                                            disabled={isView}
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            value={regPrimaryEmail}
                                                            onChange={(e) => this.setState({ regPrimaryEmail: e.target.value, regPrimaryEmailErr: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{regPrimaryEmailErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">Secondary Email</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            id="validationCustom03"
                                                            maxLength={'100'}
                                                            value={regSecondaryEmail}
                                                            onChange={(e) => this.setState({ regSecondaryEmail: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="col-xl-6">
                                                        <label htmlFor="validationCustom03">Website</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            maxLength={'100'}
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            id="validationCustom03"
                                                            value={regWeb}
                                                            onChange={(e) => this.setState({ regWeb: e.target.value })}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-xl-6">
                                                        <label>
                                                            First Name of CEO/MD/President/Owner
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        {
                                                            isOtherOwnerFirstName &&
                                                            <input
                                                                type="text"
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                className="form-control-1 other-fil"
                                                                value={otherOwnerFirstName}
                                                                onChange={e => this.setState({ otherOwnerFirstName: e.target.value })}
                                                                placeholder={'Other'}
                                                                style={{
                                                                    // position: "absolute",
                                                                    paddingLeft: '5px'
                                                                }}
                                                            />
                                                        }
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            maxLength={100}
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            style={{ position: "relative", paddingLeft: '55px' }}
                                                            onChange={e => this.setState({ ownerNameFirst: e.target.value, ownerNameFirstErr: "" })}
                                                            value={ownerNameFirst}
                                                        />
                                                        <div className="col-xl-1 mb-3">
                                                            <div
                                                                className="form-group"

                                                                style={{
                                                                    width: '45px',
                                                                    position: "absolute",
                                                                    top: "-58px",
                                                                    left: '0px'
                                                                }}
                                                            >
                                                                <label />
                                                                <select
                                                                    // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                    disabled={isView}
                                                                    className="form-control-1 select2 select-hidden-accessible"
                                                                    id="roledb"
                                                                    style={{
                                                                        paddingLeft: '0px',
                                                                        paddingRight: '0px',
                                                                        borderTop: "none",
                                                                        borderBottom: "none",
                                                                        marginTop: '-2px',
                                                                        textAlign: "left"
                                                                    }}
                                                                    value={preOwnerNameFirst}
                                                                    onChange={e => this.setState({
                                                                        preOwnerNameFirst: e.target.value,
                                                                        isOtherOwnerFirstName: e.target.value == "Other" && true
                                                                    })}

                                                                >
                                                                    <option value="Mr">Mr</option>
                                                                    <option value="Ms">Ms</option>
                                                                    <option value="DR">DR</option>
                                                                    <option value="Prof">Prof</option>
                                                                    <option value="Other">Other</option>

                                                                </select>
                                                            </div>
                                                        </div>
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{ownerNameFirstErr}</span>}

                                                    </div>
                                                    <div className="col-xl-6">
                                                        <label htmlFor="validationCustom01">Last Name of CEO/MD/President/Owner</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            value={ownerNameLast}
                                                            maxLength={100}
                                                            onChange={e => this.setState({ ownerNameLast: e.target.value })}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row ">
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">
                                                            Owner Designation<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            value={this.state.ownerDesignation}
                                                            onChange={(e) => this.setState({ ownerDesignation: e.target.value, ownerDesignationErr: "" })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{this.state.ownerDesignationErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom01">Mobile No</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            value={ownerMob}
                                                            maxLength={regCountry.toLowerCase().trim() == "China" ? 11 : 10}
                                                            onChange={e => e.target.value >= 0 && this.setState({ ownerMob: e.target.value })}
                                                            onInput={e => this.maxLengthCheck(e, 10)} size={'10'}
                                                            onKeyDown={(e) => this.preventMinus(e)}
                                                            onWheel={(e) => e.target.blur()}
                                                            style={{ paddingLeft: '50px' }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder="STD"
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            className="form-control-1"
                                                            value={preOwnerMob}
                                                            onChange={e => this.setState({ preOwnerMob: e.target.value })}
                                                            // placeholder={+91}
                                                            style={{
                                                                width: '45px',
                                                                position: "absolute",
                                                                top: '23px',
                                                                left: '12px',
                                                                paddingLeft: '14px'
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-xl-6">
                                                        <label htmlFor="validationCustom01">
                                                            Email<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            maxLength={100}
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            value={ownerEmail}
                                                            onChange={e => this.setState({ ownerEmail: e.target.value, ownerEmailErr: '' })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{ownerEmailErr}</span>}

                                                    </div>
                                                </div>

                                                <div className="main-container bg-section p-2 mt-3">
                                                    <div className="row ">
                                                        <div className="col-md-12">
                                                            <h6 style={{ padding: "5px 7px 0px 0px", color: "#0072ff" }}>
                                                                Invoice Details
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <div className="row">

                                                        <div className="col-xl-6">
                                                            <label htmlFor="validationCustom03">
                                                                Name of the Company<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="validationCustom03"
                                                                // disabled={true}
                                                                disabled={isView}
                                                                value={billCompany}
                                                                onChange={(e) => this.setState({ billCompany: e.target.value, billCompanyErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{billCompanyErr}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-xl-6">
                                                            <label htmlFor="validationCustom03">
                                                                Address Line 1<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                maxLength={'200'}
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                id="validationCustom03"
                                                                value={billAdd1}
                                                                onChange={(e) => this.setState({ billAdd1: e.target.value, billAdd1Err: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{billAdd1Err}</span>}
                                                        </div>
                                                        <div className="col-xl-6">
                                                            <label htmlFor="validationCustom03">Address Line 2</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                maxLength={'200'}
                                                                id="validationCustom03"
                                                                value={billAdd2}
                                                                onChange={(e) => this.setState({ billAdd2: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-xl-3">
                                                            <label htmlFor="validationCustom03">
                                                                City<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="validationCustom03"
                                                                // disabled={true}
                                                                disabled={isView}
                                                                value={billCity}
                                                                onChange={(e) => this.onBillCitySearch(e)}
                                                            />
                                                            {isDisplayBillCityList && this.renderBillCityList()}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{billCityErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="validationCustom03">
                                                                {billCountry.toLowerCase().trim() == "india" ? 'State' : 'State/Province'}
                                                                {billCountry.toLowerCase().trim() == "india" ? <span className="text-red">*</span> : ""}
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="validationCustom03"
                                                                // disabled={true}
                                                                disabled={isView}
                                                                value={billState}
                                                                onChange={(e) => this.onBillStateSearch(e)}
                                                            />
                                                            {isDisplayBillStateList && this.renderBillStateList()}
                                                            {billCountry.toLowerCase().trim() == "india" ? <span className='text-danger text-start text-left d-block mt-1'>{billStateErr}</span> : ""}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="validationCustom03">
                                                                {billCountry.toLowerCase().trim() == "india" ? 'Pincode' : 'Zipcode'}
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            {
                                                                billCountry.toLowerCase().trim() == "india" &&
                                                                <input
                                                                    type="text"
                                                                    maxLength={6}
                                                                    className="form-control"
                                                                    id="validationCustom03"
                                                                    // disabled={true}
                                                                    disabled={isView}
                                                                    value={billPin}
                                                                    onChange={(e) => this.onBillPincodeSearch(e)}
                                                                />
                                                            }
                                                            {
                                                                billCountry.toLowerCase().trim() != "india" &&
                                                                <input
                                                                    type="number"
                                                                    maxLength={10}
                                                                    className="form-control"
                                                                    id="validationCustom03"
                                                                    value={billPin}
                                                                    // disabled={true}
                                                                    disabled={isView}
                                                                    onChange={(e) => this.onBillPincodeSearch(e)}
                                                                    onInput={toInputUppercase}
                                                                />
                                                            }
                                                            {isDisplayBillPincodeList && this.renderBillPincodeList()}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{billPinErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="validationCustom03">
                                                                Country<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="validationCustom03"
                                                                // disabled={true}
                                                                disabled={isView}
                                                                value={billCountry}
                                                                onChange={(e) => this.onBillCountrySearch(e)}
                                                            />
                                                            {isDisplayBillCountryList && this.renderBillCountryList()}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{billCountryErr}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-xl-3">
                                                            <label htmlFor="validationCustom03">
                                                                First Name of Person Incharge
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            {
                                                                isOtherBillPersonInchFirst &&
                                                                <input
                                                                    type="text"
                                                                    // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                    disabled={isView}
                                                                    className="form-control-1 other-fil"
                                                                    value={otherBillPersonInchFirst}
                                                                    onChange={e => this.setState({ otherBillPersonInchFirst: e.target.value })}
                                                                    placeholder={'Other'}
                                                                    style={{
                                                                        // position: "absolute",
                                                                        paddingLeft: '5px'
                                                                    }}
                                                                />
                                                            }
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                id="validationCustom03"
                                                                maxLength={'100'}
                                                                value={billPersonInchFirst}
                                                                onChange={(e) => this.setState({ billPersonInchFirst: e.target.value, billPersonInchFirstErr: "" })}
                                                                style={{
                                                                    // position: "absolute",
                                                                    paddingLeft: '50px'
                                                                }}
                                                            />
                                                            <div className="col-xl-1 mb-3">
                                                                <div
                                                                    className="form-group"
                                                                    style={{
                                                                        width: '45px',
                                                                        position: "absolute",
                                                                        top: "-58px",
                                                                        left: '0px'
                                                                    }}
                                                                >
                                                                    <label />
                                                                    <select
                                                                        // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                        disabled={isView}
                                                                        className="form-control-1 select2 select-hidden-accessible"
                                                                        id="roledb"
                                                                        style={{
                                                                            paddingLeft: '0px',
                                                                            paddingRight: '0px',
                                                                            borderTop: "none",
                                                                            borderBottom: "none",
                                                                            marginTop: '0px',
                                                                            textAlign: "left"
                                                                        }}
                                                                        value={preFixBillPersonInch}
                                                                        onChange={(e) => this.setState({
                                                                            preFixBillPersonInch: e.target.value,
                                                                            isOtherBillPersonInchFirst: e.target.value == "Other" && true
                                                                        })}
                                                                    >
                                                                        <option value="Mr">Mr</option>
                                                                        <option value="Ms">Ms</option>
                                                                        <option value="DR">DR</option>
                                                                        <option value="Prof">Prof</option>
                                                                        <option value="Other">Other</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{billPersonInchFirstErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label>
                                                                Last Name of Person Incharge<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                maxLength={100}
                                                                value={billPersonInchLast}
                                                                onChange={(e) => this.setState({ billPersonInchLast: e.target.value, billPersonInchLastErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{billPersonInchLastErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="validationCustom03">
                                                                Designation<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                id="validationCustom03"
                                                                maxLength={'100'}
                                                                value={billDesignation}
                                                                onChange={(e) => this.setState({ billDesignation: e.target.value, billDesignationErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{billDesignationErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="validationCustom03">
                                                                Mobile 1<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                style={{ paddingLeft: '50px' }}
                                                                id="validationCustom03"
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                value={billMob1}
                                                                maxLength={billCountry.toLowerCase().trim() == "China" ? 11 : 10}
                                                                onInput={(e) => this.maxLengthCheck(e, 10)} size={'10'}
                                                                onKeyDown={(e) => this.preventMinus(e)}
                                                                onPaste={(e) => this.handlePaste(e)}
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) => e.target.value >= 0 && this.setState({ billMob1: e.target.value, billMob1Err: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{billMob1Err}</span>}
                                                            <input
                                                                type="text"
                                                                className="form-control-1"
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                value={preBillMob1}
                                                                onChange={(e) => this.setState({ preBillMob1: e.target.value })}
                                                                style={{
                                                                    width: 45,
                                                                    position: "absolute",
                                                                    top: 21,
                                                                    padding: "6px !important",
                                                                    paddingLeft: 5,
                                                                    borderLeft: 0,
                                                                    borderTop: 0,
                                                                    background: "none",
                                                                    borderBottom: 0,
                                                                    height: 35
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="validationCustom03">
                                                                Alternate Mobile No
                                                            </label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                style={{ paddingLeft: '50px' }}
                                                                id="validationCustom03"
                                                                value={billMob2}
                                                                maxLength={billCountry.toLowerCase().trim() == "China" ? 11 : 10}
                                                                onInput={(e) => this.maxLengthCheck(e, 10)} size={'10'}
                                                                onKeyDown={(e) => this.preventMinus(e)}
                                                                onPaste={(e) => this.handlePaste(e)}
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) => e.target.value >= 0 && this.setState({ billMob2: e.target.value })}
                                                            />
                                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{billMob2Err}</span>} */}
                                                            <input
                                                                type="text"
                                                                className="form-control-1"
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                value={preBillMob2}
                                                                onChange={(e) => this.setState({ preBillMob2: e.target.value })}
                                                                style={{
                                                                    width: 45,
                                                                    position: "absolute",
                                                                    top: 22,
                                                                    padding: "6px !important",
                                                                    paddingLeft: 5,
                                                                    borderLeft: 0,
                                                                    borderTop: 0,
                                                                    background: "none",
                                                                    borderBottom: 0,
                                                                    height: 35
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="validationCustom03">
                                                                Telephone No
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="validationCustom03"
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                value={billTel} maxLength={'10'}
                                                                onInput={(e) => this.maxLengthCheck(e, 10)} size={'10'}
                                                                onKeyDown={(e) => this.preventMinus(e)}
                                                                onPaste={(e) => this.handlePaste(e)}
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) => e.target.value >= 0 && this.setState({ billTel: e.target.value })}
                                                            />
                                                            <input
                                                                type="text"
                                                                className="form-control-1"
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                value={preBillTel}
                                                                onChange={(e) => this.setState({ preBillTel: e.target.value })}
                                                                style={{
                                                                    width: 45,
                                                                    position: "absolute",
                                                                    top: 22,
                                                                    padding: "6px !important",
                                                                    paddingLeft: 5,
                                                                    borderLeft: 0,
                                                                    borderTop: 0,
                                                                    background: "none",
                                                                    borderBottom: 0,
                                                                    height: 35
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="validationCustom03">
                                                                Telephone 1
                                                            </label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                style={{ paddingLeft: 50 }}
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                value={billTel1} maxLength={'10'}
                                                                onInput={(e) => this.maxLengthCheck(e, 10)} size={'10'}
                                                                onKeyDown={(e) => this.preventMinus(e)}
                                                                onPaste={(e) => this.handlePaste(e)}
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) => e.target.value >= 0 && this.setState({ billTel1: e.target.value })}
                                                            />
                                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{regTelErr}</span>} */}
                                                            <input
                                                                type="text"
                                                                className="form-control-1"
                                                                value={preBillTel1}
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                onChange={(e) => this.setState({ preBillTel1: e.target.value })}
                                                                style={{
                                                                    width: 45,
                                                                    position: "absolute",
                                                                    top: 22,
                                                                    padding: "6px !important",
                                                                    paddingLeft: 5,
                                                                    borderLeft: 0,
                                                                    borderTop: 0,
                                                                    background: "none",
                                                                    borderBottom: 0,
                                                                    height: 35
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-xl-3 mb-1">
                                                            <label htmlFor="validationCustom01">Telefax</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                maxLength={50}
                                                                value={billTelFax}
                                                                onChange={e => this.setState({ billTelFax: e.target.value })}
                                                            />
                                                        </div>

                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-xl-3">
                                                            <label htmlFor="validationCustom03">
                                                                Primary Email<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                // disabled={true}
                                                                disabled={isView}
                                                                id="validationCustom03"
                                                                value={billPrimaryEmail}
                                                                onChange={(e) => this.setState({ billPrimaryEmail: e.target.value, billPrimaryEmailErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{billPrimaryEmailErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="validationCustom03">
                                                                Secondary Email
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                id="validationCustom03"
                                                                value={billSecondaryEmail}
                                                                maxLength={'100'}
                                                                onChange={(e) => this.setState({ billSecondaryEmail: e.target.value })}
                                                            />
                                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{billSecondaryEmailErr}</span>} */}
                                                        </div>
                                                        <div className="col-xl-6">
                                                            <label htmlFor="validationCustom03">
                                                                Website
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="validationCustom03"
                                                                maxLength={'100'}
                                                                value={billWeb}
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                onChange={(e) => this.setState({ billWeb: e.target.value })}
                                                            />
                                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{billWebErr}</span>} */}
                                                        </div>
                                                    </div>
                                                </div>


                                                {
                                                    regCountry.toLowerCase().trim() == "india" ?
                                                        (
                                                            <div className="main-container">
                                                                <div className="row mt-4">
                                                                    <div className="col-md-12">
                                                                        <h6 style={{ padding: "5px 7px 0px 0px", color: "#0072ff" }}>
                                                                            Company Credentials
                                                                        </h6>
                                                                    </div>
                                                                </div>
                                                                <div className="row ">
                                                                    <div className="col-xl-3">
                                                                        <label htmlFor="validationCustom03">
                                                                            PAN Card Name
                                                                            {regCountry.toLowerCase().trim() == "india" && <span className="text-red">*</span>}
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="validationCustom03"
                                                                            // disabled={true}
                                                                            disabled={isView}
                                                                            value={panName}
                                                                            onChange={(e) => this.setState({ panName: e.target.value, panNameErr: "" })}
                                                                        />
                                                                        {regCountry.toLowerCase().trim() == "india" && <span className='text-danger text-start text-left d-block mt-1'>{panNameErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label htmlFor="validationCustom03">
                                                                            PAN Card no
                                                                            {regCountry.toLowerCase().trim() == "india" && <span className="text-red">*</span>}
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="validationCustom03"
                                                                            // disabled={true}
                                                                            disabled={isView}
                                                                            value={panNo}
                                                                            onChange={(e) => this.setState({ panNo: e.target.value, panNoErr: "" })}
                                                                        />
                                                                        {regCountry.toLowerCase().trim() == "india" && <span className='text-danger text-start text-left d-block mt-1'>{panNoErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label htmlFor="validationCustom03">
                                                                            TAN Number
                                                                            {regCountry.toLowerCase().trim() == "india" && <span className="text-red">*</span>}
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="validationCustom03"
                                                                            // disabled={true}
                                                                            disabled={isView}
                                                                            value={tanNo}
                                                                            onChange={(e) => this.setState({ tanNo: e.target.value, tanNoErr: "" })}
                                                                        />
                                                                        {regCountry.toLowerCase().trim() == "india" && <span className='text-danger text-start text-left d-block mt-1'>{tanNoErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label htmlFor="validationCustom03">
                                                                            GST No
                                                                            {regCountry.toLowerCase().trim() == "india" && <span className="text-red">*</span>}
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="validationCustom03"
                                                                            // disabled={true}
                                                                            disabled={isView}
                                                                            value={gstNo}
                                                                            onChange={(e) =>
                                                                                this.onGSTchange(e.target.value)
                                                                            }
                                                                        // onChange={(e) => this.setState({ gstNo: e.target.value, gstNoErr: "" })}
                                                                        />
                                                                        {regCountry.toLowerCase().trim() == "india" && <span className='text-danger text-start text-left d-block mt-1'>{gstNoErr}</span>}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label htmlFor="validationCustom03">
                                                                            Company Registration No
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="validationCustom03"
                                                                            // disabled={true}
                                                                            disabled={isView}
                                                                            value={companyRegNo}
                                                                            onChange={(e) => this.setState({ companyRegNo: e.target.value })}
                                                                        />
                                                                        {/* {regCountry.toLowerCase().trim() == "india" && <span className='text-danger text-start text-left d-block mt-1'>{companyRegNoErr}</span>} */}
                                                                    </div>
                                                                    <div className="col-xl-3">
                                                                        <label htmlFor="validationCustom03">
                                                                            IEC Code
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="validationCustom03"
                                                                            // disabled={true}
                                                                            disabled={isView}
                                                                            value={iecCode}
                                                                            onChange={(e) => this.setState({ iecCode: e.target.value })}
                                                                        />
                                                                        {/* {regCountry.toLowerCase().trim() == "india" && <span className='text-danger text-start text-left d-block mt-1'>{iecCodeErr}</span>} */}
                                                                    </div>

                                                                </div>
                                                                <div className="row mt-2">
                                                                    {/* <div className="col-xl-3">
                                                                    <label htmlFor="validationCustom03">
                                                                        Status
                                                                        {regCountry == "india" && <span className="text-red">*</span>}
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="validationCustom03"
                                                                        value={status}
                                                                        onChange={(e) => this.setState({ status: e.target.value, statusErr: "" })}
                                                                    />
                                                                    {regCountry == "india" && <span className='text-danger text-start text-left d-block mt-1'>{statusErr}</span>}
                                                                </div> */}

                                                                    {/* <div className="col-xl-3">
                                                                    <label htmlFor="validationCustom03">
                                                                        UAN No
                                                                        {regCountry == "india" && <span className="text-red">*</span>}
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="validationCustom03"
                                                                        value={uanNo}
                                                                        onChange={(e) => this.setState({ uanNo: e.target.value, uanNoErr: "" })}
                                                                    />
                                                                    {regCountry == "india" && <span className='text-danger text-start text-left d-block mt-1'>{uanNoErr}</span>}
                                                                </div> */}

                                                                </div>
                                                            </div>
                                                        ) : (null)
                                                }
                                                {
                                                    regCountry.toLowerCase().trim() == "india" &&
                                                    <div className="main-container bg-section p-2 mt-3">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <h6 style={{ padding: "5px 7px 0px 0px", color: "#0072ff" }}>
                                                                    Bank Details
                                                                </h6>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-2">
                                                            <div className="col-xl-4">
                                                                <label htmlFor="validationCustom03">
                                                                    Account Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="validationCustom03"
                                                                    // disabled={true}
                                                                    disabled={isView}
                                                                    value={accName}
                                                                    onChange={(e) => this.setState({ accName: e.target.value, accNameErr: "" })}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{accNameErr}</span>}
                                                            </div>
                                                            <div className="col-xl-4">
                                                                <label htmlFor="validationCustom03">
                                                                    Account No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="validationCustom03"
                                                                    // disabled={true}
                                                                    disabled={isView}
                                                                    value={accNo} maxLength={'30'}
                                                                    onInput={e => this.maxLengthCheck(e, 30)}
                                                                    onChange={(e) => this.setState({ accNo: e.target.value, accNoErr: "" })}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{accNoErr}</span>}
                                                            </div>
                                                            {/* <div className="col-xl-4">
                                                            <label htmlFor="validationCustom03">Account Type</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="validationCustom03"
                                                                value={accType}
                                                                onChange={(e) => this.setState({ accType: e.target.value })}
                                                            />
                                                        </div> */}
                                                            <div className="col-xl-4 ">
                                                                <label htmlFor="validationCustom01">Account Type</label>
                                                                <select
                                                                    className="form-control-1 select2 onl-bor select-hidden-accessible text-left"
                                                                    id="roledb"
                                                                    style={{ textAlign: "left" }}
                                                                    value={accType}
                                                                    // disabled={true}
                                                                    disabled={isView}
                                                                    onChange={e => this.setState({ accType: e.target.value })}>
                                                                    <option>Select</option>
                                                                    <option value={'Saving account'}>Saving account</option>
                                                                    <option value={'Current account'}>Current account</option>
                                                                    <option value={'Overdraft account'}>Overdraft account</option>
                                                                    <option value={'Others'}>Others</option>
                                                                </select>
                                                                {accType == 'Others' ? (
                                                                    <input
                                                                        type="text"
                                                                        maxLength={20}
                                                                        // disabled={true}
                                                                        disabled={isView}
                                                                        className="form-control acount-type-oth"
                                                                        value={accTypeOthers}
                                                                        onChange={e => this.setState({ accTypeOthers: e.target.value })}
                                                                    />
                                                                ) : (null)}

                                                            </div>
                                                        </div>
                                                        <div className="row mt-2">
                                                            <div className="col-xl-4">
                                                                <label htmlFor="validationCustom03">
                                                                    Bank Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="validationCustom03"
                                                                    // disabled={true}
                                                                    disabled={isView}
                                                                    value={bankName}
                                                                    onChange={(e) => this.setState({ bankName: e.target.value })}
                                                                />
                                                                {/* {<span className='text-danger text-start text-left d-block mt-1'>{bankNameErr}</span>} */}
                                                            </div>
                                                            <div className="col-xl-4">
                                                                <label htmlFor="validationCustom03">
                                                                    Branch Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="validationCustom03"
                                                                    // disabled={true}
                                                                    disabled={isView}
                                                                    value={branchName}
                                                                    onChange={(e) => this.setState({ branchName: e.target.value })}
                                                                />
                                                                {/* {<span className='text-danger text-start text-left d-block mt-1'>{branchNameErr}</span>} */}
                                                            </div>
                                                            <div className="col-xl-4">
                                                                <label htmlFor="validationCustom03">
                                                                    IFSC Code
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="validationCustom03"
                                                                    // disabled={true}
                                                                    disabled={isView}
                                                                    value={ifsc}
                                                                    onChange={(e) => this.setState({ ifsc: e.target.value, ifscErr: "" })}
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{ifscErr}</span>}
                                                            </div>
                                                        </div>
                                                    </div >
                                                }
                                                <hr />
                                                <div className="row mt-4 chapter-list">
                                                    {/* {
                                                        primaryChapterHeaderList.length > 0 && primaryChapterHeaderList.map((data) => (
                                                            <div>
                                                                <p>
                                                                    Selected Stall Category{" "}
                                                                    <span>
                                                                        <spa> : {data.StallTypeName}</spa>
                                                                    </span>
                                                                </p>
                                                                <p>
                                                                    Total Area Booked :
                                                                    <span>
                                                                        <spa>{`${data.StallArea} ${data.Unit}`}</spa>
                                                                    </span>
                                                                </p>
                                                                <p>
                                                                    Stall Dimension :
                                                                    <span>
                                                                        <spa>{`${data.ExhibitionStallDimension}`}</spa>
                                                                    </span>
                                                                </p>
                                                                <p>
                                                                    Open Sides :{" "}
                                                                    <span>
                                                                        <spa>{data.OpenSides}</spa>
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        ))
                                                    } */}

                                                    <div className="card card-cus card-cus-2 mt-2 mb-2 cus-width">
                                                        {/* <p className="p-3">
                                                            Selected Primary Chapter :{" "}
                                                            <span>
                                                                <spa>{primaryChapterName}</spa>
                                                            </span>
                                                        </p> */}
                                                        {console.log(primaryChapterListData, selectedPrimaryChapterId, selectedPrimaryChapterIdList, 'selectedPrimaryChapterIdListselectedPrimaryChapterIdList')}

                                                        <div className="asc" style={{ border: "1px solid #ddd" }}>
                                                            <div
                                                                className="card-header p-2 mb-2"
                                                                style={{ padding: "9px!important" }}
                                                            >
                                                                <h3 className="card-title" style={{ fontSize: 14 }}>
                                                                    Select Primary Chapter <span className="text-red" style={{ marginLeft: '5px', marginTop: '-0px', fontSize: '15px' }}>(Select at least one primary chapter)*</span>
                                                                </h3>
                                                                {/* {<span className='text-danger text-start text-left d-block mt-1' style={{ marginLeft: '10px' }}>{primaryChapterIdErr}</span>} */}
                                                            </div>

                                                            <div
                                                                className=""
                                                                style={{ paddingLeft: 10, paddingRight: 10 }}
                                                            >

                                                                {
                                                                    primaryChapterListData.length > 0 && primaryChapterListData.map((data, i) => (
                                                                        <>
                                                                            {/* {data.ChapterName.trim() != 'ANY OTHER' && */}
                                                                            <div className="form-row" key={i}>
                                                                                <label key={i}>
                                                                                    <input type="checkbox" key={data.ChapterID}
                                                                                        name={i}
                                                                                        disabled={isView}
                                                                                        // select= {data.IsSelect}
                                                                                        checked={data.isChecked}
                                                                                        // value={data.isChecked}
                                                                                        onClick={e => this.handleClickSelectPrimaryChapter(data, data.ChapterID)}
                                                                                    />
                                                                                    {data.ChapterName}
                                                                                </label>
                                                                            </div>
                                                                            {/* }  */}
                                                                        </>
                                                                    ))
                                                                }

                                                            </div>
                                                            {primaryChapterListData.filter(item => item.isChecked).length > 1 && <>

                                                                <div
                                                                    className="mb-3"
                                                                    style={{ paddingLeft: 10, paddingRight: 10, marginTop: 20, textAlign: 'left' }}
                                                                >
                                                                    <div className="col-4 mb-2" style={{ marginBottom: '25px' }}>
                                                                        <label>Please select Chapter for Hall preference <span style={{ color: 'red' }}>*</span></label>
                                                                        <select
                                                                            className="form-control"
                                                                            id="roledb"
                                                                            style={{ textAlign: "left" }}
                                                                            value={this.state.selectedPrimaryChapterId}
                                                                            disabled={isView ? true : this.state.selectedPrimaryChapterIdList.includes(1382)}
                                                                            onChange={(e) => this.setState({
                                                                                selectedPrimaryChapterId: e.target.value,
                                                                                primaryChapterId: e.target.value,
                                                                                defaultprimaryChapterIdErr: ''
                                                                            })}
                                                                        >
                                                                            <option>Select</option>
                                                                            {primaryChapterListData.length > 0 && primaryChapterListData.map((data) => (
                                                                                this.checkSame(data.ChapterID) && <option key={data.ChapterID} value={data.ChapterID}
                                                                                >{data.ChapterName}</option>
                                                                            ))}
                                                                        </select>
                                                                        {<span className='text-danger text-start text-left d-block mt-1'>{this.state.defaultprimaryChapterIdErr}</span>}
                                                                    </div>
                                                                    {MultiSelectNotes.length > 0 && <strong>Note<br /></strong>}
                                                                    {
                                                                        MultiSelectNotes.length > 0 && MultiSelectNotes.map((data, i) => (
                                                                            <div className='mb-1'>
                                                                                <strong>({i + 1})</strong>  {data.Description}
                                                                                < br />
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </div>
                                                                <div style={{ textAlign: 'left', marginTop: '20px', marginBottom: '20px' }} className="col-md-12 ">

                                                                    <label>Remark/Comment <span className="text-red" style={{ marginLeft: '5px', marginTop: '-0px', fontSize: '15px' }}>(please provide deatils as per the notes above in the comment box)*</span></label>
                                                                    <textarea maxLength={500} disabled={isView} value={this.state.ExhPrimaryChapterComment} className="form-control" onChange={(e) => this.setState({ ExhPrimaryChapterComment: e.target.value, ExhPrimaryChapterCommentErr: '' })}>
                                                                    </textarea>
                                                                    {
                                                                        <span className="text-danger text-start text-left d-block mt-1">
                                                                            {ExhPrimaryChapterCommentErr}
                                                                        </span>
                                                                    }
                                                                </div>
                                                            </>}
                                                        </div>

                                                        <div
                                                            className="card-header cus-hed"

                                                        >
                                                            <strong>Scheme Type <span className="text-red">*</span></strong>
                                                        </div>
                                                        <div className="form-row mt-1 p-2">
                                                            {/* {console.log('isReceiptGenerateisReceiptGenerate', isReceiptGenerate)} */}
                                                            {
                                                                stallTypeIdList.length > 0 && stallTypeIdList.map((stallTypeIdListData) => (
                                                                    <div className="col-xl-2">
                                                                        <label>
                                                                            <input type="radio"
                                                                                id={'stallTypeId'}
                                                                                name={'stallTypeId'}
                                                                                radioGroup={stallTypeId == stallTypeIdListData.Code && true}
                                                                                select={stallTypeId == stallTypeIdListData.Code && true}
                                                                                checked={stallTypeId == stallTypeIdListData.Code && true}
                                                                                value={stallTypeId}
                                                                                // disabled={isReceiptGenerated}
                                                                                disabled={isView}
                                                                                onChange={e => this.onSchemeTypeChange(e, stallTypeIdListData.Code)}
                                                                            />
                                                                            {stallTypeIdListData.Description}
                                                                        </label>
                                                                    </div>
                                                                ))
                                                            }
                                                            {<span className='text-danger '>{stallTypeIdErr}</span>}

                                                        </div>
                                                        <div
                                                            className="card-header cus-hed"
                                                            style={{

                                                                borderTop: "1px solid #eee"
                                                            }}
                                                        >
                                                            <strong>Stall Area <span className="text-red">*</span></strong>
                                                        </div>
                                                        <div className="form-row mt-1 p-2">
                                                            <div className="col-xl-3">
                                                                <label>Length * width in Meters</label>
                                                                <select
                                                                    className="form-control select2 select-hidden-accessible pl-0"
                                                                    id="roledb"
                                                                    // disabled={isReceiptGenerated}
                                                                    disabled={isView}
                                                                    value={stallArea}
                                                                    onChange={e => this.onLengthTypeChange(e)}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {
                                                                        stallAreaList.length > 0 && stallAreaList.map(stallAreaData => (
                                                                            <option value={stallAreaData.Code} key={stallAreaData.Code}>{stallAreaData.Description}</option>
                                                                        ))
                                                                    }


                                                                </select>
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{stallAreaErr}</span>}
                                                            </div>
                                                            {stallArea != '' && stallArea != 'Select' &&
                                                                <div className="">
                                                                    <label className='mt-4'></label>
                                                                    <span><strong>{this.state.area} sqm.</strong></span>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div
                                                            className="card-header  cus-hed mt-2"
                                                            style={{

                                                                borderTop: "1px solid #eee",
                                                                position: "relative"
                                                            }}
                                                        >
                                                            <strong>
                                                                Open Sides (Please Tick the no required) <span className="text-red">*</span>
                                                            </strong>
                                                            {this.state.isChargesforOpenSides && <p>
                                                                <a
                                                                    // href={`files/${sessionStorage.getItem("sessionExhibitionID")}/Open-side-Charges.pdf`}
                                                                    href={url + OpenSidePath}
                                                                    target="_blank"
                                                                    rel="noreferrer"><span class="tool" style={{ color: '#0056ff' }}>Please Refer Rule </span>
                                                                </a></p>}
                                                        </div>
                                                        <div className="form-row mt-1 p-2">
                                                            {this.state.openSideList.length > 0 && this.state.openSideList.map(item => (
                                                                <>
                                                                    {item.OpenSidesID == 4 ? this.state.area >= this.state.minAreafor4OpenSide ? <div className="col-xl-2">
                                                                        <label>
                                                                            <input type="radio" name="openSlides" value={openSlides}
                                                                                checked={openSlides == item.OpenSidesID}
                                                                                // disabled={isReceiptGenerated}
                                                                                disabled={isView}
                                                                                onClick={e => this.setState({ openSlides: item.OpenSidesID, openSlidesErr: '' })} /> {
                                                                                item.OpenSideName
                                                                            }
                                                                        </label>
                                                                    </div> : '' : <div className="col-xl-2">
                                                                        <label>
                                                                            <input type="radio" name="openSlides" value={openSlides}
                                                                                checked={openSlides == item.OpenSidesID}
                                                                                // disabled={isReceiptGenerated}
                                                                                disabled={isView}
                                                                                onClick={e => this.setState({ openSlides: item.OpenSidesID, openSlidesErr: '' })} /> {
                                                                                item.OpenSideName
                                                                            }
                                                                        </label>
                                                                    </div>}
                                                                </>
                                                            ))}
                                                            {/* <div className="col-xl-2">
                                                                            <label>
                                                                                <input type="radio" name="openSlides" value={openSlides}
                                                                                    checked={openSlides == '1'}
                                                                                    onClick={e => this.setState({ openSlides: '1', openSlidesErr: '' })} /> 1 Open Side
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-xl-2">
                                                                            <label>
                                                                                <input type="radio" name="openSlides" value={openSlides}
                                                                                    checked={openSlides == '2'}
                                                                                    onClick={e => this.setState({ openSlides: '2', openSlidesErr: '' })}
                                                                                /> 2 Open Side
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-xl-2 mb-3">
                                                                            <label>
                                                                                <input type="radio" name="openSlides" value={openSlides}
                                                                                    checked={openSlides == '3'}
                                                                                    onClick={e => this.setState({ openSlides: '3', openSlidesErr: '' })} /> 3 Open Side
                                                                            </label>
                                                                        </div> */}
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{openSlidesErr}</span>}

                                                        </div>
                                                    </div>

                                                    {/* {
                                                        subChapters.length > 0 && subChapters.map((data, index) => (
                                                            <p key={index}>
                                                                Selected Sub Chapter :{" "}
                                                                <span>
                                                                    <spa>{data.ChapterName}</spa>
                                                                </span>
                                                            </p>
                                                        ))
                                                    } */}
                                                </div>
                                                <hr />

                                                {this.state.isDoubleStoreyExhibition && this.state.stallTypeId == 1 && <>
                                                    <div
                                                        className="card-header  cus-hed mt-2"
                                                        style={{

                                                            borderTop: "1px solid #eee",
                                                            position: "relative"
                                                        }}
                                                    >
                                                        <div className="d-flex">
                                                            <input
                                                                className="toggle-box mt-1"
                                                                id="identifier-2"
                                                                type="checkbox"
                                                                style={{ float: "left" }}
                                                                checked={this.state.isDoubleStorey}
                                                                // disabled={true}
                                                                disabled={isView}
                                                                // disabled={isReceiptGenerated}
                                                                disabled={isView}
                                                                onClick={(e) => this.onCheckdoubleStorey(e)}
                                                            />
                                                            <div >
                                                                <label htmlFor="identifier-2" style={{ fontSize: 16 }}>
                                                                    <strong> Double storey </strong>

                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        this.state.isDoubleStorey
                                                        &&
                                                        <div className="form-row mt-1 p-2">
                                                            <div className="col-xl-3">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    // disabled={true}
                                                                    disabled={isView}
                                                                    maxLength={'10'}
                                                                    value={this.state.doubleStoreyArea}
                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                    // disabled={isReceiptGenerated}
                                                                    disabled={isView}
                                                                    onChange={e => this.onChangeDoubleStorey(e)}
                                                                />
                                                            </div>
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{this.state.doubleStoreyAreaErr}</span>}

                                                        </div>}
                                                </>}
                                                {this.state.isSSIExhibition && countryId == 91 && <>
                                                    <div
                                                        className="card-header  cus-hed mt-2"
                                                        // style={{ }}
                                                        style={{
                                                            fontSize: 16,
                                                            justifyContent: 'left',
                                                            borderTop: "1px solid #eee",
                                                            position: "relative"
                                                        }}
                                                    >
                                                        <input
                                                            className="toggle-box mt-1"
                                                            id="identifier-2"
                                                            type="checkbox"
                                                            style={{ float: "left" }}
                                                            checked={this.state.isSSi}
                                                            // disabled={isReceiptGenerated ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? true : SSIdiscount : false}
                                                            disabled={isView}
                                                            onClick={(e) => this.onSSITMMAITAMMAClick()}
                                                            // disabled={isReceiptGenerated}
                                                            disabled={isView}
                                                        />
                                                        <strong >
                                                            SSI certificate and membership certificate of TMMA/ITAMMA
                                                        </strong>
                                                    </div>

                                                    {
                                                        this.state.isSSi
                                                        &&
                                                        <div>

                                                            <div
                                                                className="card-header  cus-hed mt-2"
                                                                style={{

                                                                    borderTop: "1px solid #eee",
                                                                    position: "relative"
                                                                }}
                                                            >
                                                                <div className="col-xl-6">
                                                                    <div className="d-flex">
                                                                        <input
                                                                            className="toggle-box mt-1"
                                                                            id="identifier-2"
                                                                            type="checkbox"
                                                                            // disabled={isReceiptGenerated ? true : SSIdiscount}
                                                                            disabled={isView}
                                                                            style={{ float: "left" }}
                                                                            checked={this.state.isSSi}
                                                                            onClick={(e) => this.onSSITMMAITAMMAClick()}
                                                                            // disabled={isReceiptGenerated}
                                                                            disabled={isView}
                                                                        />
                                                                        <div >
                                                                            <label htmlFor="identifier-2" style={{ fontSize: 16 }}>
                                                                                SSI certificate?

                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-m-3">
                                                                    {
                                                                        this.state.isSSIdeleted == false && this.state.isSSIreplaced == false
                                                                        &&
                                                                        <div style={{
                                                                            border: '1px solid #ccc',
                                                                            padding: '10px',
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            // marginTop: '10px'
                                                                        }}>
                                                                            <a
                                                                                href={this.state.isSSifilePath}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                <span style={{ marginRight: '10px' }}
                                                                                >
                                                                                    {this.state.isSSifile}
                                                                                </span>
                                                                            </a>

                                                                            <button className="byn btn-primary rounded "
                                                                                style={{ width: "80px", height: "30px" }}
                                                                                // disabled={isReceiptGenerated ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                disabled={isView}
                                                                                dis
                                                                                onClick={() => document.getElementById("path").click()}>Choose</button>
                                                                        </div>}
                                                                    {/* {console.log('ooo', this.state.isSSIdeleted, this.state.isSSIreplaced, this.state.isSSifileReplacement)} */}
                                                                    <div className={this.state.isSSIreplaced ? "upload-options mt-1" : "upload-options mt-1 d-none"}>
                                                                        <label>
                                                                            <input
                                                                                type="file"
                                                                                id="path"
                                                                                // style={this.state.isSSIreplaced && { display: 'none' }}
                                                                                className={this.state.isSSIreplaced ? "image-upload" : "image-upload d-none"}
                                                                                // className="image-upload d-none"
                                                                                // disabled={isReceiptGenerated}
                                                                                disabled={isView}
                                                                                accept=".jpg, .jpeg, .png, .pdf"
                                                                                onChange={e => this.onFilePickSSI(e, e.target.files)}
                                                                            />
                                                                            <span className="text-danger" style={{ fontSize: '12px', textAlign: 'center', display: 'block' }}>
                                                                                Max 5MB | Pdf,Jpeg,Jpg,Png only
                                                                            </span>
                                                                            {
                                                                                this.state.isSSifileReplacement != "" && this.state.isSSifileReplacement != null &&
                                                                                <i class="fa fa-times text-danger img-can"
                                                                                    // disabled={isReceiptGenerated}
                                                                                    disabled={isView}
                                                                                    onChange={() => this.onCrossClickSSI()}
                                                                                ></i>
                                                                            }
                                                                        </label>

                                                                    </div>
                                                                </div>
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{this.state.isSSifileErr}</span>}

                                                            </div>
                                                            <div
                                                                className="card-header  cus-hed mt-2"
                                                                style={{

                                                                    borderTop: "1px solid #eee",
                                                                    position: "relative"
                                                                }}
                                                            >
                                                                <div className="col-xl-3">
                                                                    <label>
                                                                        <input type="radio" name="ITMATTAMA"
                                                                            value={this.state.TMMAITAMMA}
                                                                            // disabled={isReceiptGenerated ? true : SSIdiscount}
                                                                            disabled={isView}
                                                                            // disabled={}
                                                                            disabled={isView}
                                                                            checked={this.state.TMMAITAMMA == '1'}
                                                                            onClick={e => this.setState({ TMMAITAMMA: '1', })}
                                                                        /> Membership certificate of TMMA
                                                                    </label>

                                                                </div>
                                                                <div className="col-xl-3">
                                                                    <label>
                                                                        <input type="radio" name="ITMATTAMA"
                                                                            value={this.state.TMMAITAMMA}
                                                                            // disabled={isReceiptGenerated ? true : SSIdiscount}
                                                                            disabled={isView}
                                                                            checked={this.state.TMMAITAMMA == '2'}
                                                                            onClick={e => this.setState({ TMMAITAMMA: '2', })}
                                                                        /> Membership certificate of ITAMMA
                                                                    </label>
                                                                </div>

                                                                <div className="upload-options mt-1">
                                                                    {
                                                                        this.state.isTMMAITAMMAdeleted == false && this.state.isTAMMAITAMMAreplaced == false
                                                                        &&
                                                                        <div style={{
                                                                            border: '1px solid #ccc',
                                                                            padding: '10px',
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            // marginTop: '10px'
                                                                        }}>
                                                                            <a
                                                                                href={this.state.TMMAITAMMAfilePath}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                <span style={{ marginRight: '10px' }}
                                                                                >
                                                                                    {this.state.TMMAITAMMAfile}
                                                                                </span>
                                                                            </a>
                                                                            <button className="byn btn-primary rounded "
                                                                                style={{ width: "80px", height: "30px" }}
                                                                                // disabled={isReceiptGenerated ? true : dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                                disabled={isView}
                                                                                onClick={() => document.getElementById("path2").click()}>Choose</button>
                                                                        </div>}
                                                                    <div className={this.state.isTAMMAITAMMAreplaced ? "upload-options mt-1" : "upload-options mt-1 d-none"}>
                                                                        <label>
                                                                            <input
                                                                                type="file"
                                                                                id="path2"
                                                                                className={this.state.isTAMMAITAMMAreplaced ? "image-upload" : "image-upload d-none"}
                                                                                accept=".jpg, .jpeg, .png, .pdf"
                                                                                // disabled={isReceiptGenerated}
                                                                                disabled={isView}
                                                                                onChange={e => this.onFilePickITMATAMMA(e, e.target.files)}
                                                                                // disabled={isView}
                                                                                disabled={isView}
                                                                            />
                                                                            {
                                                                                this.state.TMMAITAMMAfileReplacement != "" && this.state.TMMAITAMMAfileReplacement != null &&
                                                                                <i class="fa fa-times text-danger img-can"
                                                                                    // disabled={isReceiptGenerated}
                                                                                    disabled={isView}
                                                                                    onChange={() => this.onCrossClickITMATAMMA()}
                                                                                ></i>
                                                                            }
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                {/* </div> */}


                                                                {<span className='text-danger text-start text-left d-block mt-1'>{this.state.TMMAITAMMAfileErr}</span>}

                                                            </div>
                                                        </div>}
                                                </>}

                                                <br></br>
                                                <div className="mt-1" style={{ textAlign: 'left', fontSize: 'medium' }}>
                                                    <span className="text-left" ><strong>Note:<br></br>
                                                        1- If your Floor Loading Requirement, Machine Weight, water, power, and compressed air requirements are not yet finalized, please enter “0” to proceed with the form. </strong>
                                                    </span><br></br>
                                                    <span className='ms-2'><strong>&nbsp;(Kindly ensure that all mandatory utility details for your booth are completed in this form on or before 30th September 2026.)</strong>
                                                    </span><br></br>
                                                    <span><strong>2- Please note the below estimate may change once you update the application.</strong>
                                                    </span><br></br>
                                                    <span><strong>3- Open side charges may also get update once the allocation done.</strong>
                                                    </span>
                                                </div>
                                                <div className=" mt-2">
                                                    <div
                                                        className="form-row col-md-12 mt-2" style={{ marginTop: '10px' }}>
                                                        <div className="table-responsive mx-4" style={{ marginTop: '20px' }}>
                                                            <h6 style={{ float: 'left', fontSize: '1.3rem', marginTop: '10px' }}>Exhibit Details</h6>{<span className='text-danger ml-2' style={{ float: 'left' }}>{lengthWidthErr}</span>}
                                                            <button className="btn btn-aqua mb-2" style={{ float: 'right' }} onClick={e => this.onAddClick(e)}>
                                                                Add Exhibit
                                                            </button>< br />
                                                        </div>
                                                    </div>
                                                    <div class="container-fluid">
                                                        <div class="accordion" id="exhibitAccordion">
                                                            {/* {exhibitDetailsList.length > 0 ? exhibitDetailsList.map((data, index) => (<></>))} */}
                                                            {subChapters.length > 0 ? subChapters.map((data, index) => (<div class="accordion-item-exhdetail">
                                                                <h2 class="accordion-header-exhdetail" id={`heading${index}`}>
                                                                    <button class="accordion-button " type="button" style={{
                                                                        border: 'none',
                                                                        backgroundColor: 'transparent !important',
                                                                        fontWeight: 'normal',
                                                                        boxShadow: 'none !important'
                                                                    }} data-bs-toggle="collapse"
                                                                        data-bs-target={`#collapseOne_${index}`} aria-expanded={data.accordion} aria-controls={`collapseOne_${index}`}>
                                                                        {data.ChapterID != 0 ? (
                                                                            <p style={{
                                                                                color: '#000',
                                                                                fontSize: '1.12rem',
                                                                                padding: '15px 20px',
                                                                            }}>{data.ChapterName}</p>
                                                                        ) : (
                                                                            <input
                                                                                style={{ width: '90%' }}
                                                                                type="text"
                                                                                className="form-control"
                                                                                // maxLength={'10'}
                                                                                value={data.ChapterName}
                                                                                // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                onChange={e => this.onEnterProductName(e, index)}
                                                                            />
                                                                        )}
                                                                    </button>
                                                                </h2>
                                                                <div id={`collapseOne_${index}`} class="accordion-collapse collapse show" aria-labelledby={`heading${index}`}
                                                                    data-bs-parent="#exhibitAccordion">
                                                                    <div class="accordion-body-exhdetail">

                                                                        <div class="row mb-3 gx-3">
                                                                            <div class="col-md-3">
                                                                                <div class="mb-3">
                                                                                    <label class="form-label-exhdetail border-0">Manufacturer Name </label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        maxLength={'200'}
                                                                                        value={data.ManufacturerName}
                                                                                        onBlur={e => this.checksameMFandCountry()}
                                                                                        style={{ border: data.errArr.includes('ManufacturerName') && '2px solid red' }}
                                                                                        // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                        onChange={e => {
                                                                                            this.onManufacturerNameChange(e, data.ChapterID, index);
                                                                                            // setTimeout(() => {

                                                                                            // }, 500);
                                                                                        }
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                                <div class="mb-3">
                                                                                    <label class="form-label-exhdetail border-0">Manufacturing Country<span className="text-red">*</span></label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        required=""
                                                                                        value={data.ManufacturingCountry}
                                                                                        style={{ border: data.errArr.includes('ManufacturingCountry') && '2px solid red' }}
                                                                                        onBlur={(e) => this.onCountryBlur(e.target.value, index)}
                                                                                        onChange={e => {
                                                                                            this.onManufacturingCountryChange(e, data.ChapterID, index);
                                                                                            setTimeout(() => {

                                                                                            }, 500);
                                                                                        }}
                                                                                    // onChange={(e) => this.onManufacturingCountryChange(e, data.ChapterID, index)}
                                                                                    />
                                                                                    {console.log("this.state.tempCountryList--->", this.state.tempCountryList)}
                                                                                    {this.state.isDisplayCountryList && this.state.manufactureCountryIndex == index && this.renderCountryList()}
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-6 mb-2">
                                                                                <div class="mb-3">
                                                                                    <label class="form-label-exhdetail border-0">Company Email<span className="text-red">*</span></label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        required=""
                                                                                        style={{ border: data.errArr.includes('CompanyEmail') && '2px solid red' }}
                                                                                        value={data.CompanyEmail}
                                                                                        onBlur={(e) => {
                                                                                            if (e.target.value != '' && emailValidator(e.target.value) != '') {
                                                                                                if (!data.errArr.includes('CompanyEmail')) {
                                                                                                    data.errArr.push('CompanyEmail')
                                                                                                    this.setState({ subChapters: subChapters })
                                                                                                }
                                                                                                toastError("Please Enter proper Email")
                                                                                            }
                                                                                        }}
                                                                                        onChange={(e) => this.onEnterCompanyEmail(e, data.ChapterID, index)}
                                                                                    />
                                                                                </div>
                                                                                <div class="mb-3">
                                                                                    <label class="form-label-exhdetail border-0">Registered Headquarters Address<span className="text-red">*</span></label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        required=""
                                                                                        value={data.registrationHQaddress}
                                                                                        style={{ border: data.errArr.includes('registrationHQaddress') && '2px solid red' }}
                                                                                        // onBlur={(e) => this.onCountryBlur(e.target.value, index)}
                                                                                        onChange={(e) => this.onEnterHQaddress(e, data.ChapterID, index)}
                                                                                    />                                                                                       </div>
                                                                            </div>
                                                                            <div class="col-md-3 mb-2" style={{ minWidth: '11rem', background: data.errArr.includes('isAllMB') && '#ff00002b' }}>

                                                                                <div className='border p-0 rounded-2 mt-2'>
                                                                                    <label class="form-label-exhdetail border-0 d-block border-bottom p-2">Machine/Brochure/Accessories<span className="text-red">*</span></label>
                                                                                    <div class="align-items-center flex-wrap p-2 pt-0">
                                                                                        <div class="mb-1 m-0">
                                                                                            <input
                                                                                                className="toggle-box mt-1"
                                                                                                id="identifier-2"
                                                                                                type="checkbox"
                                                                                                style={{ float: "left" }}
                                                                                                checked={data.isMachine}
                                                                                                onClick={(e) => this.onMBclick(0, data.ChapterID, index)}
                                                                                            />
                                                                                            <label class="form-check-label checkbox-label border-0"
                                                                                                for="checkMachine1">Machine</label>
                                                                                        </div>
                                                                                        <div class="mb-1">
                                                                                            <input
                                                                                                className="toggle-box mt-1"
                                                                                                id="identifier-2"
                                                                                                type="checkbox"
                                                                                                style={{ float: "left" }}
                                                                                                checked={data.IsAccessory}
                                                                                                onClick={(e) => this.onMBclick(2, data.ChapterID, index)}
                                                                                            />
                                                                                            <label class="form-check-label checkbox-label border-0"
                                                                                                for="checkAccessories1">Accessories/Product</label>
                                                                                        </div>
                                                                                        <div class="mb-1">
                                                                                            <input
                                                                                                className="toggle-box mt-1"
                                                                                                id="identifier-2"
                                                                                                type="checkbox"
                                                                                                style={{ float: "left" }}
                                                                                                checked={data.isBrochure}
                                                                                                onClick={(e) => this.onMBclick(1, data.ChapterID, index)}
                                                                                            />
                                                                                            <label class="form-check-label checkbox-label border-0" for="checkBrochure1">Only
                                                                                                Brochure</label>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div class="row mb-3 gx-3">
                                                                            <div class="col-md-3">
                                                                                <div class="mb-3">
                                                                                    <label class="form-label-exhdetail border-0">Machine Details</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        maxLength={'200'}
                                                                                        value={data.MachineDetails}

                                                                                        // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                        onChange={e => this.onMachineDetailsChange(e, data.ChapterID, index)}
                                                                                    />
                                                                                </div>
                                                                                <div class="mb-3">
                                                                                    <label class="form-label-exhdetail border-0">HSN Code</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        maxLength={'200'}
                                                                                        value={data.HSNCode}

                                                                                        // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                        onChange={e => this.onEnterHSNCode(e, data.ChapterID, index)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-3 mb-3">
                                                                                <div class="nested-card h-100">
                                                                                    <div class="nested-card-title">Machine Dimension (mtr){data.isMachine && <span className="text-red" >*</span>}</div>
                                                                                    <div class="table-like">
                                                                                        <div class="table-col">
                                                                                            <div class="table-label">Length{data.isMachine && <span className="text-red" >*</span>}</div>
                                                                                            {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                maxLength={'9'}
                                                                                                value={0}
                                                                                                disabled={true}
                                                                                            // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                            // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                            /> : <input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                maxLength={'9'}
                                                                                                value={data.Length}
                                                                                                style={{ border: data.errArr.includes('Length') && '2px solid red' }}
                                                                                                disabled={!data.isBrochure && !data.isMachine && !data.IsAccessory ? false : !data.isMachine}
                                                                                                onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                            />}
                                                                                        </div>
                                                                                        <div class="table-col">
                                                                                            <div class="table-label">Breadth{data.isMachine && <span className="text-red" >*</span>}</div>
                                                                                            {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                maxLength={'9'}
                                                                                                value={0}
                                                                                                disabled={true}
                                                                                            // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                            // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                            /> : <input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                maxLength={'9'}
                                                                                                value={data.Breadth}
                                                                                                style={{ border: data.errArr.includes('Breadth') && '2px solid red' }}
                                                                                                disabled={!data.isBrochure && !data.isMachine && !data.IsAccessory ? false : !data.isMachine}
                                                                                                onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                onChange={e => this.onBreadthChange(e, data.ChapterID, index)}
                                                                                            />}
                                                                                        </div>
                                                                                        <div class="table-col">
                                                                                            <div class="table-label">Area{data.isMachine && <span className="text-red" >*</span>}</div>
                                                                                            {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                maxLength={'9'}
                                                                                                value={0}
                                                                                                disabled={true}
                                                                                            // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                            // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                            /> : <input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                value={data.Area}
                                                                                                disabled
                                                                                            />}
                                                                                        </div>
                                                                                        <div class="table-col">
                                                                                            <div class="table-label">Height{data.isMachine && <span className="text-red" >*</span>}</div>
                                                                                            {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                maxLength={'9'}
                                                                                                value={0}
                                                                                                disabled={true}
                                                                                            // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                            // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                            /> : <input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                maxLength={'9'}
                                                                                                value={data.Height}
                                                                                                style={{ border: data.errArr.includes('Height') && '2px solid red' }}
                                                                                                disabled={!data.isBrochure && !data.isMachine && !data.IsAccessory ? false : !data.isMachine}
                                                                                                onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                onChange={e => this.onHeightChange(e, data.ChapterID, index)}
                                                                                            />}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-3">
                                                                                <div class="mb-3">
                                                                                    <label class="form-label-exhdetail border-0">Calculated Area</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control "
                                                                                        maxLength={'10'}
                                                                                        disabled
                                                                                        value={data.CalculatedArea != 0 && data.CalculatedArea != null ? data.CalculatedArea : ''}
                                                                                    // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                    // onChange={e => this.onEnterHSNCode(e, data.ChapterID, index)}
                                                                                    />
                                                                                </div>
                                                                                <div class="mb-3">
                                                                                    <label class="form-label-exhdetail border-0">Scheme Type</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        disabled
                                                                                        className="form-control "
                                                                                        maxLength={'10'}
                                                                                        value={data.ShellScheme == 2 ? 'Shell' : data.ShellScheme == 1 ? 'Bare' : ''}
                                                                                    // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                    // onChange={e => this.onEnterHSNCode(e, data.ChapterID, index)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-3">
                                                                                <div class="mb-3">
                                                                                    <label class="form-label-exhdetail border-0">Floor Loading Requirements (Kgs per sq mtr)</label>
                                                                                    {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        maxLength={'9'}
                                                                                        value={0}
                                                                                        disabled={true}
                                                                                    // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                    // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                    /> : <input
                                                                                        type="text"
                                                                                        title=' Note :
                                                                                                                                                        1- Very heavy-duty equipment and machinery are not allowed into the Hall and shall be allocated in the external exhibition space.
                                                                                                                                                        2- If any exhibitor wants to show live machinery, please contact the organizer for special arrangements.'
                                                                                        className="form-control"
                                                                                        maxLength={'9'}
                                                                                        value={data.FloorCapacity}
                                                                                        onInput={e => this.maxLengthCheck(e, 10)}
                                                                                        onChange={e => this.onFloorCapacityChange(e, data.ChapterID, index)}
                                                                                    />}
                                                                                </div>
                                                                                <div class="mb-3">
                                                                                    <label class="form-label-exhdetail border-0">Machine Weight (Kg)</label>
                                                                                    {(data.isBrochure || data.IsAccessory) && !data.isMachine ? <input
                                                                                        type="number"
                                                                                        className="form-control"
                                                                                        maxLength={'9'}
                                                                                        value={0}
                                                                                        disabled={true}
                                                                                    // onInput={e => this.maxLengthCheck(e, 10)}
                                                                                    // onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                    /> : <input
                                                                                        type="number"
                                                                                        className="form-control"
                                                                                        maxLength={'9'}
                                                                                        value={data.MachineWeight}
                                                                                        onInput={e => this.maxLengthCheck(e, 10)}
                                                                                        onChange={e => this.onMachineWeightChange(e, data.ChapterID, index)}
                                                                                    />}
                                                                                </div>
                                                                            </div>

                                                                        </div>

                                                                        <div class="row gx-3">
                                                                            <div class="col-md-3 mb-3">
                                                                                <div class="nested-card h-100">
                                                                                    <div class="nested-card-title no-border">Power Requirement<span
                                                                                        class="text-danger">*</span></div>
                                                                                    <span class="text-danger-small">(Please review the utility rates in the manual
                                                                                        form)</span>
                                                                                    <div class="table-like border-top">
                                                                                        <div class="table-col">
                                                                                            <div class="table-label">Single Phase (K.W.)</div>
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control"
                                                                                                maxLength={'10'}
                                                                                                style={{ border: data.errArr.includes('SinglePhasePower') && '2px solid red' }}
                                                                                                value={data.SinglePhasePower}
                                                                                                onInput={e => {

                                                                                                    if ((e.target.value > 3 || e.target.value < 0) && e.target.value != '') {
                                                                                                        toastError("Maximum 3 quantities allowed for single phase. Apply for three phase for more")
                                                                                                    };
                                                                                                    (e.target.value > 3 || e.target.value < 0) && e.target.value != '' ? e.target.value = '' : e.target.value = e.target.value;
                                                                                                }} onChange={e => this.onEntersinglePhase(e, data.ChapterID, index)}
                                                                                            />                                                                                                 </div>
                                                                                        <div class="table-col">
                                                                                            <div class="table-label">Three Phase (K.W.)</div>
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control"
                                                                                                maxLength={'10'}
                                                                                                style={{ border: data.errArr.includes('ThreePhasePower') && '2px solid red' }}
                                                                                                value={data.ThreePhasePower}
                                                                                                onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                onChange={e => this.onEnterThreePhase(e, data.ChapterID, index)}
                                                                                            />                                                                                                  </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-3 mb-3">
                                                                                <div class="nested-card h-100">
                                                                                    <div class="nested-card-title no-border">Water Requirement<span
                                                                                        class="text-danger">*</span></div>
                                                                                    <span class="text-danger-small">(Please review the utility rates in the manual
                                                                                        form)</span>
                                                                                    <div class="table-like border-top">
                                                                                        <div class="table-col">
                                                                                            <div class="table-label">Consumption Of Water(Ltr/hr)<span
                                                                                                class="text-danger">*</span></div>
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control"
                                                                                                maxLength={'10'}
                                                                                                style={{ border: data.errArr.includes('WaterConsumption') && '2px solid red' }}
                                                                                                value={data.WaterConsumption}
                                                                                                onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                onChange={e => this.onEnterWaterConsumption(e, data.ChapterID, index)}
                                                                                            />
                                                                                        </div>
                                                                                        <div class="table-col">
                                                                                            <div class="table-label">Inlet Connection<span class="text-danger">*</span>
                                                                                            </div>
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control"
                                                                                                style={{ border: data.errArr.includes('InletQuantity') && '2px solid red' }}
                                                                                                maxLength={'10'}
                                                                                                value={data.InletQuantity}
                                                                                                onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                onChange={e => this.onEnterInletQuantity(e, data.ChapterID, index)}
                                                                                            />
                                                                                        </div>
                                                                                        <div class="table-col">
                                                                                            <div class="table-label">Outlet Connection<span class="text-danger">*</span>
                                                                                            </div>
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control"
                                                                                                maxLength={'10'}
                                                                                                style={{ border: data.errArr.includes('OutletQuantity') && '2px solid red' }}
                                                                                                value={data.OutletQuantity}
                                                                                                onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                onChange={e => this.onEnterOutletQuantity(e, data.ChapterID, index)}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-4 mb-3">
                                                                                <div class="nested-card h-100">
                                                                                    <div class="nested-card-title no-border">Air Requirement<span
                                                                                        class="text-danger">*</span></div>
                                                                                    <span class="text-danger-small">(Please review the utility rates in the manual
                                                                                        form)</span>
                                                                                    <div class="table-like border-top">
                                                                                        <div class="table-col">
                                                                                            <div class="table-label">Bar Quantity<span class="text-danger">*</span>
                                                                                            </div>
                                                                                            <select
                                                                                                className="form-control select2 select-hidden-accessible pl-0"
                                                                                                // id="roledb"
                                                                                                value={data.BarQuantity}
                                                                                                onChange={e => this.onEnterBar(e, data.ChapterID, index)}
                                                                                            >
                                                                                                <option value="0">NA</option>
                                                                                                {
                                                                                                    this.state.barQuantityList.length > 0 && this.state.barQuantityList.map(item => (
                                                                                                        <option value={item.BarQuantity} key={item.BarQuantity}>{item.BarQuantity}</option>
                                                                                                    ))
                                                                                                }


                                                                                            </select>
                                                                                        </div>
                                                                                        <div class="table-col">
                                                                                            <div class="table-label">CFM Quantity<span class="text-danger">*</span>
                                                                                            </div>
                                                                                            <select
                                                                                                className="form-control select2 select-hidden-accessible pl-0"
                                                                                                // id="roledb"
                                                                                                value={data.CFMQuantity}
                                                                                                onFocus={() => data.BarQuantity != null && data.BarQuantity != '' ? this.getFillList(CFMActionId, "", data.BarQuantity <= 6 ? 13 : data.BarQuantity === 7 ? 14 : 17, "", data.BarQuantity) : null}
                                                                                                onChange={e => this.onEnterCFM(e, data.ChapterID, index)}
                                                                                            >
                                                                                                <option value='0'>NA</option>
                                                                                                {
                                                                                                    this.state.CFMQuantityList.length > 0 && this.state.CFMQuantityList.map(item => (
                                                                                                        <option value={item.CFMID} key={item.CFMID}>{item.CFM}</option>
                                                                                                    ))
                                                                                                }


                                                                                            </select>
                                                                                        </div>
                                                                                        <div class="table-col">
                                                                                            <div class="table-label">Max Compressed Air Connection<span
                                                                                                class="text-danger">*</span></div>
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control"
                                                                                                maxLength={'10'}
                                                                                                style={{ border: data.errArr.includes('MaxCompressedAir') && '2px solid red' }}
                                                                                                value={data.MaxCompressedAir}
                                                                                                onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                onChange={e => this.onEnterMaxCompressed(e, data.ChapterID, index)}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-2 mb-3">
                                                                                <div class="nested-card h-100">
                                                                                    <div class="nested-card-title text-white" style={{ background: '#3dbca7' }}>Upload Certificate of Origin{showMandatoryMark && <span className="text-red">*</span>}</div>
                                                                                    {(data.isMachine || data.IsAccessory) ? data.DocDeleted == false || data.DocumentName != '' ?
                                                                                        <div style={{
                                                                                            margin: '2rem 1rem',
                                                                                            border: '1px solid #ccc',
                                                                                            padding: '10px',
                                                                                            display: 'inline-flex',
                                                                                            alignItems: 'center',
                                                                                            // marginTop: '10px'
                                                                                        }}>
                                                                                            {/* {console.log(this.state.isSSifile)} */}
                                                                                            {data.DocDeleted == false ? <a
                                                                                                href={data.DocumentPath}
                                                                                                target="_blank"
                                                                                                rel="noopener noreferrer"
                                                                                            >
                                                                                                <span style={{ marginRight: '10px' }}
                                                                                                >{data.DocumentName}</span>
                                                                                            </a> : <span onClick={() => this.renderNewImage(data.DocumentFile, data.DocumentType)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                                                            >{data.DocumentName}</span>}
                                                                                            <i className={`fa fa-times text-danger img-can`}
                                                                                                onClick={(e) => this.onChapterDocDelete(data.ChapterID, index)}
                                                                                            ></i>
                                                                                        </div>
                                                                                        : <div className="upload-container mt-1">
                                                                                            <label style={{ display: 'flex' }}>
                                                                                                <input
                                                                                                    type="file"
                                                                                                    id={`file${index}`}
                                                                                                    ref={this.fileInputRef}
                                                                                                    name={`file${index}`}
                                                                                                    className="image-upload"
                                                                                                    accept=".jpg, .jpeg, .png, .pdf"
                                                                                                    onChange={e => this.onFilePick(e, e.target.files, index)}
                                                                                                // disabled={isView}
                                                                                                />
                                                                                                {
                                                                                                    data.DocumentFile != "" &&
                                                                                                    <i class="fa fa-times text-danger img-can"
                                                                                                        onClick={() => this.onCrossClick(index)}
                                                                                                    ></i>
                                                                                                }
                                                                                            </label>
                                                                                        </div> : <div className='text-center mt-2'></div>}
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>)) : <div class="accordion-item-exhdetail"><p style={{
                                                                color: '#000',
                                                                fontSize: '1.12rem',
                                                                padding: '15px 20px',
                                                            }} colSpan={10} className="text-center">Record not available</p>
                                                            </div>}
                                                        </div>
                                                    </div>
                                                    {(this.state.isShowInternationalArea) && countryId == 91 && <div className="area-card pt-2 mt-3">
                                                        <div className="card-header bg-transparent px-0 border-0">


                                                            <h2 className='mb-0 pb-2' style={{ fontSize: '20px' }}>International Area</h2>
                                                            <div className="text-primary " style={{ cursor: 'pointer', fontSize: '13px' }} onClick={(e) => this.setState({ intAreaRulesPop: true })}
                                                            ><span className='text-danger'>International Area Calculation Rules</span><br></br> Click here <span className='text-danger'>to view</span></div>
                                                        </div>

                                                        <div className="info-box">
                                                            <span>Bare Area</span>
                                                            <strong>{this.state.IAbare}</strong>
                                                        </div>

                                                        <div className="info-box">
                                                            <span>Shell Area</span>
                                                            <strong>{this.state.IAshell}</strong>
                                                        </div>

                                                        <div className="total-box">
                                                            <span>TOTAL INTERNATIONAL AREA</span>
                                                            <strong>{InternationalArea} Sqm</strong>
                                                        </div>

                                                        {/* <p className="note">
        <strong>Note:</strong> Audit will take place prior to opening to verify exhibits.
        Discrepancies may lead to penalties or legal consequences.
    </p> */}
                                                    </div>}
                                                    < br />
                                                    {
                                                        ExhibitDetailsNote.length > 0 && ExhibitDetailsNote.map((data, i) => (
                                                            <>{< div style={{ textAlign: 'left' }}>
                                                                <strong>Note: </strong>{data.Description}
                                                            </div>
                                                            }
                                                                < br />
                                                            </>
                                                        ))
                                                    }
                                                    < br />
                                                    {this.state.isShowMachineryGuidelines &&
                                                        <>
                                                            {countryId == 91 ? (
                                                                <p className="m-0 mt-5">
                                                                    <strong>Guideline for Machinery Display at {sessionStorage.getItem("exhibitionAddress")}</strong><br />
                                                                    {this.state.guideLines.length > 0 && this.state.guideLines.map((data, i) => (
                                                                        <>
                                                                            {i + 1}- {data.Description}< br />
                                                                        </>
                                                                    ))}
                                                                    {/* 1- Display of machinery is allowed only in static mode.<br />
                                                                                2- Very heavy-duty equipment and machinery are not allowed into the Hall and shall be allocated in the external exhibition space.<br />
                                                                                3- Floor load capacity: The floor space can hold 3 tons per sqm inside the hall.<br />
                                                                                4- Compressed Air and water supply are not available in the halls.<br />
                                                                                5- Loading door dimensions: The length is 9.56 mtr and height is 3.18 mtr.<br /> */}
                                                                </p>
                                                            ) : (
                                                                <p className="m-0 mt-5">
                                                                    <strong>Guideline for Machinery Display at {sessionStorage.getItem("exhibitionAddress")}</strong><br />
                                                                    {this.state.guideLines.length > 0 && this.state.guideLines.map((data, i) => (
                                                                        <>
                                                                            {i + 1}- {data.Description}< br />
                                                                        </>
                                                                    ))}
                                                                    {/* 1- Display of machinery is allowed only in static mode.<br />
                                                                                2- Very heavy-duty equipment and machinery are not allowed into the Hall and shall be allocated in the external exhibition space.<br />
                                                                                3- Floor load capacity: The floor space can hold 3 tons per sqm inside the hall.<br />
                                                                                4- Compressed Air and water supply are not available in the halls.<br />
                                                                                5- Loading door dimensions: The length is 9.56 mtr and height is 3.18 mtr.<br />
                                                                                <strong>Note: </strong>If any exhibitor wants to show live machinery, please contact the organizer for special arrangements.<br /> */}
                                                                </p>
                                                            )}</>}

                                                    {this.state.isShowChapterNotes && <>
                                                        {countryId == 91 ? (
                                                            <p className="m-0 mt-5">
                                                                <strong>Note: </strong><br />
                                                                {this.state.note.length > 0 && this.state.note.map((data, i) => (
                                                                    <>
                                                                        {i + 1}- {data.Description}< br />
                                                                    </>
                                                                ))}
                                                            </p>
                                                        ) : (null)}
                                                    </>}



                                                    {this.state.isShowExhPrimaryChapterComment &&
                                                        <div className="form-row mb-3">
                                                            <label>Remark for Multiple Chapter<span className="text-red">*</span></label>
                                                            <textarea className="form-control" value={ExhPrimaryChapterComment} maxLength={500}
                                                                // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                                disabled={isView}
                                                                onChange={e => this.setState({ ExhPrimaryChapterComment: e.target.value, ExhPrimaryChapterCommentErr: '' })} />
                                                            <span className='text-danger text-start text-left d-block mt-1'>{this.state.ExhPrimaryChapterCommentErr}</span>
                                                        </div>
                                                    }
                                                    {(sessionStorage.getItem('isPaidByAgentRegistration') != null && sessionStorage.getItem('isPaidByAgentRegistration') == 0) ||
                                                        (sessionStorage.getItem('isIndirectAccess') != null && sessionStorage.getItem('isIndirectAccess') == 'true') || sessionStorage.getItem('RoleIDSS') != 1 ? (
                                                        <div className="row mt-3">
                                                            {/* <p>
                                                                <strong>
                                                                    Note: Only Products manufactured in india are eligible for
                                                                    subsidy
                                                                </strong>
                                                            </p> */}
                                                            <div className="table-responsive">
                                                                {/* <p className="mb-2" style={{ float: "left", color: "#0072ff" }}>
                                                                    As per Rule no. 7.1,7.2,7.8,7.9,and 7.10 the total rent payable
                                                                    by us is as follows:
                                                                </p>
                                                                <p className="mb-2" style={{ float: "right", color: "#0072ff" }}>
                                                                    Please refer Rule no. 7.1,7.2,7.8,7.9 and 7.10
                                                                </p>
                                                                <p /> */}
                                                                <table className="table table-bordered">
                                                                    <tbody>
                                                                        {
                                                                            estimateDetails.length > 0 ? estimateDetails.map((data, index) => (
                                                                                <tr key={Math.random()} >
                                                                                    <td style={{ width: '300px', whiteSpace: data.Description.includes('\n') ? 'pre-line' : '' }} ><strong>{data.Description}</strong></td>
                                                                                    <td style={{ textAlign: index != 0 ? 'right' : 'center' }} >{index == 0 ? <strong>{data.Installment1}</strong> : data.Installment1}</td>
                                                                                    <td style={{ textAlign: index != 0 ? 'right' : 'center' }} >{index == 0 ? <strong>{data.Installment2}</strong> : data.Installment2}</td>
                                                                                    <td style={{ textAlign: index != 0 ? 'right' : 'center' }} >{index == 0 ? <strong>{data.OpenSide}</strong> : data.OpenSide}</td>
                                                                                    <td style={{ width: '300px', textAlign: index != 0 ? 'right' : 'center' }} >{index == 0 ? <strong>{data.Total_amt}</strong> : data.Total_amt}</td>
                                                                                </tr>
                                                                            )) :
                                                                                <>
                                                                                    <tr className='text-center'><td colSpan={4} className='text-center'>Record not found</td></tr>
                                                                                </>
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    ) : (null)}
                                                    <div className="form-row mb-3">
                                                        <label>Remarks/Any Notes</label>
                                                        <textarea className="form-control" value={comment} maxLength={500}
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            onChange={e => this.setState({ comment: e.target.value })} />
                                                    </div>
                                                    {this.state.undertakingContent.length > 0 && countryId == 91 && <>
                                                        <div className="form-row">
                                                            <h6 className='mb-3'><strong>Exhibitor Undertaking for {sessionStorage.getItem("sessionExhibitionName")}</strong></h6>
                                                            {this.state.undertakingContent.map((data) => (
                                                                <p className='m-1 p-0'>{data}</p>
                                                            ))}
                                                        </div>
                                                        <div className="form-row mt-2">
                                                            <div className="col-xl-4 mb-1">
                                                                <label htmlFor="validationCustom01">
                                                                    Authorized Person Name<span className="text-red">*</span>
                                                                </label>
                                                                <input
                                                                    // disabled
                                                                    disabled={isView}
                                                                    type="text"
                                                                    maxLength={100}
                                                                    className="form-control"
                                                                    value={AuthorizedPersonName}
                                                                    onChange={(e) =>
                                                                        this.setState({
                                                                            AuthorizedPersonName: e.target.value, AuthorizedPersonNameErr: '',
                                                                        })
                                                                    }
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{this.state.AuthorizedPersonNameErr}</span>}
                                                            </div>
                                                            <div className="col-xl-4 mb-1">
                                                                <label htmlFor="validationCustom01">
                                                                    Designation of the Authorized person<span className="text-red">*</span>
                                                                </label>
                                                                <input
                                                                    // disabled
                                                                    disabled={isView}
                                                                    type="text"
                                                                    maxLength={100}
                                                                    className="form-control"
                                                                    value={DesignationAuthorizedPerson}
                                                                    onChange={(e) =>
                                                                        this.setState({
                                                                            DesignationAuthorizedPerson: e.target.value, DesignationAuthorizedPersonErr: '',
                                                                        })
                                                                    }
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{this.state.DesignationAuthorizedPersonErr}</span>}
                                                            </div>
                                                            <div className="col-xl-4 mb-1">
                                                                <label htmlFor="validationCustom01">
                                                                    Exhibitor company Name<span className="text-red">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    // disabled
                                                                    disabled={isView}
                                                                    maxLength={100}
                                                                    className="form-control"
                                                                    value={ExhibitorCompanyName}
                                                                    onChange={(e) =>
                                                                        this.setState({
                                                                            ExhibitorCompanyName: e.target.value, ExhibitorCompanyNameErr: '',
                                                                        })
                                                                    }
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{this.state.ExhibitorCompanyNameErr}</span>}
                                                            </div>
                                                            <div className="col-xl-4 mb-1">
                                                                <label htmlFor="validationCustom01">
                                                                    Email of the Authorized person<span className="text-red">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    // disabled
                                                                    disabled={isView}
                                                                    maxLength={100}
                                                                    className="form-control"
                                                                    value={EmailAuthorizedPerson}
                                                                    onChange={(e) =>
                                                                        this.setState({
                                                                            EmailAuthorizedPerson: e.target.value, EmailAuthorizedPersonErr: '',
                                                                        })
                                                                    }
                                                                />
                                                                {<span className='text-danger text-start text-left d-block mt-1'>{this.state.EmailAuthorizedPersonErr}</span>}
                                                            </div>
                                                            <div className="col-xl-4 mb-1">
                                                                <div
                                                                    // className="col-xl-3 mb-1"
                                                                    style={{ position: "relative" }}
                                                                >
                                                                    <label htmlFor="validationCustom01">
                                                                        Mobile No. of the Authorized person<span className="text-red">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        // disabled
                                                                        disabled={isView}
                                                                        maxLength={
                                                                            countryId === "43"
                                                                                ? 11
                                                                                : 10
                                                                        }
                                                                        value={MobileAuthorizedPerson}
                                                                        onChange={(e) =>
                                                                            this.setState({
                                                                                MobileAuthorizedPerson: e.target.value, MobileAuthorizedPersonErr: '',
                                                                            })
                                                                        }
                                                                        onInput={(e) => countryId == 91 ? this.maxLengthCheck(e, 10) : null}
                                                                        size={"10"}
                                                                        onKeyDown={(e) =>
                                                                            (e.keyCode === 69 || e.keyCode === 190) &&
                                                                            e.preventDefault()
                                                                        }
                                                                        onWheel={(e) => e.target.blur()}
                                                                        onKeyPress={(e) => this.preventMinus(e)}
                                                                        style={{ paddingLeft: "50px" }}
                                                                    />
                                                                    <input
                                                                        type="text"
                                                                        // disabled
                                                                        disabled={isView}
                                                                        className="form-control-1"
                                                                        placeholder="ISD"
                                                                        value={PreMobileAuthorizedPerson}
                                                                        // disabled={isCorrespondenceDetails}
                                                                        disabled={isView}
                                                                        onChange={(e) =>
                                                                            this.setState({
                                                                                PreMobileAuthorizedPerson:
                                                                                    e.target.value,
                                                                            })
                                                                        }
                                                                        // placeholder={+91}
                                                                        style={{
                                                                            width: "45px",
                                                                            position: "absolute",
                                                                            top: "25px",
                                                                            paddingLeft: "5px",
                                                                        }}
                                                                    />
                                                                    {<span className='text-danger text-start text-left d-block mt-1'>{this.state.MobileAuthorizedPersonErr}</span>}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <hr></hr>
                                                    </>
                                                    }
                                                    <div className="form-row mb-3">
                                                        <label>Admin Remark<span className="text-red">*</span></label>
                                                        <textarea className="form-control" value={adminRemark} maxLength={500}
                                                            // disabled={dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) : false}
                                                            disabled={isView}
                                                            onChange={e => this.setState({ adminRemark: e.target.value, adminRemarkErr: '' })} />
                                                        <span className='text-danger text-start text-left d-block mt-1'>{this.state.adminRemarkErr}</span>
                                                    </div>
                                                    {console.log("this.state.checkboxList---------->", this.state.checkboxList)}

                                                    {this.state.checkboxList.length > 0 && this.state.checkboxList.map((data, i) => (
                                                        <div className="form-row mt-3">
                                                            <div >
                                                                <label className="d-flex" >
                                                                    <input type="checkbox" style={{ height: 20 }}
                                                                        // disabled
                                                                        disabled
                                                                        name={data.ExhRegistrationNotesId}
                                                                        value={data.checked}
                                                                        checked={true}
                                                                        // checked={data.checked}
                                                                        onClick={e => this.onCheckBoxClick(data, data.ExhRegistrationNotesId)}
                                                                    />
                                                                    {/* {data.label}  {data.ExhRegistrationNotesId == 1041 ? */}
                                                                    {data.label}
                                                                    {/* {data.label.includes('Rules and Regulation') ?
                                                                        <p className='text-primary' >{" "} Click Here</p> : null
                                                                    } {data.label.includes('undertaking') ?
                                                                        <p className='text-primary' >{" "} Click Here</p> : null
                                                                    } */}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))}

                                                    <hr />
                                                    {/* disabled={} */}
                                                    {!isView && <div className="btn-group w-auto">
                                                        {/* {dueDate != '' ? new Date().setHours(0, 0, 0, 0) > dueDate.setHours(0, 0, 0, 0) ? '' : */}
                                                        {/* <button
                                                                type="button"
                                                                className="btn btn-primary rounded-0 d-block"
                                                                style={{ marginRight: 10 }}
                                                                onClick={() => this.editSpaceBooking()}
                                                            >
                                                                Update
                                                            </button> : */}
                                                        {this.getUpdateAccess() && <button
                                                            type="button"
                                                            className="btn btn-primary rounded-0 d-block"
                                                            style={{ marginRight: 10 }}
                                                            onClick={() => this.editSpaceBooking()}
                                                        >
                                                            Update
                                                        </button>}
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary rounded-0 d-block"
                                                            style={{ marginRight: 10 }}
                                                            onClick={() => this.onCancelClick()}
                                                        >
                                                            Back
                                                        </button>
                                                    </div>}

                                                    {/* <div className="row">
                                                    <div className="btn-group" role="group" aria-label="Basic example">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary rounded-0"
                                                            style={{ marginRight: 10 }}
                                                            onClick={() => this.editSpaceBooking()}
                                                        >
                                                            Update
                                                        </button>
                                                    </div>
                                                </div> */}
                                                </div>
                                                {/*  <div class="row mt-4">
                                      <div class="btn-group" role="group" aria-label="Basic example">
                                        <button type="button" class="btn btn-primary rounded-0" style="margin-right:10px">Submit</button>
                                        <button type="button" class="btn btn-primary rounded-0">Payment Listing Page</button>
                                      </div>
                                  </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <Modal isOpen={false} onRequestClose={e => this.setState({ intAreaRulesPop: !intAreaRulesPop })} >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-header" style={{ padding: "10px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    <b>International Area Calculation Rules</b>
                                </h5>
                                <button style={{ fontSize: '16px' }}
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={e => this.setState({ intAreaRulesPop: !intAreaRulesPop })}
                                />
                            </div>

                            <div className="modal-body" style={{ overflowY: 'auto' }}>
                                <div >
                                    <ol>
                                        <li><p>
                                            If only Brochure is selected for all exhibit items, the international area will be calculated based on the brochure slab.
                                            (<div className="text-primary" style={{ cursor: 'pointer', display: 'contents' }} onClick={(e) => this.setState({ slabpop: true, intAreaRulesPop: false })}
                                            >Click here</div> to view slab.)
                                        </p></li>
                                        <li><p>
                                            If only Brochure is selected along with a combination of Machine or Accessories from different manufacturers, the applicable international area for each brochure will be 9 sqm per manufacturer.
                                        </p></li>
                                        <li><p>
                                            If Machine is selected, the international area will be calculated based on the dimensions specified for each exhibit item.
                                        </p></li>
                                        <li><p>
                                            If Accessories are selected then  the international area will be 18 sqm for each.
                                        </p></li>
                                        <li><p>
                                            If there is a combination of Machine, Accessories, and Brochure, the international area will be calculated as per the respective rules mentioned in Points 2, 3, and 4.
                                        </p></li>
                                    </ol>
                                    <br></br>
                                    <p>
                                        For any further queries or clarification, please contact the exhibition team at {ExhibitionMobileNo.length > 0 ? ExhibitionMobileNo.map((data, i) => (<>{data}{i != ExhibitionMobileNo.length - 1 ? ',' : null}</>)) : null} or  {ExhibitionEmail.length > 0 ? ExhibitionEmail.map((data, i) => (<a href={data} > {data} {i != ExhibitionEmail.length - 1 ? '/' : null} </a>)) : null}
                                    </p>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={e => this.setState({ intAreaRulesPop: !intAreaRulesPop })}
                                    >OK</button>
                                </div>
                            </div>
                            {/* <div className="modal-footer" style={{ padding: 3 }}>
                                                                    
                                                                                                </div> */}
                        </div>
                    </div >

                </Modal >
                <Modal isOpen={isOpen} onRequestClose={this.onAddClick}>
                    <div className="modal-dialog">
                        <div className="modal-content" style={{ marginTop: '6em', left: '-20em', width: '90em' }}>
                            <div className="modal-header p-3 pb-1">
                                <h3 className="card-title" style={{ fontSize: 14 }}><strong>Select Below Product</strong>
                                </h3>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" style={{ fontSize: '12px' }}
                                    // data-bs-dismiss="modal"
                                    // aria-label="Close"
                                    onClick={e => this.setState({ isOpen: !isOpen })}
                                />
                            </div>
                            <div className="modal-body" style={{ maxHeight: '400px', overflow: 'auto' }}>
                                <div className="" style={{ paddingLeft: 10 }}>
                                    <form className="needs-validation pb-2" noValidate="">
                                        <div className="form-row">

                                            <div class="accordion" id="accordionExample">
                                                {
                                                    lev2.length > 0 && lev2.map(level2Data => (
                                                        <>
                                                            {
                                                                // level2Data.ParentChapterID == primaryChapterRadio &&
                                                                <div class="accordion-item">
                                                                    <h2 class="accordion-header" id={'heading_l1_' + level2Data.ChapterID}>
                                                                        <button class={"accordion-button collapsed"}
                                                                            type="button" data-bs-toggle="collapse"
                                                                            data-bs-target={'#collapse_l1_' + level2Data.ChapterID} aria-expanded="false"
                                                                            aria-controls={'collapse_l1_' + level2Data.ChapterID}>
                                                                            {/* // checkbox for level2 */}
                                                                            {
                                                                                level2Data.IsCheckbox &&
                                                                                <input type="checkbox" className="from-left-sp" name="" key={level2Data.ChapterID}
                                                                                    checked={level2Data.IsSelect}
                                                                                    onClick={e => this.onCheckLevel2(e, level2Data.ChapterID)} />
                                                                            }
                                                                            {level2Data.ChapterName} </button>
                                                                    </h2>
                                                                    {this.record(level2Data, lev3, lev4)}
                                                                </div>
                                                            }

                                                        </>
                                                    ))
                                                }
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>
                            {/* <div className="modal-footer p-1">
                                               <button
                                                   type="button"
                                                   className="btn ad-fil-btn"
                                                   data-bs-dismiss="modal"
                                                   style={{ background: "#ddd", color: "#000", padding: "4px 16px" }}
                                               >
                                                   Continue
                                               </button>
                                               <button
                                                   type="button"
                                                   className="btn ad-fil-btn"
                                                   data-bs-dismiss="modal"
                                                   style={{ background: "#ddd", color: "#000", padding: "4px 16px" }}
                                                   onClick={e => this.setState({ isOpen: !isOpen })}
                                               >
                                                   Cancel
                                               </button>
                                           </div> */}
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={isOpen10} onRequestClose={(e) => this.setState({ isOpen10: false })}>
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    {/* <p style={{ textAlign: 'center', margin: '15px', fontSize: '20px' }} className="mb-2">
                                                                        Increase Stall Area
                                                                    </p> */}
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        {`Based on the exhibit dimensions entered, the overall booth area should be greater than the recalculated space area. Therefore, the booth area has been revised to ${expectedArea} sq.m.`}
                                    </p>
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        Kindly confirm the revised area and proceed with the application.
                                    </p>
                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 text-center"
                                        type="submit"
                                        style={{
                                            width: "20%",
                                            // display: "block",
                                            background: "#007bff",
                                            padding: 4
                                        }}
                                        onClick={() => this.changetoExpArea()}
                                    >
                                        {" "}
                                        {/* <a
                                                                            className="text-center btn-next text-white"
                                                                            style={{ color: 'white' }}
                                                                        > */}
                                        OK
                                        {/* </a>{" "} */}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >
                <Modal isOpen={false} onRequestClose={(e) => this.setState({ OpenMixExhibitorRule: false })}>
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    {/* <p style={{ textAlign: 'center', margin: '15px', fontSize: '20px' }} className="mb-2">
                                                               Increase Stall Area
                                                           </p> */}
                                    <ol>
                                        <li><p>
                                            If only Brochure is selected for all exhibit items, the international area will be calculated based on the brochure slab.
                                            (<div className="text-primary" style={{ cursor: 'pointer', display: 'contents' }} onClick={(e) => this.setState({ slabpop: true, intAreaRulesPop: false })}
                                            >Click here</div> to view slab.)
                                        </p></li>
                                        <li><p>
                                            If only Brochure is selected along with a combination of Machine or Accessories from different manufacturers, the applicable international area for each brochure will be 9 sqm per manufacturer.
                                        </p></li>
                                        <li><p>
                                            If Machine is selected, the international area will be calculated based on the dimensions specified for each exhibit item.
                                        </p></li>
                                        <li><p>
                                            If Accessories are selected then  the international area will be 18 sqm for each.
                                        </p></li>
                                        <li><p>
                                            If there is a combination of Machine, Accessories, and Brochure, the international area will be calculated as per the respective rules mentioned in Points 2, 3, and 4.
                                        </p></li>
                                    </ol>
                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 text-center"
                                        type="submit"
                                        style={{
                                            width: "20%",
                                            // display: "block",
                                            background: "#007bff",
                                            padding: 4
                                        }}
                                        onClick={() => this.setState({ OpenMixExhibitorRule: false, isMixRuleAgree: true })}
                                    >
                                        {" "}
                                        {/* <a
                                                                   className="text-center btn-next text-white"
                                                                   style={{ color: 'white' }}
                                                               > */}
                                        OK
                                        {/* </a>{" "} */}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >
                <Modal isOpen={this.state.isDel1Open} onRequestClose={() => this.setState({ isDel1Open: false })}>
                    <div className="modal-dialog custom_modal_dialog" style={{ left: '0px', top: '300px', }}>
                        <div className="modal-content" style={{ marginLeft: '-200px' }}>
                            <div className="modal-header" style={{ padding: "7px 10px", }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    Confirm Delete
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={(e) => this.setState({ isDel1Open: false })}
                                />
                            </div>
                            <div className="modal-body" >
                                <div className="form-row mt-3">

                                    <div className="col-md-10">
                                        <p class="pop_label">Do you really want to delete this Document?</p>

                                    </div>
                                    <div class="modal-footer p-1">
                                        <div class="form-group text-right mod-fot">
                                            <button type="button" class="btn btn-del-pop"
                                                onClick={(e) => this.handleSSIDelete(e)}
                                            >Yes</button>
                                            <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isDel1Open: false })}>No</button>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >
                <Modal isOpen={this.state.isDel2Open} onRequestClose={() => this.setState({ isDel2Open: false })}>
                    <div className="modal-dialog custom_modal_dialog" style={{ left: '0px', top: '300px', }}>
                        <div className="modal-content" style={{ marginLeft: '-200px' }}>
                            <div className="modal-header" style={{ padding: "7px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    Confirm Delete
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    onClick={(e) => this.setState({ isDel2Open: false })}

                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px" }}>
                                <div className="form-row mt-3">

                                    <div className="col-md-10">
                                        <p class="pop_label">Do you really want to delete this Document?</p>

                                    </div>
                                    <div class="modal-footer p-1">
                                        <div class="form-group text-right mod-fot">
                                            <button type="button" class="btn btn-del-pop"
                                                onClick={(e) => this.handleTMMAITAMMADelete(e)}
                                            >Yes</button>
                                            <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isDel2Open: false })}>No</button>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.isDel3Open} onRequestClose={() => this.setState({ isDel3Open: false })}>
                    <div className="modal-dialog custom_modal_dialog" style={{ left: '0px', top: '300px', }}>
                        <div className="modal-content" style={{ marginLeft: '-200px' }}>
                            <div className="modal-header" style={{ padding: "7px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    Confirm Delete
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    onClick={(e) => this.setState({ isDel3Open: false })}

                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px" }}>
                                <div className="form-row mt-3">

                                    <div className="col-md-10">
                                        <p class="pop_label">Do you really want to delete this Document?</p>

                                    </div>
                                    <div class="modal-footer p-1">
                                        <div class="form-group text-right mod-fot">
                                            <button type="button" class="btn btn-del-pop"
                                                onClick={(e) => this.handleChapterDocDelete(e)}
                                            >Yes</button>
                                            <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isDel3Open: false })}>No</button>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={isOpen4} onRequestClose={(e) => this.setState({ isOpen4: false })}>
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    {/* <p style={{ textAlign: 'center', margin: '15px', fontSize: '20px' }} className="mb-2">
                                                                   Increase Stall Area
                                                               </p> */}
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        {`Based on the exhibit dimensions entered, the overall booth area should be greater than the recalculated space area. Therefore, the booth area has been revised to ${expectedArea} sq.m.`}
                                    </p>
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        Kindly confirm the revised area and proceed with the application.
                                    </p>
                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 text-center"
                                        type="submit"
                                        style={{
                                            width: "20%",
                                            // display: "block",
                                            background: "#007bff",
                                            padding: 4
                                        }}
                                        onClick={() => this.changetoExpArea()}
                                    >
                                        {" "}
                                        {/* <a
                                                                       className="text-center btn-next text-white"
                                                                       style={{ color: 'white' }}
                                                                   > */}
                                        OK
                                        {/* </a>{" "} */}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >
                <Modal isOpen={this.state.estimatePop} onRequestClose={() => this.setState({ estimatePop: false })}>
                    <div class="modal-dialog modal-xl modal-dialog-centered">
                        <div className="modal-content" style={{ marginTop: '6em', left: '-8em' }}>
                            <div className="modal-header" style={{ padding: "7px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    This will be the Revised estimates if you choose to Continue to update
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    onClick={(e) => this.setState({ estimatePop: false })}

                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px" }}>
                                <div className="table-responsive">
                                    {/* <p className="mb-2" style={{ float: "left", color: "#0072ff" }}>
                                                                                   As per Rule no. 7.1,7.2,7.8,7.9,and 7.10 the total rent payable
                                                                                   by us is as follows:
                                                                               </p>
                                                                               <p className="mb-2" style={{ float: "right", color: "#0072ff" }}>
                                                                                   Please refer Rule no. 7.1,7.2,7.8,7.9 and 7.10
                                                                               </p>
                                                                               <p /> */}
                                    <table className="table table-bordered">
                                        <tbody>
                                            {
                                                this.state.newestimateDetails.length > 0 ? this.state.newestimateDetails.map((data, index) => (
                                                    <tr key={Math.random()} >
                                                        <td style={{ width: '300px', whiteSpace: data.Description.includes('\n') ? 'pre-line' : '' }} ><strong>{data.Description}</strong></td>
                                                        <td style={{ textAlign: index != 0 ? 'right' : 'center' }} >{index == 0 ? <strong>{data.Installment1}</strong> : data.Installment1}</td>
                                                        <td style={{ textAlign: index != 0 ? 'right' : 'center' }} >{index == 0 ? <strong>{data.Installment2}</strong> : data.Installment2}</td>
                                                        <td style={{ textAlign: index != 0 ? 'right' : 'center' }} >{index == 0 ? <strong>{data.OpenSide}</strong> : data.OpenSide}</td>
                                                        <td style={{ width: '300px', textAlign: index != 0 ? 'right' : 'center' }} >{index == 0 ? <strong>{data.Total_amt}</strong> : data.Total_amt}</td>
                                                    </tr>
                                                )) :
                                                    <>
                                                        <tr className='text-center'><td colSpan={4} className='text-center'>Record not found</td></tr>
                                                    </>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    {/* {this.state.is1stPiCreated ? <button type="button" class="btn btn-del-pop"
                                                       onClick={(e => this.setState({
                                                           // isUpdatePerm: true
                                                       }, () => this.viewPI(1)))}
                                                   >View 1st PI</button> : <></>}
                                                   {this.state.is2ndPiCreated ? <button type="button" class="btn btn-del-pop" style={{ marginLeft: '5px' }}
                                                       onClick={(e => this.setState({
                                                           // isUpdatePerm: true
                                                       }, () => this.viewPI(0)))}
                                                   >View 2nd PI</button> : <></>} */}
                                    <button type="button" class="btn btn-aqua" style={{ marginLeft: '5px' }}
                                        onClick={(e => this.setState({
                                            isUpdatePerm: true
                                        }, () => this.editSpaceBooking()))}
                                    >Update</button>
                                    <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ estimatePop: false })}>cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={OpensameCountryManuErr} onRequestClose={(e) => this.setState({ OpensameCountryManuErr: false })}>
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                    <strong>Rules and Guidelines</strong>
                                </p><br></br>
                                {countryId == 91 ? <ul >
                                    <li>
                                        Any agent representing an Indian company have to submit individual application form for each company with minimum 18 sqm booth. Clubbing of multiple Indian companies within a single 18 sqm booth is not permitted
                                    </li>
                                    <li>
                                        For foreign participation, under Indian agent kindly refer to the rules of application & minimum area criteria.
                                    </li><br></br>
                                    <li><p>
                                        Kindly contact the ITME 2026 Exhibition Team for further clarification or assistance.
                                    </p></li>
                                </ul> : <ul >
                                    <li>
                                        Clubbing of multiple foreign companies within a single booth is not permitted. Please refer to the space booking application guidelines for detailed information on this rule
                                    </li><br></br>
                                    <li><p>
                                        Kindly contact the ITME 2026 Exhibition Team for further clarification or assistance.
                                    </p></li>
                                </ul>}
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 text-center"
                                        type="submit"
                                        style={{
                                            width: "20%",
                                            // display: "block",
                                            background: "#007bff",
                                            padding: 4
                                        }}
                                        onClick={() => this.setState({ OpensameCountryManuErr: false })}
                                    >
                                        {" "}
                                        {/* <a
                                                                          className="text-center btn-next text-white"
                                                                          style={{ color: 'white' }}
                                                                      > */}
                                        OK
                                        {/* </a>{" "} */}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >
                <Modal isOpen={this.state.toNewPop} >
                    <div
                        className="modal-dialog custom_modal_dialog modal-xxl"
                        style={{ left: '0px', top: '25%', maxWidth: '95%', width: '95%' }}
                    >
                        <div className="modal-content responsive-width w-auto">

                            <div className="modal-header py-2 bg-danger">
                                <h4 className="mb-0 py-1 text-center text-white fw-semibold w-100">
                                    Important Note
                                </h4>
                            </div>

                            <div className="modal-body">
                                <div className="row">
                                    <h5 className="text-center fw-normal">
                                        Indian companies showcasing foreign-manufactured machines or accessories must complete a separate International Space Booking form using the link below:
                                        <br />
                                        <span className="d-block mt-2 fw-normal">[
                                            <a
                                                className="text-primary mt-2"
                                                style={{ cursor: 'pointer' }}
                                                onClick={this.fillInternationalForm}
                                            >
                                                Click here
                                            </a>  to fill out the International Form]
                                        </span>
                                    </h5>
                                </div>
                            </div>

                            <div className="modal-footer p-1">
                                <div className="form-group text-right mod-fot mx-3">
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger"
                                        data-dismiss="modal"
                                        onClick={() => this.setState({ toNewPop: false })}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* </div> */}
                </Modal>
                <Modal isOpen={this.state.slabpop} >
                    <div className="modal-dialog modal-xl" style={{ width: 'fit-content', top: '15%' }}>
                        <div className="modal-content responsive-width w-auto" style={{ marginTop: '70px' }}>
                            <div className="modal-header" style={{ padding: "16px 20px", fontSize: 'medium', backgroundColor: 'white' }}>
                                <div className="mb-0 pt-2 text-center fw-bold w-100">
                                    Below listed foreign area Slab applies only to companies that are showcasing foreign companies’ brochures under the booth of an Indian Company or an Indian Agent Company.
                                </div>
                                {/* <strong> */}
                                {/* </strong> */}
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    onClick={(e) => this.setState({ slabpop: false, intAreaRulesPop: true })}
                                    // style={{ scale: '' }}
                                    aria-label="Close"
                                >
                                    {/* <i class="fa fa-circle-xmark"></i> */}
                                </button>
                            </div>

                            <div className="modal-body pt-0 p-3" style={{ padding: "0px 12px 9px 12px" }}>
                                <div className="form-row mt-2" style={{ height: 'calc(100vh - 288px)', overflow: 'auto' }}>
                                    <table
                                        className="table table-bordered"
                                        style={{
                                            border: "1px solid #d8d8d8 !important",
                                            marginRight: '50px',
                                            marginLeft: '50px',
                                        }}
                                    >
                                        <thead>
                                            <tr>
                                                <th className='text-center'>Area Slab(SQM)</th>
                                                <th className='text-center'>USD Tariff to charge</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {internationalAreaSlabList.length > 0 && internationalAreaSlabList.map((item, i) => (
                                                <tr>
                                                    <td className='text-center'>{i == internationalAreaSlabList.length - 1 ? `${item.FromRange} sqm and above` : `${item.FromRange} sqm to ${item.ToRange} sqm`}</td>
                                                    <td className='text-center'>{item.MinArea} sqm</td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>


                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={(e) => this.setState({ slabpop: false, intAreaRulesPop: true })}
                                    >OK</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </Modal>
                <Modal isOpen={this.state.minAreaPop1} >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        Exhibitors with  9 sqm booth are not permitted to display products from any other company.
                                        <br />

                                    </p>

                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 text-center text-white"
                                        type="submit"
                                        style={{
                                            width: "20%",
                                            // display: "block",
                                            background: "#4ec7be",
                                            padding: 4
                                        }}
                                        onClick={() => {
                                            subChapters.map(item => {
                                                if (item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '') {
                                                    item.ManufacturingCountry = ''
                                                }
                                            })
                                            this.setState({ subChapters: subChapters, minAreaPop1: false })
                                        }}
                                    >
                                        {" "}
                                        {/* <a
                                                                                                         className="text-center btn-next text-white"
                                                                                                         style={{ color: 'white' }}
                                                                                                     > */}
                                        OK
                                        {/* </a>{" "} */}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* </div> */}
                </Modal>
                <Modal isOpen={this.state.minAreaPop2} >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        Since you will be displaying another company's products within your booth, the minimum booth area requirement will increase to 27 sqm.
                                        <br />

                                    </p>

                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <button
                                        className="btn mb-1 text-center"
                                        type="submit"
                                        style={{
                                            width: "20%",
                                            // display: "block",
                                            background: "#007bff",
                                            padding: 4
                                        }}
                                        onClick={() => {

                                            if (internationalAreaSlabList.length > 0) {
                                                for (var i = 0; i < stallAreaList.length; i++) {
                                                    if (stallAreaList[i].StallArea == internationalAreaSlabList[0].FromRange) {
                                                        console.log(stallAreaList[i], internationalAreaSlabList, 'internationalAreaSlabList')
                                                        this.setState({
                                                            expectedArea: stallAreaList[i].StallArea, expectedAreaId: stallAreaList[i].Code
                                                        }, () => {
                                                            this.changetoExpArea().then(() => {
                                                                this.adjustCalculatedArea(this.state.expectedArea)
                                                            })
                                                        })
                                                    }
                                                }
                                            }
                                            this.setState({
                                                minAreaPop2: false
                                            })
                                        }}
                                    >
                                        {" "}
                                        {/* <a
                                                                                                         className="text-center btn-next text-white"
                                                                                                         style={{ color: 'white' }}
                                                                                                     > */}
                                        OK
                                        {/* </a>{" "} */}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* </div> */}
                </Modal>
                <Modal isOpen={this.state.prefferedPop} >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-body p-2">
                                    <p style={{ textAlign: 'left', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        Based on the exhibit details provided (brochures only), the booth type has been changed from Shell to Bare Space.
                                        {/* <br /> */}
                                    </p>

                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        Would you like to
                                    </p>
                                </div>
                                <div className="modal-footer pb-1 justify-content-center">
                                    <br></br>
                                    <button
                                        type="button"
                                        className="btn btn-aqua"
                                        style={{
                                            // width: "20%",
                                            // display: "block",
                                            background: "#4ec7be",
                                            // padding: 4
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                prefferedPop: false, prefferedType: 1, prefferedPopAsk: true
                                            }, () => {
                                                this.adjustCalculatedArea(area)
                                            })
                                        }}
                                    >
                                        Keep Bare Space and build the booth yourself
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-aqua"
                                        style={{
                                            // width: "20%",
                                            // display: "block",
                                            background: "#4ec7be",
                                            // padding: 4
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                prefferedPop: false, prefferedType: 2, prefferedPopAsk: true
                                            }, () => {
                                                this.onSchemeTypeChange(null, 2, 1)
                                            })
                                        }}
                                    >
                                        Continue with a Shell booth
                                    </button>
                                    <p style={{ textAlign: 'center', margin: '15px', fontSize: '18px' }} className="mb-2">
                                        <strong> Note:</strong>  Space charges will be applied at the standard Shell rate in either case
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* </div> */}
                </Modal>
                <Modal isOpen={intAreaRulesPop} onRequestClose={e => this.setState({ intAreaRulesPop: !intAreaRulesPop })} onAfterOpen={() => this.PdfRender2()}>
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-header" style={{ padding: "10px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    <b>International Area Calculation Rules</b>
                                </h5>
                                <button style={{ fontSize: '16px' }}
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={e => this.setState({ intAreaRulesPop: !intAreaRulesPop })}
                                />
                            </div>

                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px", height: 'calc(90vh - 200px)', overflow: 'auto', overflowY: 'hidden' }}>
                                {/* <iframe
                                                                                                    id="myIframe" style={{ marginTop: '0px' }}
                                                                                                    src={`${DOC_BASE_URL + RandRpath}#toolbar=0&navpanes=0`}
                                                                                                    width="100%"
                                                                                                    height="100%"
                                                                                                    title="Bing"
                                                                                                /> */}
                                <div
                                    id="pdf-container"
                                    ref={this.pdfContainerRef2}
                                    style={{
                                        width: "100%",
                                        height: "100%",       // keeps it scrollable inside card
                                        overflowY: "auto",    // ✅ allow auto scrollbar (not forced scroll)
                                        WebkitOverflowScrolling: "touch", // ✅ smooth scroll (mobile too)
                                        background: '#f5f5f5'
                                    }}
                                ></div>
                            </div>
                            <div className="form-row m-3 mt-2 mb-0 border-bottom">

                                <div className="col-md-10">
                                    <p> <div className="text-primary" style={{ cursor: 'pointer', display: 'contents' }} onClick={(e) => this.setState({ slabpop: true, intAreaRulesPop: false })}
                                    >Click here</div> to view Brochure slab.</p>
                                </div>
                                <div className="col-md-2">
                                    <button
                                        type="button"
                                        className="btn btn-gray"
                                        data-bs-dismiss="modal"
                                        style={{ padding: '4px 15px', float: 'right' }}
                                        onClick={e => this.setState({ intAreaRulesPop: false, isMixRuleAgree: true })}
                                    >
                                        Ok
                                    </button>
                                </div>


                            </div>
                            {/* <div className="modal-footer" style={{ padding: 3 }}>
                                                                
                                                                                            </div> */}
                        </div>
                    </div>

                </Modal >
                <style>
                    {`
   .accordion-header-exhdetail .accordion-button::after {
  top: 20px;
}
  
  .accordion-header-exhdetail .accordion-button {
  background-color: transparent !important;
   box-shadow: none !important;
}
    `}
                </style>
            </>
        )
    }
}

export default withRouter(connect(null, { getDetails_exhibitorSpaceBooking_action, edit_exhibitorSpaceBoking_action, fill_action, primaryChapterAdd_action, deleteChapterDoc_action, getPreviewDetails_action, getDoubleStoreySSI_action, deleteSSicertificate_action, deleteTMMAITAMMA_action, updateExhibitorSpacebookingEstimate_action })(ExhibitorsSpacebooking));